export default {
  "审批同意成功": "审批同意成功",
  "请填写拒绝原因": "请填写拒绝原因",
  "审批拒绝成功": "审批拒绝成功",
  "审批拒绝失败": "审批拒绝失败",
  "审批拒绝失败:": "审批拒绝失败:",
  "审批撤销成功": "审批撤销成功",
  "审批撤销失败": "审批撤销失败",
  "审批撤销失败:": "审批撤销失败:",
  "重新发起操作": "重新发起操作",
  "审批单链接已复制到剪贴板": "审批单链接已复制到剪贴板",
  "复制链接失败": "复制链接失败",
  "复制链接失败:": "复制链接失败:",
  "请选择新的审批人": "请选择新的审批人",
  "审批人更新成功": "审批人更新成功",
  "审批单详情": "审批单详情",
  "审批人无法审批？要变更审批人？可联系审批管理员": "审批人无法审批？要变更审批人？可联系审批管理员",
  "修改审批人": "修改审批人",
  "项目详情链接：": "项目详情链接：",
  "查看项目详情": "查看项目详情",
  "复制链接": "复制链接",
  "链接已复制到剪贴板": "链接已复制到剪贴板",
  "浏览器不支持复制功能": "浏览器不支持复制功能",
  "审批单号": "审批单号",
  "审批标题": "审批标题",
  "审批进度": "审批进度",
  "审批类型": "审批类型",
  "发起原因": "发起原因",
  "发起时间": "发起时间",
  "拒绝": "拒绝",
  "更多": "更多",
  "请输入审批单号/审批标题": "请输入审批单号/审批标题",
  "发起时间:": "发起时间:",
  "查询类型:": "查询类型:",
  "我发起的": "我发起的",
  "我审批的": "我审批的",
  "审批类型:": "审批类型:",
  "请选择审批类型": "请选择审批类型",
  "审批进度:": "审批进度:",
  "请选择审批进度": "请选择审批进度",
  "拒绝审批": "拒绝审批",
  "确认拒绝": "确认拒绝",
  "请填写拒绝原因：": "请填写拒绝原因：",
  "请输入拒绝原因...": "请输入拒绝原因...",
  "已选择": "已选择",
  "点击进入": "点击进入",
  "暂无可用审批类型": "暂无可用审批类型",
  "审批统计": "审批统计",
  "我的审批单": "我的审批单",
  "撤销": "撤销",
  "同意": "同意",
  "审批流程": "审批流程",
  "流程发起": "流程发起",
  "发起人：": "发起人：",
  "时间：": "时间：",
  "审批节点": "审批节点",
  "分组审批：每个小组都需通过，每个小组审批通过规则为": "分组审批：每个小组都需通过，每个小组审批通过规则为",
  "小组": "小组",
  "该分组暂无审批人信息": "该分组暂无审批人信息",
  "暂无审批人信息": "暂无审批人信息",
  "暂无审批流程信息": "暂无审批流程信息",
  "审批流程已完成": "审批流程已完成",
  "编辑审批人": "编辑审批人",
  "需上一节点审批通过后开放...": "需上一节点审批通过后开放...",
  "等待审批中...": "等待审批中...",
  "不需要审批了": "不需要审批了",
  "当前状态": "当前状态",
  "涉及系统": "涉及系统",
  "其他信息": "其他信息",
  "获取事件详情失败:": "获取事件详情失败:",
  "获取事件详情失败": "获取事件详情失败",
  "Goc事件明细": "Goc事件明细",
  "确认撤销": "确认撤销",
  "您确定要撤销此审批单吗？撤销后将无法恢复。": "您确定要撤销此审批单吗？撤销后将无法恢复。",
  "将": "将",
  "替换为：": "替换为：",
  "分支名称": "分支名称",
  "我的审批": "我的审批",
  "所有审批": "所有审批",
  "ECS筛选": "ECS筛选",
  "实例名称": "实例名称",
  "请输入实例名称": "请输入实例名称",
  "实例状态": "实例状态",
  "请选择实例状态": "请选择实例状态",
  "CPU核数": "CPU核数",
  "请输入CPU核数": "请输入CPU核数",
  "内存大小(GB)": "内存大小(GB)",
  "请输入内存大小(GB)": "请输入内存大小(GB)",
  "操作系统类型": "操作系统类型",
  "请选择操作系统类型": "请选择操作系统类型",
  "网络类型": "网络类型",
  "请选择网络类型": "请选择网络类型",
  "网络计费类型": "网络计费类型",
  "请选择网络计费类型": "请选择网络计费类型",
  "实例计费类型": "实例计费类型",
  "请选择实例计费类型": "请选择实例计费类型",
  "实例是否不可用": "实例是否不可用",
  "不可用": "不可用",
  "运行中": "运行中",
  "已停止": "已停止",
  "启动中": "启动中",
  "停止中": "停止中",
  "等待中": "等待中",
  "经典网络": "经典网络",
  "专有网络": "专有网络",
  "按固定带宽": "按固定带宽",
  "按使用流量": "按使用流量",
  "包年包月": "包年包月",
  "按量付费": "按量付费",
  "抢占式实例": "抢占式实例",
  "实例ID": "实例ID",
  "可用区": "可用区",
  "实例规格": "实例规格",
  "规格族": "规格族",
  "CPU/内存": "CPU/内存",
  "系统类型": "系统类型",
  "镜像ID": "镜像ID",
  "主机名": "主机名",
  "交换机ID": "交换机ID",
  "私网IP": "私网IP",
  "公网IP": "公网IP",
  "弹性公网IP": "弹性公网IP",
  "安全组": "安全组",
  "搜索关键词": "搜索关键词",
  "请输入搜索关键词": "请输入搜索关键词",
  "监控项单位": "监控项单位",
  "请输入单位，多个用逗号分隔或直接选择": "请输入单位，多个用逗号分隔或直接选择",
  "命名空间": "命名空间",
  "监控项描述": "监控项描述",
  "统计周期": "统计周期",
  "维度": "维度",
  "单位": "单位",
  "统计方法": "统计方法",
  "PolarDB筛选": "PolarDB筛选",
  "数据库类型": "数据库类型",
  "请选择数据库类型": "请选择数据库类型",
  "数据库版本": "数据库版本",
  "请输入数据库版本，多个用逗号分隔": "请输入数据库版本，多个用逗号分隔",
  "存储付费类型": "存储付费类型",
  "请选择存储付费类型": "请选择存储付费类型",
  "付费类型": "付费类型",
  "请选择付费类型": "请选择付费类型",
  "集群状态": "集群状态",
  "请选择集群状态": "请选择集群状态",
  "集群系列": "集群系列",
  "请选择集群系列": "请选择集群系列",
  "存储类型": "存储类型",
  "请选择存储类型": "请选择存储类型",
  "强一致性": "强一致性",
  "请选择强一致性": "请选择强一致性",
  "删除保护": "删除保护",
  "锁定": "锁定",
  "是否过期": "是否过期",
  "锁定模式": "锁定模式",
  "请选择锁定模式": "请选择锁定模式",
  "热备集群": "热备集群",
  "请选择热备集群": "请选择热备集群",
  "创建中": "创建中",
  "删除中": "删除中",
  "重启中": "重启中",
  "变配中": "变配中",
  "标准版": "标准版",
  "高性能": "高性能",
  "未锁定": "未锁定",
  "手动锁定": "手动锁定",
  "因过期而锁定": "因过期而锁定",
  "因恢复而锁定": "因恢复而锁定",
  "因磁盘配额超限而锁定": "因磁盘配额超限而锁定",
  "SE标准版": "SE标准版",
  "开启": "开启",
  "集群描述": "集群描述",
  "数据库引擎": "数据库引擎",
  "集群类型": "集群类型",
  "节点规格": "节点规格",
  "节点数量": "节点数量",
  "存储空间(GB)": "存储空间(GB)",
  "已用存储(GB)": "已用存储(GB)",
  "计费类型": "计费类型",
  "存储计费类型": "存储计费类型",
  "子系列": "子系列",
  "数据库节点": "数据库节点",
  "资源组ID": "资源组ID",
  "集群创建时间": "集群创建时间",
  "集群过期时间": "集群过期时间",
  "云产品描述": "云产品描述",
  "RDS筛选": "RDS筛选",
  "实例描述": "实例描述",
  "请输入实例描述": "请输入实例描述",
  "请选择数据库引擎": "请选择数据库引擎",
  "实例类型": "实例类型",
  "请选择实例类型": "请选择实例类型",
  "请选择计费类型": "请选择计费类型",
  "迁移中": "迁移中",
  "升级中": "升级中",
  "创建只读实例中": "创建只读实例中",
  "恢复中": "恢复中",
  "导入中": "导入中",
  "从其他实例导入中": "从其他实例导入中",
  "网络类型变更中": "网络类型变更中",
  "容灾切换中": "容灾切换中",
  "克隆中": "克隆中",
  "克隆只读实例中": "克隆只读实例中",
  "内核版本升级中": "内核版本升级中",
  "创建临时实例中": "创建临时实例中",
  "SSL配置修改中": "SSL配置修改中",
  "SSL启用中": "SSL启用中",
  "SSL禁用中": "SSL禁用中",
  "已删除": "已删除",
  "内存(GB)": "内存(GB)",
  "网络连接类型": "网络连接类型",
  "连接地址": "连接地址",
  "连接模式": "连接模式",
  "VPC云实例ID": "VPC云实例ID",
  "锁定原因": "锁定原因",
  "只读实例ID": "只读实例ID",
  "实例创建时间": "实例创建时间",
  "实例过期时间": "实例过期时间",
  "提示级别": "提示级别",
  "地域ID": "地域ID",
  "地域名称": "地域名称",
  "地域端点": "地域端点",
  "添加网关域名": "添加网关域名",
  "域名": "域名",
  "请输入域名": "请输入域名",
  "网关": "网关",
  "请选择网关": "请选择网关",
  "协议": "协议",
  "请选择协议": "请选择协议",
  "证书": "证书",
  "请选择证书": "请选择证书",
  "证书名称": "证书名称",
  "证书ID": "证书ID",
  "绑定域名": "绑定域名",
  "过期时间": "过期时间",
  "主机记录": "主机记录",
  "指域名前缀，例如：www": "指域名前缀，例如：www",
  "记录类型": "记录类型",
  "指解析记录的用途，例如：网站、邮箱": "指解析记录的用途，例如：网站、邮箱",
  "解析请求来源(isp)": "解析请求来源(isp)",
  "指解析请求的来源，例如：电信、联通": "指解析请求的来源，例如：电信、联通",
  "记录值": "记录值",
  "一般是填写服务器的IP地址": "一般是填写服务器的IP地址",
  "指解析结果在Local DNS中的缓存时间": "指解析结果在Local DNS中的缓存时间",
  "解析记录在云解析DNS中的启用情况": "解析记录在云解析DNS中的启用情况",
  "启用": "启用",
  "暂停": "暂停",
  "已绑定网关": "已绑定网关",
  "最近同步时间": "最近同步时间",
  "请输入主机记录": "请输入主机记录",
  "请输入记录值": "请输入记录值",
  "所有状态": "所有状态",
  "常用域名": "常用域名",
  "未标为常用域名": "未标为常用域名",
  "记录数": "记录数",
  "DNS服务器地址": "DNS服务器地址",
  "付费版本": "付费版本",
  "免费版": "免费版",
  "企业标准版": "企业标准版",
  "企业旗舰版": "企业旗舰版",
  "请选择行业线": "请选择行业线",
  "未设置开始结束时间": "未设置开始结束时间",
  "实际工作时间": "实际工作时间",
  "近30天": "近30天",
  "近三月": "近三月",
  "开始结束时间": "开始结束时间",
  "任务类型": "任务类型",
  "请到开始结束时间处设置预估人天（左侧蓝色分级线可拖动）": "请到开始结束时间处设置预估人天（左侧蓝色分级线可拖动）",
  "需求甘特图": "需求甘特图",
  "任务列表": "任务列表",
  "任务甘特图": "任务甘特图",
  "需求信息": "需求信息",
  "任务状态": "任务状态",
  "未知用户": "未知用户",
  "的": "的",
  "甘特图视图": "甘特图视图",
  "一键收起": "一键收起",
  "一键展开": "一键展开",
  "任务状态筛选：": "任务状态筛选：",
  "请选择任务状态": "请选择任务状态",
  "任务时间筛选：": "任务时间筛选：",
  "新建目录": "新建目录",
  "编辑目录": "编辑目录",
  "目录名称": "目录名称",
  "请输入目录名称": "请输入目录名称",
  "请至少选择一个组织、系统或其他人员": "请至少选择一个组织、系统或其他人员",
  "组织": "组织",
  "添加该组织下的所有人员,支持多选": "添加该组织下的所有人员,支持多选",
  "请选择组织": "请选择组织",
  "组织人员": "组织人员",
  "已添加组织人员": "已添加组织人员",
  "添加该系统下的所有人员,支持多选": "添加该系统下的所有人员,支持多选",
  "系统人员": "系统人员",
  "已添加系统人员": "已添加系统人员",
  "其他人员": "其他人员",
  "请选择其他人员": "请选择其他人员",
  "支持多选": "支持多选",
  "创建面板": "创建面板",
  "查看目录详情": "查看目录详情",
  "删除目录": "删除目录",
  "创建目录": "创建目录",
  "人员名称": "人员名称",
  "部门": "部门",
  "任务预估工时": "任务预估工时",
  "任务实际工时": "任务实际工时",
  "缺陷工时": "缺陷工时",
  "线上问题工时": "线上问题工时",
  "考勤工时": "考勤工时",
  "加班工时": "加班工时",
  "缺陷时效": "缺陷时效",
  "研发为缺陷解决时效相加（解决时效=解决时间-创建时间）": "研发为缺陷解决时效相加（解决时效=解决时间-创建时间）",
  "测试为缺陷关闭时效相加（关闭时效=关闭时间-解决时间）": "测试为缺陷关闭时效相加（关闭时效=关闭时间-解决时间）",
  "线上问题时效": "线上问题时效",
  "研发为线上问题解决时效相加（解决时效=解决时间-创建时间）": "研发为线上问题解决时效相加（解决时效=解决时间-创建时间）",
  "测试为线上问题关闭时效相加（关闭时效=关闭时间-解决时间）": "测试为线上问题关闭时效相加（关闭时效=关闭时间-解决时间）",
  "缺陷平均时效": "缺陷平均时效",
  "缺陷平均时效 = 缺陷时效 / 缺陷数量": "缺陷平均时效 = 缺陷时效 / 缺陷数量",
  "线上问题平均时效": "线上问题平均时效",
  "线上问题平均时效 = 线上问题时效 / 线上问题数量": "线上问题平均时效 = 线上问题时效 / 线上问题数量",
  "缺陷工时占比": "缺陷工时占比",
  "缺陷工时占比 = 缺陷实际工时 / 考勤工时": "缺陷工时占比 = 缺陷实际工时 / 考勤工时",
  "线上问题工时占比": "线上问题工时占比",
  "线上问题工时占比 = 线上问题工时 / 考勤工时": "线上问题工时占比 = 线上问题工时 / 考勤工时",
  "缺陷重开次数": "缺陷重开次数",
  "缺陷重开率": "缺陷重开率",
  "缺陷重开率 = 缺陷重开次数 / 缺陷数量": "缺陷重开率 = 缺陷重开次数 / 缺陷数量",
  "缺陷（平均值）": "缺陷（平均值）",
  "线上问题（平均值）": "线上问题（平均值）",
  "平均产品评审驳回率": "平均产品评审驳回率",
  "平均代码提交规范率": "平均代码提交规范率",
  "平均紧急发布率": "平均紧急发布率",
  "代码与发布质量监测": "代码与发布质量监测",
  "研发缺陷与线上缺陷综合指标": "研发缺陷与线上缺陷综合指标",
  "产品需求各阶段平均耗时": "产品需求各阶段平均耗时",
  "人员数据详情": "人员数据详情",
  "姓名": "姓名",
  "员工编码": "员工编码",
  "等待阶段平均时间": "等待阶段平均时间",
  "产品方案平均时间": "产品方案平均时间",
  "研发平均开发时间": "研发平均开发时间",
  "测试平均等待时间": "测试平均等待时间",
  "缺陷平均解决耗时": "缺陷平均解决耗时",
  "缺陷平均关闭时长": "缺陷平均关闭时长",
  "缺陷平均重开率": "缺陷平均重开率",
  "线上问题需求设计缺陷率": "线上问题需求设计缺陷率",
  "线上问题平均解决耗时": "线上问题平均解决耗时",
  "线上问题平均关闭时长": "线上问题平均关闭时长",
  "线上问题平均重开率": "线上问题平均重开率",
  "任务实际工时需满足以下条件：": "任务实际工时需满足以下条件：",
  "工时开始时间大于等于任务开始时间。": "工时开始时间大于等于任务开始时间。",
  "工时结束时间小于等于任务结束时间。": "工时结束时间小于等于任务结束时间。",
  "缺陷实际工时": "缺陷实际工时",
  "缺陷实际工时需满足以下条件：": "缺陷实际工时需满足以下条件：",
  "工时开始时间大于等于缺陷创建时间。": "工时开始时间大于等于缺陷创建时间。",
  "工时结束时间小于等于缺陷解决时间。": "工时结束时间小于等于缺陷解决时间。",
  "线上问题实际工时": "线上问题实际工时",
  "线上问题实际工时需满足以下条件：": "线上问题实际工时需满足以下条件：",
  "工时开始时间大于等于线上问题创建时间。": "工时开始时间大于等于线上问题创建时间。",
  "工时结束时间小于等于线上问题解决时间。": "工时结束时间小于等于线上问题解决时间。",
  "偏离值": "偏离值",
  "实际工时 = 任务实际工时 + 缺陷实际工时 + 线上问题实际工时": "实际工时 = 任务实际工时 + 缺陷实际工时 + 线上问题实际工时",
  "偏离值=考勤工时 − 实际工时": "偏离值=考勤工时 − 实际工时",
  "如果偏离值为正，表示考勤工时超过了任务工时，可能意味着员工加班或工作效率低下。 如果偏离值为负，表示考勤工时低于任务工时，可能意味着员工未能完成预定的工作量。": "如果偏离值为正，表示考勤工时超过了任务工时，可能意味着员工加班或工作效率低下。 如果偏离值为负，表示考勤工时低于任务工时，可能意味着员工未能完成预定的工作量。",
  "偏差百分比": "偏差百分比",
  "偏离率的计算公式通常为：偏离率=(考勤工时−实际工时)/实际工时*100%": "偏离率的计算公式通常为：偏离率=(考勤工时−实际工时)/实际工时*100%",
  "正偏离率：表示考勤工时高于实际工时，可能意味着员工在工作中投入了更多时间，或者任务预估时间不足。": "正偏离率：表示考勤工时高于实际工时，可能意味着员工在工作中投入了更多时间，或者任务预估时间不足。",
  "负偏离率：表示考勤工时低于实际工时，可能意味着员工未能完成预定的工作量，或者考勤记录存在问题。": "负偏离率：表示考勤工时低于实际工时，可能意味着员工未能完成预定的工作量，或者考勤记录存在问题。",
  "查看全员甘特图": "查看全员甘特图",
  "单位：": "单位：",
  "名称和链接已复制到剪贴板": "名称和链接已复制到剪贴板",
  "点击这里展开左侧菜单": "点击这里展开左侧菜单",
  "请选择左侧菜单项进行操作": "请选择左侧菜单项进行操作",
  "点击这里展开左侧菜单以查看更多选项": "点击这里展开左侧菜单以查看更多选项",
  "任务责任人看板": "任务责任人看板",
  "任务状态占比": "任务状态占比",
  "预估工时（单位: 天）": "预估工时（单位: 天）",
  "各时间段内个人任务的预估工时总和，数据为0表示存在任务尚未排期": "各时间段内个人任务的预估工时总和，数据为0表示存在任务尚未排期",
  "研发任务与考勤数据对比": "研发任务与考勤数据对比",
  "工时、缺陷、任务数据": "工时、缺陷、任务数据",
  "查看教程": "查看教程",
  "新建值班表": "新建值班表",
  "编辑值班表": "编辑值班表",
  "值班表名称": "值班表名称",
  "请输入值班表名称": "请输入值班表名称",
  "值班时间段": "值班时间段",
  "请选择值班时间段": "请选择值班时间段",
  "不参与组长轮转的业务领域": "不参与组长轮转的业务领域",
  "可选，默认全部参与": "可选，默认全部参与",
  "只影响值班组长候选人，不影响业务领域自身的值班安排": "只影响值班组长候选人，不影响业务领域自身的值班安排",
  "创建值班表": "创建值班表",
  "配置日常值班表模板": "配置日常值班表模板",
  "领域负责人": "领域负责人",
  "值班日期": "值班日期",
  "值班组长": "值班组长",
  "日常值班表模版": "日常值班表模版",
  "已选人员固定值班；业务岗位按关联部门成员轮转，组长按未排除的值班业务领域负责人轮转": "已选人员固定值班；业务岗位按关联部门成员轮转，组长按未排除的值班业务领域负责人轮转",
  "按启用的业务领域重置模板岗位": "按启用的业务领域重置模板岗位",
  "确认重置模板岗位？": "确认重置模板岗位？",
  "确认重置": "确认重置",
  "模板岗位已重置": "模板岗位已重置",
  "重置模板岗位": "重置模板岗位",
  "假": "假",
  "班": "班",
  "按最新模板重新排班": "按最新模板重新排班",
  "请先完成值班模板调整": "请先完成值班模板调整",
  "业务岗位只重排所选业务领域；值班组长按整张值班表的负责人候选范围独立重排。生效日期之前的排班不会修改。": "业务岗位只重排所选业务领域；值班组长按整张值班表的负责人候选范围独立重排。生效日期之前的排班不会修改。",
  "生效日期": "生效日期",
  "请选择生效日期": "请选择生效日期",
  "重排内容": "重排内容",
  "请至少选择一项重排内容": "请至少选择一项重排内容",
  "重排业务岗位": "重排业务岗位",
  "重排值班组长": "重排值班组长",
  "需重排的业务领域": "需重排的业务领域",
  "请选择本次需要重排的业务领域": "请选择本次需要重排的业务领域",
  "今天": "今天",
  "可联系方式": "可联系方式",
  "值班表名称和链接已复制到剪贴板": "值班表名称和链接已复制到剪贴板",
  "从生效日期起，可选择重排业务岗位、值班组长或两者同时重排": "从生效日期起，可选择重排业务岗位、值班组长或两者同时重排",
  "重新排值班表": "重新排值班表",
  "自动排班": "自动排班",
  "只补全空缺岗位，不覆盖已手工填写的人员": "只补全空缺岗位，不覆盖已手工填写的人员",
  "按关联部门自动填充": "按关联部门自动填充",
  "业务需求明细": "业务需求明细",
  "请至少选择一种专业线": "请至少选择一种专业线",
  "请输入仪表盘名称": "请输入仪表盘名称",
  "仪表盘名称不能超过100个字符": "仪表盘名称不能超过100个字符",
  "专业线类型": "专业线类型",
  "自定义专业线": "自定义专业线",
  "请选择自定义专业线": "请选择自定义专业线",
  "配置专业线": "配置专业线",
  "可查看人员": "可查看人员",
  "描述不能超过500个字符": "描述不能超过500个字符",
  "新建专业线": "新建专业线",
  "编辑专业线": "编辑专业线",
  "查看专业线": "查看专业线",
  "专业线名称": "专业线名称",
  "请输入专业线名称": "请输入专业线名称",
  "专业线名称不能超过100个字符": "专业线名称不能超过100个字符",
  "请选择成员": "请选择成员",
  "删除确认": "删除确认",
  "暂停至": "暂停至",
  "产品需求明细": "产品需求明细",
  "管理自定义专业线": "管理自定义专业线",
  "折叠全部": "折叠全部",
  "展开全部": "展开全部",
  "退出全屏": "退出全屏",
  "图表全屏": "图表全屏",
  "整体交付周数统计（产品需求维度）": "整体交付周数统计（产品需求维度）",
  "选择专业线": "选择专业线",
  "选择产品经理": "选择产品经理",
  "年度交付周数（整体）": "年度交付周数（整体）",
  "专业线交付周数统计（产品需求维度）": "专业线交付周数统计（产品需求维度）",
  "整体交付周数统计（业务需求维度）": "整体交付周数统计（业务需求维度）",
  "专业线交付周数统计（业务需求维度）": "专业线交付周数统计（业务需求维度）",
  "近两周需求进展环比": "近两周需求进展环比",
  "超期需求": "超期需求",
  "超2周": "超2周",
  "超3周": "超3周",
  "超1个月": "超1个月",
  "超期未介入产品需求": "超期未介入产品需求",
  "超期未介入业务需求": "超期未介入业务需求",
  "超期方案未完成产品需求": "超期方案未完成产品需求",
  "评审完成超期未排期产品需求": "评审完成超期未排期产品需求",
  "周新增/上线需求（数量）": "周新增/上线需求（数量）",
  "完成方案/评审-上线（周需时）": "完成方案/评审-上线（周需时）",
  "专业线需求数量": "专业线需求数量",
  "您还没有仪表盘哦，请先点击下方按钮创建一个仪表盘吧": "您还没有仪表盘哦，请先点击下方按钮创建一个仪表盘吧",
  "只能上传图片文件": "只能上传图片文件",
  "图片大小不能超过 5MB": "图片大小不能超过 5MB",
  "图片上传成功": "图片上传成功",
  "上传失败:": "上传失败:",
  "卡片信息缺失，无法赠送": "卡片信息缺失，无法赠送",
  "请选择接收人": "请选择接收人",
  "赠送成功": "赠送成功",
  "请选择卡片进行预览": "请选择卡片进行预览",
  "确认赠送": "确认赠送",
  "接收人": "接收人",
  "请选择需要赠送的同事": "请选择需要赠送的同事",
  "赠送说明": "赠送说明",
  "请输入赠送说明": "请输入赠送说明",
  "选择装饰": "选择装饰",
  "自定义": "自定义",
  "实时预览": "实时预览",
  "送你": "送你",
  "选择点赞卡组：": "选择点赞卡组：",
  "请选择组": "请选择组",
  "研发过程缺陷质量指标": "研发过程缺陷质量指标",
  "研发过程缺陷解决时效": "研发过程缺陷解决时效",
  "质量度量指标": "质量度量指标",
  "子项目质量度量指标对比": "子项目质量度量指标对比",
  "缺陷逃逸率=线上Bug数/（线上Bug数+研发过程Bug数）×100%": "缺陷逃逸率=线上Bug数/（线上Bug数+研发过程Bug数）×100%",
  "缺陷漏检率=线上Bug数/研发过程Bug数×100%": "缺陷漏检率=线上Bug数/研发过程Bug数×100%",
  "缺陷平均解决耗时=∑（解决时间-创建时间）/n。": "缺陷平均解决耗时=∑（解决时间-创建时间）/n。",
  "缺陷平均关闭耗时": "缺陷平均关闭耗时",
  "缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。": "缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。",
  "缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%": "缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%",
  "需求设计缺陷率=需求设计缺陷数/缺陷总数×100%": "需求设计缺陷率=需求设计缺陷数/缺陷总数×100%",
  "研发过程缺陷质量指标（子项目）": "研发过程缺陷质量指标（子项目）",
  "研发过程缺陷解决时效（子项目）": "研发过程缺陷解决时效（子项目）",
  "测试阶段平均时间": "测试阶段平均时间",
  "验收阶段平均时间": "验收阶段平均时间",
  "需求平均前置时间": "需求平均前置时间",
  "产品需求各阶段平均耗时横向对比": "产品需求各阶段平均耗时横向对比",
  "等待阶段": "等待阶段",
  "产品方案": "产品方案",
  "研发阶段": "研发阶段",
  "测试阶段": "测试阶段",
  "验收阶段": "验收阶段",
  "需求前置时间": "需求前置时间",
  "从需求提出，到完成开发、测试、上线的时间周期价值，反映了业务和产研团队对客户问题或业务机会的交付（响应）速度，依赖整个组织各职能部门的协调一致和紧密协作。": "从需求提出，到完成开发、测试、上线的时间周期价值，反映了业务和产研团队对客户问题或业务机会的交付（响应）速度，依赖整个组织各职能部门的协调一致和紧密协作。",
  "注: 各阶段时间均已四舍五入至两位小数，总时间与各阶段直接相加可能存在微小差异。": "注: 各阶段时间均已四舍五入至两位小数，总时间与各阶段直接相加可能存在微小差异。",
  "回滚率": "回滚率",
  "产品评审驳回率=评审驳回数/（评审驳回回数+评审通过数）×100%": "产品评审驳回率=评审驳回数/（评审驳回回数+评审通过数）×100%",
  "代码提交规范率=代码提交关联需求或者缺陷数/提交总数×100%": "代码提交规范率=代码提交关联需求或者缺陷数/提交总数×100%",
  "紧急发布率=紧急发布次数/发布总次数 ×100%": "紧急发布率=紧急发布次数/发布总次数 ×100%",
  "发布成功率=发布成功数/发布总数 ×100%": "发布成功率=发布成功数/发布总数 ×100%",
  "发布回滚率=回滚数/发布总数 ×100%": "发布回滚率=回滚数/发布总数 ×100%",
  "线上缺陷质量指标": "线上缺陷质量指标",
  "线上缺陷解决时效": "线上缺陷解决时效",
  "线上缺陷质量指标（子项目）": "线上缺陷质量指标（子项目）",
  "线上缺陷解决时效（子项目）": "线上缺陷解决时效（子项目）",
  "子项目代码与发布质量监测对比": "子项目代码与发布质量监测对比",
  "子系统产品需求各阶段平均耗时更新对比": "子系统产品需求各阶段平均耗时更新对比",
  "需求总交付": "需求总交付",
  "需求耗时分布（均值）": "需求耗时分布（均值）",
  "需求平均等待时间": "需求平均等待时间",
  "需求平均开发周期": "需求平均开发周期",
  "需求平均测试周期": "需求平均测试周期",
  "需求平均验收周期": "需求平均验收周期",
  "发布回滚率": "发布回滚率",
  "产品需求设计缺陷率": "产品需求设计缺陷率",
  "产品需求设计缺陷率=产品需求设计缺陷数/研发过程缺陷总数×100%": "产品需求设计缺陷率=产品需求设计缺陷数/研发过程缺陷总数×100%",
  "研发过程缺陷平均解决耗时（单位：天）": "研发过程缺陷平均解决耗时（单位：天）",
  "研发过程缺陷平均解决耗时": "研发过程缺陷平均解决耗时",
  "研发过程缺陷平均解决耗时=∑（解决时间-创建时间）/n。": "研发过程缺陷平均解决耗时=∑（解决时间-创建时间）/n。",
  "研发过程缺陷平均关闭耗时（单位：天）": "研发过程缺陷平均关闭耗时（单位：天）",
  "研发过程缺陷平均关闭耗时": "研发过程缺陷平均关闭耗时",
  "研发过程缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。": "研发过程缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。",
  "研发过程缺陷重开率": "研发过程缺陷重开率",
  "研发过程缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%": "研发过程缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%",
  "线上缺陷产品需求设计缺陷率": "线上缺陷产品需求设计缺陷率",
  "线上缺陷产品需求设计缺陷率=线上缺陷产品需求设计缺陷数/线上缺陷总数×100%": "线上缺陷产品需求设计缺陷率=线上缺陷产品需求设计缺陷数/线上缺陷总数×100%",
  "线上缺陷平均解决耗时（单位：天）": "线上缺陷平均解决耗时（单位：天）",
  "线上缺陷平均解决耗时": "线上缺陷平均解决耗时",
  "线上缺陷平均解决耗时=∑（解决时间-创建时间）/n。": "线上缺陷平均解决耗时=∑（解决时间-创建时间）/n。",
  "线上缺陷平均关闭耗时（单位：天）": "线上缺陷平均关闭耗时（单位：天）",
  "线上缺陷平均关闭耗时": "线上缺陷平均关闭耗时",
  "线上缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。": "线上缺陷平均关闭耗时=∑（关闭时间-解决时间）/n。",
  "线上缺陷重开率": "线上缺陷重开率",
  "线上缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%": "线上缺陷重开率=重新打开的缺陷数/已关闭的缺陷总数×100%",
  "改进看板": "改进看板",
  "效率指标": "效率指标",
  "执行人类型": "执行人类型",
  "质量指标": "质量指标",
  "财务分析": "财务分析",
  "请选择团队": "请选择团队",
  "选择年份": "选择年份",
  "排名": "排名",
  "年": "年",
  "总计:": "总计:",
  "人员/年份": "人员/年份",
  "排序方式": "排序方式",
  "按": "按",
  "计划上线时间": "计划上线时间",
  "操作人员": "操作人员",
  "服务状态": "服务状态",
  "其他": "其他",
  "影响周期": "影响周期",
  "有效解决时间": "有效解决时间",
  "责任组长": "责任组长",
  "直接原因": "直接原因",
  "根本原因": "根本原因",
  "关联项名称": "关联项名称",
  "驳回原因": "驳回原因",
  "提交不规范": "提交不规范",
  "提交人邮箱": "提交人邮箱",
  "请求次数": "请求次数",
  "平均响应时间 (ms)": "平均响应时间 (ms)",
  "错误数": "错误数",
  "慢查询": "慢查询",
  "异常数": "异常数",
  "慢接口": "慢接口",
  "等待时间": "等待时间",
  "非规范提交记录": "非规范提交记录",
  "发布失败记录": "发布失败记录",
  "未覆盖需求记录": "未覆盖需求记录",
  "技术债务详情": "技术债务详情",
  "总计：": "总计：",
  "执行次数": "执行次数",
  "已解决": "已解决",
  "慢SQL模版详情": "慢SQL模版详情",
  "慢SQL日志记录": "慢SQL日志记录",
  "近三年": "近三年",
  "近二年": "近二年",
  "近一年": "近一年",
  "筛选指标": "筛选指标",
  "上月": "上月",
  "过往整周期": "过往整周期",
  "昨天": "昨天",
  "上周": "上周",
  "上个月": "上个月",
  "上两月": "上两月",
  "上三月": "上三月",
  "上一自然半年": "上一自然半年",
  "去年": "去年",
  "最近": "最近",
  "近7天": "近7天",
  "近60天": "近60天",
  "近90天": "近90天",
  "近180天": "近180天",
  "近365天": "近365天",
  "近1月": "近1月",
  "近3月": "近3月",
  "近6月": "近6月",
  "近12月": "近12月",
  "当前整周期": "当前整周期",
  "当前自然半年": "当前自然半年",
  "今年": "今年",
  "至今": "至今",
  "本周至今": "本周至今",
  "本月至今": "本月至今",
  "本年至今": "本年至今",
  "我的任务": "我的任务",
  "任务负责人看板": "任务负责人看板",
  "气泡大小:": "气泡大小:",
  "（值越大，气泡越大）；": "（值越大，气泡越大）；",
  "气泡颜色:": "气泡颜色:",
  "（值越大，颜色越深）": "（值越大，颜色越深）",
  "排序:": "排序:",
  "您没有权限查看该角色数据": "您没有权限查看该角色数据",
  "选择角色": "选择角色",
  "人员对比": "人员对比",
  "专业线对比": "专业线对比",
  "年度对比": "年度对比",
  "选择业务领域": "选择业务领域",
  "选择人员(可多选)": "选择人员(可多选)",
  "选择业务领域(可多选)": "选择业务领域(可多选)",
  "选择年份(可多选)": "选择年份(可多选)",
  "请选择角色": "请选择角色",
  "角色：": "角色：",
  "您没有权限查看该用户数据": "您没有权限查看该用户数据",
  "指标": "指标",
  "(单位:": "(单位:",
  "均值/总数": "均值/总数",
  "个人对比": "个人对比",
  "全年": "全年",
  "上半年": "上半年",
  "下半年": "下半年",
  "上班": "上班",
  "打卡时间": "打卡时间",
  "下班": "下班",
  "卡片唯一标志编码，前、后端需要根据该标志编码进行功能开发": "卡片唯一标志编码，前、后端需要根据该标志编码进行功能开发",
  "（创建公共卡片需要代码开发，请确认卡片功能上线后再创建卡片）": "（创建公共卡片需要代码开发，请确认卡片功能上线后再创建卡片）",
  "新建卡片如需代码开发，请提前告知开发卡片编码": "新建卡片如需代码开发，请提前告知开发卡片编码",
  "创建卡片": "创建卡片",
  "请输入卡片名称或描述或编码": "请输入卡片名称或描述或编码",
  "确定要删除 【": "确定要删除 【",
  "】 卡片吗？": "】 卡片吗？",
  "我的仪表盘": "我的仪表盘",
  "】 仪表盘吗？": "】 仪表盘吗？",
  "请选择或输入成员名称": "请选择或输入成员名称",
  "（可通过拖拽调整卡片展示顺序）": "（可通过拖拽调整卡片展示顺序）",
  "显示在当前仪表盘": "显示在当前仪表盘",
  "可添加的卡片": "可添加的卡片",
  "异常事项": "异常事项",
  "点击查看详情": "点击查看详情",
  "我的考勤详情": "我的考勤详情",
  "只能选择单条进行操作！": "只能选择单条进行操作！",
  "缺陷名称和链接已剪贴板": "缺陷名称和链接已剪贴板",
  "催办成功": "催办成功",
  "线上问题明细": "线上问题明细",
  "缺陷明细": "缺陷明细",
  "该任务相关联的服务的服务类型": "该任务相关联的服务的服务类型",
  "指派给我的": "指派给我的",
  "抄送给我的": "抄送给我的",
  "我反馈的": "我反馈的",
  "需求明细": "需求明细",
  "我负责的需求": "我负责的需求",
  "我开发的需求": "我开发的需求",
  "我关注的需求": "我关注的需求",
  "我相关的需求": "我相关的需求",
  "已催促全部未确认人！": "已催促全部未确认人！",
  "该评审相关信息已复制到剪贴板": "该评审相关信息已复制到剪贴板",
  "评审明细": "评审明细",
  "确定要完成": "确定要完成",
  "确定要取消": "确定要取消",
  "评审的会议吗？": "评审的会议吗？",
  "我参与的评审": "我参与的评审",
  "我发起的评审": "我发起的评审",
  "质量门禁": "质量门禁",
  "可靠性评级": "可靠性评级",
  "可维修性评级": "可维修性评级",
  "漏洞数量": "漏洞数量",
  "安全评级": "安全评级",
  "热点已审查(%)": "热点已审查(%)",
  "审查评级": "审查评级",
  "覆盖率(%)": "覆盖率(%)",
  "重复率(%)": "重复率(%)",
  "代码行数": "代码行数",
  "扫描时间": "扫描时间",
  "详细报告": "详细报告",
  "漏洞总数": "漏洞总数",
  "严重漏洞": "严重漏洞",
  "高危漏洞": "高危漏洞",
  "中危漏洞": "中危漏洞",
  "低危漏洞": "低危漏洞",
  "组件总数": "组件总数",
  "严重组件": "严重组件",
  "高危组件": "高危组件",
  "中危组件": "中危组件",
  "低危组件": "低危组件",
  "慢SQL模板": "慢SQL模板",
  "「协同」": "「协同」",
  "我负责的迭代": "我负责的迭代",
  "预估人天（天）": "预估人天（天）",
  "实际工时（时）": "实际工时（时）",
  "任务明细": "任务明细",
  "我负责的任务": "我负责的任务",
  "我参与的任务": "我参与的任务",
  "点击维护团队成员后可查看成员工作状况": "点击维护团队成员后可查看成员工作状况",
  "维护成员": "维护成员",
  "请选择或输入成员名称查询": "请选择或输入成员名称查询",
  "用例类型": "用例类型",
  "运行结果": "运行结果",
  "用例状态": "用例状态",
  "用例内容": "用例内容",
  "我创建的测试用例": "我创建的测试用例",
  "请选择截止时间": "请选择截止时间",
  "今天到期": "今天到期",
  "本周到期": "本周到期",
  "请先编辑并排期": "请先编辑并排期",
  "待排期任务": "待排期任务",
  "待评审测试用例": "待评审测试用例",
  "未知": "未知",
  "测试环境": "测试环境",
  "生产环境": "生产环境",
  "UAT环境": "UAT环境",
  "查看全部": "查看全部",
  "研发缺陷": "研发缺陷",
  "线上缺陷": "线上缺陷",
  "未完成事项": "未完成事项",
  "项目数据透视": "项目数据透视",
  "考勤状态：": "考勤状态：",
  "考勤状态：普通": "考勤状态：普通",
  "欢迎来到研发效能工作台": "欢迎来到研发效能工作台",
  "研发效能工作台，聚合了研发效能平台与你相关的工作内容，帮助你更轻松、高效的处理工作，": "研发效能工作台，聚合了研发效能平台与你相关的工作内容，帮助你更轻松、高效的处理工作，",
  "自定义卡片等功能帮助你高效触达工作场景。": "自定义卡片等功能帮助你高效触达工作场景。",
  "请选择工作台角色": "请选择工作台角色",
  "开始工作": "开始工作",
  "请选择仪表盘": "请选择仪表盘",
  "新的仪表盘": "新的仪表盘",
  "配置仪表盘": "配置仪表盘",
  "编辑卡片": "编辑卡片",
  "配置卡片": "配置卡片",
  "分组字段:": "分组字段:",
  "分组层级最多支持4级，请重新选择": "分组层级最多支持4级，请重新选择",
  "选择分组字段（最多4级）": "选择分组字段（最多4级）",
  "⚠️ 已达到最大分组层级限制（4级），可删除现有分组后继续选择": "⚠️ 已达到最大分组层级限制（4级），可删除现有分组后继续选择",
  "📋 基础信息": "📋 基础信息",
  "🏢 归属信息": "🏢 归属信息",
  "👥 团队人员": "👥 团队人员",
  "⚡ 操作人员": "⚡ 操作人员",
  "当前分组 (": "当前分组 (",
  "统计图表": "统计图表",
  "清理资源中...": "清理资源中...",
  "切换中...": "切换中...",
  "获取图表选择数据失败:": "获取图表选择数据失败:",
  "展开控制面板": "展开控制面板",
  "收起控制面板": "收起控制面板",
  "刷新数据": "刷新数据",
  "添加图表": "添加图表",
  "调整图表顺序": "调整图表顺序",
  "展示图表：": "展示图表：",
  "选择图表": "选择图表",
  "需求创建时间:": "需求创建时间:",
  "请先选择需求池来查看数据": "请先选择需求池来查看数据",
  "您还没有自定义需求池哦，请先点击下方按钮创建一个需求池吧": "您还没有自定义需求池哦，请先点击下方按钮创建一个需求池吧",
  "创建需求池": "创建需求池",
  "请先选择左侧的需求池来查看数据": "请先选择左侧的需求池来查看数据",
  "展开控制面板(视图切换 · Tab切换 · 操作区)": "展开控制面板(视图切换 · Tab切换 · 操作区)",
  "收起控制面板(视图切换 · Tab切换 · 操作区)": "收起控制面板(视图切换 · Tab切换 · 操作区)",
  "拖拽调整列宽": "拖拽调整列宽",
  "需求名称/序列号": "需求名称/序列号",
  "请输入名称或序列号": "请输入名称或序列号",
  "请选择需求类型": "请选择需求类型",
  "系统培训": "系统培训",
  "需要": "需要",
  "不需要": "不需要",
  "影响国家": "影响国家",
  "期待完成日期": "期待完成日期",
  "发布完成日期": "发布完成日期",
  "状态筛选": "状态筛选",
  "人员筛选": "人员筛选",
  "筛选条件已重置": "筛选条件已重置",
  "拆分时，该角色下每个人员独立一个分组；不拆分时，该角色下所有人员合并为一个分组": "拆分时，该角色下每个人员独立一个分组；不拆分时，该角色下所有人员合并为一个分组",
  "拆分": "拆分",
  "字段管理 (": "字段管理 (",
  "字段管理": "字段管理",
  "搜索字段名称...": "搜索字段名称...",
  "个字段": "个字段",
  "全选": "全选",
  "固定字段": "固定字段",
  "已启用字段": "已启用字段",
  "未启用字段": "未启用字段",
  "没有找到匹配的字段": "没有找到匹配的字段",
  "新建图表": "新建图表",
  "编辑图表": "编辑图表",
  "查看图表": "查看图表",
  "请输入图表名称": "请输入图表名称",
  "横轴（类别）": "横轴（类别）",
  "请选择横轴类别": "请选择横轴类别",
  "过滤条件": "过滤条件",
  "设置过滤条件": "设置过滤条件",
  "未设置": "未设置",
  "请选择迭代": "请选择迭代",
  "请选择国家线": "请选择国家线",
  "请选择测试": "请选择测试",
  "实际完成日期": "实际完成日期",
  "获取图表数据失败:": "获取图表数据失败:",
  "图表顺序调整成功": "图表顺序调整成功",
  "拖拽卡片调整图表显示顺序，调整完成后点击确定保存": "拖拽卡片调整图表显示顺序，调整完成后点击确定保存",
  "拖拽调整顺序": "拖拽调整顺序",
  "图表删除成功": "图表删除成功",
  "请先配置图表": "请先配置图表",
  "删除图表确认": "删除图表确认",
  "确定要删除图表": "确定要删除图表",
  "需求池名称": "需求池名称",
  "请输入需求池名称": "请输入需求池名称",
  "需求池名称不能超过100个字符": "需求池名称不能超过100个字符",
  "负责人：": "负责人：",
  "确认添加人员": "确认添加人员",
  "确认添加": "确认添加",
  "选中的系统：": "选中的系统：",
  "选中的标签：": "选中的标签：",
  "将要添加的人员": "将要添加的人员",
  "点击人员标签的 ✕ 可移除该人员": "点击人员标签的 ✕ 可移除该人员",
  "所选系统的人员已全部存在，无需添加新人员。": "所选系统的人员已全部存在，无需添加新人员。",
  "其他可查看人员": "其他可查看人员",
  "快速添加系统人员/标签人员": "快速添加系统人员/标签人员",
  "选择系统来快速添加人员": "选择系统来快速添加人员",
  "选择标签来快速添加属于该标签的需求的人员": "选择标签来快速添加属于该标签的需求的人员",
  "中文名": "中文名",
  "英文名": "英文名",
  "关闭状态创建的标签为研发效能内部标签，开启状态为研发效能内部标签+需求看板外部展示标签。": "关闭状态创建的标签为研发效能内部标签，开启状态为研发效能内部标签+需求看板外部展示标签。",
  "添加标签": "添加标签",
  "标签需求": "标签需求",
  "请先选择系统": "请先选择系统",
  "所选系统的人员已全部存在，无需添加": "所选系统的人员已全部存在，无需添加",
  "请先选择标签": "请先选择标签",
  "所选标签的人员已全部存在，无需添加": "所选标签的人员已全部存在，无需添加",
  "人员已添加成功": "人员已添加成功",
  "添加失败": "添加失败",
  "暂无有效的甘特图数据": "暂无有效的甘特图数据",
  "个分组，": "个分组，",
  "条记录": "条记录",
  "全部折叠": "全部折叠",
  "需求:": "需求:",
  "任务名称:": "任务名称:",
  "负责人:": "负责人:",
  "任务类型:": "任务类型:",
  "开始时间:": "开始时间:",
  "结束时间:": "结束时间:",
  "所属迭代": "所属迭代",
  "暂停至日期": "暂停至日期",
  "提测时间": "提测时间",
  "后端任务时间": "后端任务时间",
  "前端任务时间": "前端任务时间",
  "测试任务时间": "测试任务时间",
  "UI任务时间": "UI任务时间",
  "需求标题": "需求标题",
  "UI设计师": "UI设计师",
  "筛选中...": "筛选中...",
  "数据更新中...": "数据更新中...",
  "所有需求池": "所有需求池",
  "产品需求池": "产品需求池",
  "业务方需求池": "业务方需求池",
  "开发需求池": "开发需求池",
  "测试需求池": "测试需求池",
  "前端需求池": "前端需求池",
  "后端需求池": "后端需求池",
  "UI设计需求池": "UI设计需求池",
  "技术支持需求池": "技术支持需求池",
  "已完成需求池": "已完成需求池",
  "已复制": "已复制",
  "性别:": "性别:",
  "男": "男",
  "女": "女",
  "入职时间:": "入职时间:",
  "所属国家:": "所属国家:",
  "Base地:": "Base地:",
  "部门:": "部门:",
  "手机号:": "手机号:",
  "邮箱:": "邮箱:",
  "所属系统:": "所属系统:",
  "备注:": "备注:",
  "参与项目数 :": "参与项目数 :",
  "总人数:": "总人数:",
  "逻辑图 (向右)": "逻辑图 (向右)",
  "思维导图": "思维导图",
  "性别": "性别",
  "入职时间": "入职时间",
  "所属国家": "所属国家",
  "所在部门": "所在部门",
  "手机号": "手机号",
  "请选择所属系统": "请选择所属系统",
  "请输入备注": "请输入备注",
  "点赞说明": "点赞说明",
  "缺陷的新增数量会有所波动。小幅度的波动是正常的，不必过于关注。需要关注的是大幅度的波动或连续的上升趋势会带来需求交付的延期风险。": "缺陷的新增数量会有所波动。小幅度的波动是正常的，不必过于关注。需要关注的是大幅度的波动或连续的上升趋势会带来需求交付的延期风险。",
  "是指单位时间内未解决的缺陷数量的趋势，反映出团队处理缺陷的能力及软件质量的状态。以下是一些查看存量缺陷趋势指标时的提示：": "是指单位时间内未解决的缺陷数量的趋势，反映出团队处理缺陷的能力及软件质量的状态。以下是一些查看存量缺陷趋势指标时的提示：",
  "长期趋势：如果长期存量缺陷数量持续增长，可能说明存在质量问题或团队处理缺陷的效率低下。": "长期趋势：如果长期存量缺陷数量持续增长，可能说明存在质量问题或团队处理缺陷的效率低下。",
  "处理速度：存量缺陷如果长期不降只升，表示团队处理缺陷的速度赶不上新增缺陷的速度，可能需要调整优先级，分配更多的资源来处理旧的缺陷。": "处理速度：存量缺陷如果长期不降只升，表示团队处理缺陷的速度赶不上新增缺陷的速度，可能需要调整优先级，分配更多的资源来处理旧的缺陷。",
  "缺陷趋势是一个健康的软件开发生命周期中的重要工具，除了使用它来追踪需求进度，也可以作为改进工作流程、提升产品质量的重要参考。": "缺陷趋势是一个健康的软件开发生命周期中的重要工具，除了使用它来追踪需求进度，也可以作为改进工作流程、提升产品质量的重要参考。",
  "该图表会显示每天新增的缺陷数量、修复的缺陷数量以及仍然活跃的或未解决的缺陷数量（通常称为\"缺陷存量\"）。": "该图表会显示每天新增的缺陷数量、修复的缺陷数量以及仍然活跃的或未解决的缺陷数量（通常称为\"缺陷存量\"）。",
  "通常指的是在一天缺陷数量的变化。包括新增的缺陷，已经关闭的缺陷，解决中的缺陷等。": "通常指的是在一天缺陷数量的变化。包括新增的缺陷，已经关闭的缺陷，解决中的缺陷等。",
  "效率衡量： 如果你的团队今天解决了很多缺陷，但同时又产生了许多新的缺陷，那缺陷数量变化（日）指标就能很好地反映出这个情况，作为衡量团队工作效率的一个指标。": "效率衡量： 如果你的团队今天解决了很多缺陷，但同时又产生了许多新的缺陷，那缺陷数量变化（日）指标就能很好地反映出这个情况，作为衡量团队工作效率的一个指标。",
  "进度追踪：这个指标可以帮助研发跟踪需求的进度。如果缺陷的数量持续减少，那说明正在向好的方向发展。": "进度追踪：这个指标可以帮助研发跟踪需求的进度。如果缺陷的数量持续减少，那说明正在向好的方向发展。",
  "所选时间段内未关闭缺陷各状态占比": "所选时间段内未关闭缺陷各状态占比",
  "所选时间段内未关闭缺陷各优先级占比": "所选时间段内未关闭缺陷各优先级占比",
  "帮助检测潜在问题： 这可以帮助我们识别出哪些人可能需要更多的支持，或者他们的工作负载是否过大。如果某位团队成员的未解决缺陷数量远高于其他人，这可能表明他们正在处理的问题区域特别复杂，或可能需要增加资源和注意力。": "帮助检测潜在问题： 这可以帮助我们识别出哪些人可能需要更多的支持，或者他们的工作负载是否过大。如果某位团队成员的未解决缺陷数量远高于其他人，这可能表明他们正在处理的问题区域特别复杂，或可能需要增加资源和注意力。",
  "均衡工作负载：这个指标也可以帮助我们平衡工作负载，我们可以通过调整任务分配，使每个团队成员负责的缺陷数量大致平均。这个指标并不意味着缺陷多的团队成员工作效率低下或技术能力差，反而可能因为他们在处理更复杂的、更需要专业技术的问题。因此，必须结合实际情况进行，理解背后可能的因素，而不是简单地从数量上学判别。": "均衡工作负载：这个指标也可以帮助我们平衡工作负载，我们可以通过调整任务分配，使每个团队成员负责的缺陷数量大致平均。这个指标并不意味着缺陷多的团队成员工作效率低下或技术能力差，反而可能因为他们在处理更复杂的、更需要专业技术的问题。因此，必须结合实际情况进行，理解背后可能的因素，而不是简单地从数量上学判别。",
  "是指单位时间内未解决的线上问题数量的趋势，反映出团队处理线上问题的能力及软件质量的状态。以下是一些查看存量线上问题趋势指标时的提示：": "是指单位时间内未解决的线上问题数量的趋势，反映出团队处理线上问题的能力及软件质量的状态。以下是一些查看存量线上问题趋势指标时的提示：",
  "长期趋势：如果长期存量线上问题数量持续增长，可能说明存在质量问题或团队处理线上问题的效率低下。": "长期趋势：如果长期存量线上问题数量持续增长，可能说明存在质量问题或团队处理线上问题的效率低下。",
  "处理速度：存量线上问题如果长期不降只升，表示团队处理线上问题的速度赶不上新增线上问题的速度，可能需要调整优先级，分配更多的资源来处理旧的线上问题。": "处理速度：存量线上问题如果长期不降只升，表示团队处理线上问题的速度赶不上新增线上问题的速度，可能需要调整优先级，分配更多的资源来处理旧的线上问题。",
  "线上问题趋势是一个健康的软件开发生命周期中的重要工具，除了使用它来追踪需求进度，也可以作为改进工作流程、提升产品质量的重要参考。": "线上问题趋势是一个健康的软件开发生命周期中的重要工具，除了使用它来追踪需求进度，也可以作为改进工作流程、提升产品质量的重要参考。",
  "该图表会显示每天新增的线上问题数量、修复的线上问题数量以及仍然活跃的或未解决的线上问题数量（通常称为\"线上问题存量\"）。": "该图表会显示每天新增的线上问题数量、修复的线上问题数量以及仍然活跃的或未解决的线上问题数量（通常称为\"线上问题存量\"）。",
  "通常指的是在一天线上问题数量的变化。包括新增的线上问题，已经关闭的线上问题，解决中的线上问题等。": "通常指的是在一天线上问题数量的变化。包括新增的线上问题，已经关闭的线上问题，解决中的线上问题等。",
  "效率衡量： 如果你的团队今天解决了很多线上问题，但同时又产生了许多新的线上问题，那线上问题数量变化（日）指标就能很好地反映出这个情况，作为衡量团队工作效率的一个指标。": "效率衡量： 如果你的团队今天解决了很多线上问题，但同时又产生了许多新的线上问题，那线上问题数量变化（日）指标就能很好地反映出这个情况，作为衡量团队工作效率的一个指标。",
  "进度追踪：这个指标可以帮助研发跟踪需求的进度。如果线上问题的数量持续减少，那说明正在向好的方向发展。": "进度追踪：这个指标可以帮助研发跟踪需求的进度。如果线上问题的数量持续减少，那说明正在向好的方向发展。",
  "所选时间段内未关闭线上问题各状态占比": "所选时间段内未关闭线上问题各状态占比",
  "所选时间段内未关闭线上问题各优先级占比": "所选时间段内未关闭线上问题各优先级占比",
  "帮助检测潜在问题： 这可以帮助我们识别出哪些人可能需要更多的支持，或者他们的工作负载是否过大。如果某位团队成员的未解决线上问题数量远高于其他人，这可能表明他们正在处理的问题区域特别复杂，或可能需要增加资源和注意力。": "帮助检测潜在问题： 这可以帮助我们识别出哪些人可能需要更多的支持，或者他们的工作负载是否过大。如果某位团队成员的未解决线上问题数量远高于其他人，这可能表明他们正在处理的问题区域特别复杂，或可能需要增加资源和注意力。",
  "均衡工作负载：这个指标也可以帮助我们平衡工作负载，我们可以通过调整任务分配，使每个团队成员负责的线上问题数量大致平均。这个指标并不意味着线上问题多的团队成员工作效率低下或技术能力差，反而可能因为他们在处理更复杂的、更需要专业技术的问题。因此，必须结合实际情况进行，理解背后可能的因素，而不是简单地从数量上学判别。": "均衡工作负载：这个指标也可以帮助我们平衡工作负载，我们可以通过调整任务分配，使每个团队成员负责的线上问题数量大致平均。这个指标并不意味着线上问题多的团队成员工作效率低下或技术能力差，反而可能因为他们在处理更复杂的、更需要专业技术的问题。因此，必须结合实际情况进行，理解背后可能的因素，而不是简单地从数量上学判别。",
  "有": "有",
  "没有": "没有",
  "配置模板": "配置模板",
  "自动推送": "自动推送",
  "抄送人&负责人": "抄送人&负责人",
  "编辑模板": "编辑模板",
  "管理部门周报细分模板": "管理部门周报细分模板",
  "确认要删除该部门周报模板吗？": "确认要删除该部门周报模板吗？",
  "删除部门周报模板": "删除部门周报模板",
  "配置部门周报": "配置部门周报",
  "部门列表": "部门列表",
  "已配置模板列表": "已配置模板列表",
  "配置部门周报模板": "配置部门周报模板",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【xxx部门2034年第17周周报】；通配符说明：%N【部门名称】、%Y【当前年份】、%W【当年第几周】": "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【xxx部门2034年第17周周报】；通配符说明：%N【部门名称】、%Y【当前年份】、%W【当年第几周】",
  "点击上方复制按钮获取原始模板或者自定义带有%Y与%W的模板": "点击上方复制按钮获取原始模板或者自定义带有%Y与%W的模板",
  "点击获取原始标题模板": "点击获取原始标题模板",
  "原始标题模板已复制到剪贴板": "原始标题模板已复制到剪贴板",
  "选择你的周报收件人": "选择你的周报收件人",
  "周报包含成员": "周报包含成员",
  "已添加周报模板项": "已添加周报模板项",
  "(可拖拽调整顺序)": "(可拖拽调整顺序)",
  "未添加周报模板项": "未添加周报模板项",
  "已有模板": "已有模板",
  "确认删除该项目周报模板吗？": "确认删除该项目周报模板吗？",
  "未获取到模板ID，无法删除": "未获取到模板ID，无法删除",
  "删除模板": "删除模板",
  "配置项目周报": "配置项目周报",
  "我负责且进行中的项目": "我负责且进行中的项目",
  "发送成功": "发送成功",
  "汇报对象为邮件收件人，并且会自动拉取项目相关人员作为邮件抄送人": "汇报对象为邮件收件人，并且会自动拉取项目相关人员作为邮件抄送人",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【xx项目_2024年第17周周报】；通配符说明：%N【项目名称】、%Y【当前年份】、%W【当年第几周】": "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【xx项目_2024年第17周周报】；通配符说明：%N【项目名称】、%Y【当前年份】、%W【当年第几周】",
  "选择周报收件人": "选择周报收件人",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【产品经理_2024年第17周周报】；通配符说明：%N【角色名称】、%Y【当前年份】、%W【当年第几周】": "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W周报】 会自动转译为 【产品经理_2024年第17周周报】；通配符说明：%N【角色名称】、%Y【当前年份】、%W【当年第几周】",
  "选择周报成员": "选择周报成员",
  "请选择周报成员": "请选择周报成员",
  "周报人员状况": "周报人员状况",
  "模板包含成员": "模板包含成员",
  "确认要克隆该部门小组周报模板吗？": "确认要克隆该部门小组周报模板吗？",
  "一键克隆模板": "一键克隆模板",
  "确认要删除该部门小组周报模板吗？": "确认要删除该部门小组周报模板吗？",
  "删除部门小组周报模板": "删除部门小组周报模板",
  "创建部门小组周报模板": "创建部门小组周报模板",
  "配置个人周报模板": "配置个人周报模板",
  "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W_%B%P周报】 会自动转译为 【Luke李黎明_2024年第17周_研发效能（Development Engineer）周报】；通配符说明：%N【发送人姓名】、%Y【当前年份】、%W【当年第几周】、%B【业务领域】、%P【岗位】": "如果没有自定义的需求，可以直接使用带有通配符的默认模板，无需修改！默认利用通配符转译标题模板，eg：【%N_%Y%W_%B%P周报】 会自动转译为 【Luke李黎明_2024年第17周_研发效能（Development Engineer）周报】；通配符说明：%N【发送人姓名】、%Y【当前年份】、%W【当年第几周】、%B【业务领域】、%P【岗位】",
  "如果开启则在每周日15:00自动推送": "如果开启则在每周日15:00自动推送",
  "已生成分享内容至剪切板": "已生成分享内容至剪切板",
  "删除评论": "删除评论",
  "确认删除这条评论吗?": "确认删除这条评论吗?",
  "汇报给：": "汇报给：",
  "抄送：": "抄送：",
  "上一条": "上一条",
  "下一条": "下一条",
  "已读数：": "已读数：",
  "已读人：": "已读人：",
  "点赞人：": "点赞人：",
  "点赞": "点赞",
  "评论区：": "评论区：",
  "已保存为本周草稿内容": "已保存为本周草稿内容",
  "保存后，本周写周报会携带上草稿内容，下周自动失效（草稿只对本周工作小结、下周工作计划、感想&问题&建议、自由内容模板有效）": "保存后，本周写周报会携带上草稿内容，下周自动失效（草稿只对本周工作小结、下周工作计划、感想&问题&建议、自由内容模板有效）",
  "保存本周草稿": "保存本周草稿",
  "确定现在推送工作周报吗？": "确定现在推送工作周报吗？",
  "周报已在推送中，请勿重复提交": "周报已在推送中，请勿重复提交",
  "已创建周报推送任务，请稍等": "已创建周报推送任务，请稍等",
  "确认后将会直接生成【当周周报】！": "确认后将会直接生成【当周周报】！",
  "保存后，本周写周报会携带上草稿内容，下周自动失效": "保存后，本周写周报会携带上草稿内容，下周自动失效",
  "以下数据由系统生成：": "以下数据由系统生成：",
  "点击查看git提交详情": "点击查看git提交详情",
  "点击查看代码提交规范": "点击查看代码提交规范",
  "确认后将会直接生成【当周周报】并通过邮件推送给汇报对象！": "确认后将会直接生成【当周周报】并通过邮件推送给汇报对象！",
  "用例类别": "用例类别",
  "标记": "标记",
  "开始日期": "开始日期",
  "风险程度": "风险程度",
  "风险应对方法": "风险应对方法",
  "已处理": "已处理",
  "未处理": "未处理",
  "总用例数量": "总用例数量",
  "新增功能用例数量": "新增功能用例数量",
  "已完成功能用例数量": "已完成功能用例数量",
  "未完成功能用例数量": "未完成功能用例数量",
  "新增自动化用例数量": "新增自动化用例数量",
  "已完成自动化用例数量": "已完成自动化用例数量",
  "未完成自动化用例数量": "未完成自动化用例数量",
  "该URL已失效，请重新复制新的分享链接在打开详情！": "该URL已失效，请重新复制新的分享链接在打开详情！",
  "点赞数": "点赞数",
  "确认要删除该周报吗？": "确认要删除该周报吗？",
  "删除周报": "删除周报",
  "欢迎使用每周三省吾身": "欢迎使用每周三省吾身",
  "每周三省吾身，支持配置周报模板，根据您本周的工作内容一键生成周报，并且支持定时推送，": "每周三省吾身，支持配置周报模板，根据您本周的工作内容一键生成周报，并且支持定时推送，",
  "让您更轻松的填写周报。": "让您更轻松的填写周报。",
  "创建周报模板": "创建周报模板",
  "写部门周报": "写部门周报",
  "配置角色模板": "配置角色模板",
  "写项目周报": "写项目周报",
  "配置项目周报模板": "配置项目周报模板",
  "请输入标题名称": "请输入标题名称",
  "选择成员": "选择成员",
  "获取该组织下的所有人员，支持多选": "获取该组织下的所有人员，支持多选",
  "组织人员与岗位": "组织人员与岗位",
  "产品人员": "产品人员",
  "红色代表大于本周平均值，需关注。": "红色代表大于本周平均值，需关注。",
  "平均值计算规则：总缺陷数 / 总人数": "平均值计算规则：总缺陷数 / 总人数",
  "汇总": "汇总",
  "1）淡黄色代表此产品经理评审数量在周平均值以下，如果持续较低需关注其工作内容。 平均值计算规则：总评审数 / 总人数": "1）淡黄色代表此产品经理评审数量在周平均值以下，如果持续较低需关注其工作内容。 平均值计算规则：总评审数 / 总人数",
  "2）红色代表未评审需求。": "2）红色代表未评审需求。",
  "平均值": "平均值",
  "1）红色代表工作时长高于47.5小时(每天9.5H), 需关注。": "1）红色代表工作时长高于47.5小时(每天9.5H), 需关注。",
  "2） 绿色代表工作时长低于42.5小时(每天8.5H)。": "2） 绿色代表工作时长低于42.5小时(每天8.5H)。",
  "周报推送时间": "周报推送时间",
  "每周日下午六点": "每周日下午六点",
  "确认要删除该周报模板吗？": "确认要删除该周报模板吗？",
  "删除周报模板": "删除周报模板",
  "配置角色模块": "配置角色模块",
  "新增周报模块": "新增周报模块",
  "总工作时长": "总工作时长",
  "待介入需求平均已等待时长(天)": "待介入需求平均已等待时长(天)",
  "处理中需求": "处理中需求",
  "已暂停需求": "已暂停需求",
  "本周新增需求": "本周新增需求",
  "本周评审需求": "本周评审需求",
  "本周产品缺陷": "本周产品缺陷",
  "颜色说明": "颜色说明",
  ": 黄色代表需要关注，红色代表需要重点关注。": ": 黄色代表需要关注，红色代表需要重点关注。",
  "数据统计时间范围": "数据统计时间范围",
  ": 上周一 00:00 到上周日 23:59:59。": ": 上周一 00:00 到上周日 23:59:59。",
  "总工作时长参考": "总工作时长参考",
  "- 红色: 工作时长高于 47.5 小时 (每天 9.5 小时)，需关注。": "- 红色: 工作时长高于 47.5 小时 (每天 9.5 小时)，需关注。",
  "- 绿色: 工作时长低于 42.5 小时 (每天 8.5 小时)。": "- 绿色: 工作时长低于 42.5 小时 (每天 8.5 小时)。",
  ": 待介入业务需求 + 待介入产品需求的总数。": ": 待介入业务需求 + 待介入产品需求的总数。",
  "待介入需求平均已等待时长 (天)": "待介入需求平均已等待时长 (天)",
  "计算规则为 (当前时间 - 待介入需求的创建时间) / 待介入需求数量。": "计算规则为 (当前时间 - 待介入需求的创建时间) / 待介入需求数量。",
  ": 需求状态为 “业务已确认” 或 “产品方案中” 的需求数量。": ": 需求状态为 “业务已确认” 或 “产品方案中” 的需求数量。",
  "统计该产品经理的已暂停需求，“()”中统计的是平均暂停时长，与待介入需求平均已等待时长逻辑一致。": "统计该产品经理的已暂停需求，“()”中统计的是平均暂停时长，与待介入需求平均已等待时长逻辑一致。",
  "- 淡黄色: 此产品经理评审数量在周平均值以下，需关注其工作内容。": "- 淡黄色: 此产品经理评审数量在周平均值以下，需关注其工作内容。",
  "- 红色: 未评审需求。": "- 红色: 未评审需求。",
  ": 测试问题中类别为 “需求缺陷” 的问题数。": ": 测试问题中类别为 “需求缺陷” 的问题数。",
  "- 红色: 大于本周平均值。": "- 红色: 大于本周平均值。",
  "汇总/平均": "汇总/平均",
  "审核中": "审核中",
  "工作项名称": "工作项名称",
  "发布类型": "发布类型",
  "关联分支": "关联分支",
  "关联缺陷": "关联缺陷",
  "预约日期": "预约日期",
  "预约人": "预约人",
  "预约时间": "预约时间",
  "发布状态": "发布状态",
  "发布描述": "发布描述",
  "审核备注": "审核备注",
  "确认要取消预约吗？": "确认要取消预约吗？",
  "预约记录": "预约记录",
  "服务分支详情": "服务分支详情",
  "填写原因": "填写原因",
  "原因不能为空": "原因不能为空",
  "请输入原因": "请输入原因",
  "关联缺陷详情": "关联缺陷详情",
  "请选择发布分支": "请选择发布分支",
  "编辑预约": "编辑预约",
  "不存在预约发布服务分支": "不存在预约发布服务分支",
  "预约发布类型": "预约发布类型",
  "请选择预约发布类型": "请选择预约发布类型",
  "请选择工作项": "请选择工作项",
  "请选择预约日期": "请选择预约日期",
  "重新拉取服务分支": "重新拉取服务分支",
  "星期日": "星期日",
  "星期一": "星期一",
  "星期二": "星期二",
  "星期三": "星期三",
  "星期四": "星期四",
  "星期五": "星期五",
  "星期六": "星期六",
  "预约详情": "预约详情",
  "预约状态": "预约状态",
  "已预约": "已预约",
  "未预约": "未预约",
  "假期": "假期",
  "查看需求详情": "查看需求详情",
  "查看迭代详情": "查看迭代详情",
  "预约": "预约",
  "下个月": "下个月",
  "确认回滚": "确认回滚",
  "版本": "版本",
  "镜像": "镜像",
  "处理中": "处理中",
  "历史版本": "历史版本",
  "提交申请": "提交申请",
  "请输入回滚原因": "请输入回滚原因",
  "申请调试": "申请调试",
  "审批人": "审批人",
  "调试时长": "调试时长",
  "请输入调试时长": "请输入调试时长",
  "请输入数字": "请输入数字",
  "请输入1-120分钟": "请输入1-120分钟",
  "申请原因": "申请原因",
  "申请记录": "申请记录",
  "审批中": "审批中",
  "已通过": "已通过",
  "已拒绝": "已拒绝",
  "申请人": "申请人",
  "申请时间": "申请时间",
  "审批成功": "审批成功",
  "审批时间": "审批时间",
  "就绪：": "就绪：",
  "个，可用：": "个，可用：",
  "个，期望：": "个，期望：",
  "滚动更新中": "滚动更新中",
  "容器名称": "容器名称",
  "当前镜像": "当前镜像",
  "启动时间": "启动时间",
  "内存": "内存",
  "调试记录": "调试记录",
  "实时日志": "实时日志",
  "健康检测": "健康检测",
  "运行时长": "运行时长",
  "实例 IP": "实例 IP",
  "节点信息": "节点信息",
  "基本操作": "基本操作",
  "查看 Yaml": "查看 Yaml",
  "同步当前服务": "同步当前服务",
  "WebSocket 连接错误:": "WebSocket 连接错误:",
  "停止连接": "停止连接",
  "重新连接": "重新连接",
  "Pod 名称:": "Pod 名称:",
  "容器名称:": "容器名称:",
  "YAML 已复制到剪贴板！": "YAML 已复制到剪贴板！",
  "复制失败！": "复制失败！",
  "Yaml 配置": "Yaml 配置",
  "Pod数据同步成功": "Pod数据同步成功",
  "容器数据同步成功": "容器数据同步成功",
  "数据同步中，请耐心等待": "数据同步中，请耐心等待",
  "当前服务同步成功": "当前服务同步成功",
  "获取容器调试权限失败，请重试": "获取容器调试权限失败，请重试",
  "副本数量": "副本数量",
  "调整": "调整",
  "实例IP": "实例IP",
  "服务实例": "服务实例",
  "列表视图": "列表视图",
  "卡片视图": "卡片视图",
  "实例信息": "实例信息",
  "K8s 集群": "K8s 集群",
  "区域": "区域",
  "K8s 命名空间": "K8s 命名空间",
  "镜像仓库": "镜像仓库",
  "加密成功": "加密成功",
  "加密生成器": "加密生成器",
  "复制生成结果": "复制生成结果",
  "加密": "加密",
  "副本数数据异常，请刷新页面后重试": "副本数数据异常，请刷新页面后重试",
  "伸缩": "伸缩",
  "服务：": "服务：",
  "当前期望副本数：": "当前期望副本数：",
  "目标副本数：": "目标副本数：",
  "可连续点击 +1/-1 选择最终目标值，然后一次提交。": "可连续点击 +1/-1 选择最终目标值，然后一次提交。",
  "申请将副本数从": "申请将副本数从",
  "修改为": "修改为",
  "容器组数量": "容器组数量",
  "可用副本数/期望副本数": "可用副本数/期望副本数",
  "请输入服务名称": "请输入服务名称",
  "服务总数": "服务总数",
  "地域/集群/命名空间": "地域/集群/命名空间",
  "命名空间：": "命名空间：",
  "请选择命名空间": "请选择命名空间",
  "请先选择地域": "请先选择地域",
  "应用同步成功": "应用同步成功",
  "泳道组": "泳道组",
  "编辑泳道组": "编辑泳道组",
  "入口类型:": "入口类型:",
  "泳道组流量入口:": "泳道组流量入口:",
  "泳道组涉及的应用": "泳道组涉及的应用",
  "暂无匹配的应用": "暂无匹配的应用",
  "暂无应用数据": "暂无应用数据",
  "请不要重复提交": "请不要重复提交",
  "提交错误:": "提交错误:",
  "创建泳道组": "创建泳道组",
  "更新": "更新",
  "创建泳道组后：": "创建泳道组后：",
  "1.若未创建灰度泳道，网关的所有流量默认会路由至后端服务的基线节点。": "1.若未创建灰度泳道，网关的所有流量默认会路由至后端服务的基线节点。",
  "2.若已创建灰度泳道，网关会将不匹配灰度规则的流量路由至基线节点。": "2.若已创建灰度泳道，网关会将不匹配灰度规则的流量路由至基线节点。",
  "因此，需确保网关所指向的后端服务包含基线节点，否则请求会报错。": "因此，需确保网关所指向的后端服务包含基线节点，否则请求会报错。",
  "基线节点指的是未接入服务治理的节点，或接入过程中未添加 alicloud.service.tag 标签的节点。": "基线节点指的是未接入服务治理的节点，或接入过程中未添加 alicloud.service.tag 标签的节点。",
  "泳道组名称": "泳道组名称",
  "请输入泳道组名称": "请输入泳道组名称",
  "泳道组名称不能超过64个字符": "泳道组名称不能超过64个字符",
  "支持大小写字母、数字、\".\"和\"-\"、长度不超过64个字符": "支持大小写字母、数字、\".\"和\"-\"、长度不超过64个字符",
  "入口类型": "入口类型",
  "请选择入口类型": "请选择入口类型",
  "入口网关": "入口网关",
  "请选择入口网关": "请选择入口网关",
  "泳道组涉及应用": "泳道组涉及应用",
  "选择泳道组涉及应用": "选择泳道组涉及应用",
  "请选择泳道组涉及的应用": "请选择泳道组涉及的应用",
  "应用数据同步成功": "应用数据同步成功",
  "请先选择命名空间": "请先选择命名空间",
  "请先选择泳道组": "请先选择泳道组",
  "命名空间同步成功": "命名空间同步成功",
  "刷新成功": "刷新成功",
  "泳道组同步成功": "泳道组同步成功",
  "同步命名空间": "同步命名空间",
  "刷新泳道组": "刷新泳道组",
  "同步泳道组": "同步泳道组",
  "当前命名空间下暂无泳道组": "当前命名空间下暂无泳道组",
  "请创建第一个泳道组来开始流量管理": "请创建第一个泳道组来开始流量管理",
  "按内容模式必须设置至少一条灰度条件": "按内容模式必须设置至少一条灰度条件",
  "请完善所有灰度条件的参数": "请完善所有灰度条件的参数",
  "按内容模式至少需要一条灰度条件": "按内容模式至少需要一条灰度条件",
  "参数类型": "参数类型",
  "参数": "参数",
  "条件": "条件",
  "前缀匹配": "前缀匹配",
  "正则匹配": "正则匹配",
  "百分比": "百分比",
  "hash(get(key)) % 100 < value 成立时满足条件": "hash(get(key)) % 100 < value 成立时满足条件",
  "值": "值",
  "输入值后按回车添加": "输入值后按回车添加",
  "输入值后按回车添加多个条件": "输入值后按回车添加多个条件",
  "hash(get(key)) % 100 &lt; value 成立时满足条件": "hash(get(key)) % 100 &lt; value 成立时满足条件",
  "按内容模式至少需要一条条件": "按内容模式至少需要一条条件",
  "删除条件": "删除条件",
  "编辑泳道": "编辑泳道",
  "创建泳道": "创建泳道",
  "泳道名称": "泳道名称",
  "请输入一个便于理解和识别的泳道名称": "请输入一个便于理解和识别的泳道名称",
  "请输入泳道名称": "请输入泳道名称",
  "泳道名称不能超过64个字符": "泳道名称不能超过64个字符",
  "泳道标签": "泳道标签",
  "请选择泳道标签": "请选择泳道标签",
  "编辑模式下不能修改泳道标签": "编辑模式下不能修改泳道标签",
  "泳道标签需要用来给应用打标，当匹配条件命中时，会将打上此处定义的标识。": "泳道标签需要用来给应用打标，当匹配条件命中时，会将打上此处定义的标识。",
  "确认匹配关系": "确认匹配关系",
  "请确认泳道标签与打标节点之间的匹配关系。如果不合预期，请根据实际情况调整泳道或节点的标签。请注意，下列匹配关系是系统当前的实时状态，后续可能会随着系统的变更而发生改变。": "请确认泳道标签与打标节点之间的匹配关系。如果不合预期，请根据实际情况调整泳道或节点的标签。请注意，下列匹配关系是系统当前的实时状态，后续可能会随着系统的变更而发生改变。",
  "应用名称": "应用名称",
  "匹配节点数/全部节点数": "匹配节点数/全部节点数",
  "泳道状态": "泳道状态",
  "灰度模式": "灰度模式",
  "灰度模式在整个泳道组内需保持一致，一旦第一条泳道成功创建，后续泳道就不可以再对其进行更改": "灰度模式在整个泳道组内需保持一致，一旦第一条泳道成功创建，后续泳道就不可以再对其进行更改",
  "按内容匹配度": "按内容匹配度",
  "当请求内容可以用于灰度识别时，建议采用此种灰度模式。倘若不可以，也强烈建议您通过系统改造增加此类灰度标识，以便获得更好的灰度效果。比如，可以保持灰度请求前后的一致性。": "当请求内容可以用于灰度识别时，建议采用此种灰度模式。倘若不可以，也强烈建议您通过系统改造增加此类灰度标识，以便获得更好的灰度效果。比如，可以保持灰度请求前后的一致性。",
  "按比例匹配度": "按比例匹配度",
  "当请求内容无法用于灰度识别且遗留系统也无法进行改造时，可以采用此种退化的灰度模式。该模式有一定弊端，可能导致同一来源的请求进入不同泳道，而造成灰度请求前后行为的不一致。": "当请求内容无法用于灰度识别且遗留系统也无法进行改造时，可以采用此种退化的灰度模式。该模式有一定弊端，可能导致同一来源的请求进入不同泳道，而造成灰度请求前后行为的不一致。",
  "流量比例": "流量比例",
  "为所选路由或Path设置流量比例，在默认情况下，泳道内的所有路由或Path都将使用统一的流量比例。": "为所选路由或Path设置流量比例，在默认情况下，泳道内的所有路由或Path都将使用统一的流量比例。",
  "• 单个泳道流量比例不能超过": "• 单个泳道流量比例不能超过",
  "• 泳道组内所有泳道流量比例之和不能超过": "• 泳道组内所有泳道流量比例之和不能超过",
  "• 当前泳道组已使用": "• 当前泳道组已使用",
  "%，最多还可分配": "%，最多还可分配",
  "请输入流量比例": "请输入流量比例",
  "灰度条件": "灰度条件",
  "灰度条件指定了请求内容的灰度匹配方式。当请求内容满足下列条件时，会被打上前面指定的泳道标签。": "灰度条件指定了请求内容的灰度匹配方式。当请求内容满足下列条件时，会被打上前面指定的泳道标签。",
  "条件关系": "条件关系",
  "按内容模式必须设置至少一条灰度条件，且所有条件参数都必须填写完整。": "按内容模式必须设置至少一条灰度条件，且所有条件参数都必须填写完整。",
  "以下条件同时满足": "以下条件同时满足",
  "以下条件任意满足": "以下条件任意满足",
  "请添加灰度条件": "请添加灰度条件",
  "添加灰度条件": "添加灰度条件",
  "条件:": "条件:",
  "泳道同步成功": "泳道同步成功",
  "泳道应用列表": "泳道应用列表",
  "流量分配条件规则": "流量分配条件规则",
  "灰度比例": "灰度比例",
  "已启用": "已启用",
  "已关闭": "已关闭",
  "流量分配": "流量分配",
  "刷新泳道": "刷新泳道",
  "同步泳道": "同步泳道",
  "搜索泳道名称": "搜索泳道名称",
  "发布中": "发布中",
  "编辑中": "编辑中",
  "下线中": "下线中",
  "强制HTTPS": "强制HTTPS",
  "已开启": "已开启",
  "来源": "来源",
  "插件名称": "插件名称",
  "未启用": "未启用",
  "当前版本": "当前版本",
  "最高版本": "最高版本",
  "确认生效?": "确认生效?",
  "生效成功!": "生效成功!",
  "生效": "生效",
  "灰度配置": "灰度配置",
  "保存(无权限)": "保存(无权限)",
  "保存成功!": "保存成功!",
  "灰度版本": "灰度版本",
  "请选择!": "请选择!",
  "灰度方式": "灰度方式",
  "灰度值": "灰度值",
  "最多只能设置4000个灰度值": "最多只能设置4000个灰度值",
  "请至少选择或输入一个灰度值": "请至少选择或输入一个灰度值",
  "选择国家": "选择国家",
  "选择用户": "选择用户",
  "用户ID": "用户ID",
  "每行一个用户ID，或用逗号分隔 例如: user1 user2,user3 user4": "每行一个用户ID，或用逗号分隔 例如: user1 user2,user3 user4",
  "请输入要添加的用户ID": "请输入要添加的用户ID",
  "没有有效的用户ID可添加": "没有有效的用户ID可添加",
  "预览": "预览",
  "生效中": "生效中",
  "服务类別": "服务类別",
  "秒": "秒",
  "责任描述": "责任描述",
  "查看错误日志": "查看错误日志",
  "请勾选要复制的数据": "请勾选要复制的数据",
  "已复制发布记录到剪贴板": "已复制发布记录到剪贴板",
  "复制选中数据": "复制选中数据",
  "请选择或输入服务名称": "请选择或输入服务名称",
  "关联发布单": "关联发布单",
  "选择系统": "选择系统",
  "编辑回滚责任人": "编辑回滚责任人",
  "申请Hot Fix": "申请Hot Fix",
  "申请服务的服务类型": "申请服务的服务类型",
  "服务类型不能为空": "服务类型不能为空",
  "服务不能为空": "服务不能为空",
  "申请的服务": "申请的服务",
  "分支不能为空": "分支不能为空",
  "申请的分支": "申请的分支",
  "请输入发布原因，不超过30个字符": "请输入发布原因，不超过30个字符",
  "发布原因不能为空": "发布原因不能为空",
  "获取服务列表失败:": "获取服务列表失败:",
  "获取分支列表失败:": "获取分支列表失败:",
  "获取服务属性失败:": "获取服务属性失败:",
  "获取服务列表失败": "获取服务列表失败",
  "获取服务信息失败": "获取服务信息失败",
  "请先选择发布单类型和对应的载体": "请先选择发布单类型和对应的载体",
  "获取已发布服务分支失败": "获取已发布服务分支失败",
  "分支领先Master": "分支领先Master",
  "分支落后Master": "分支落后Master",
  "新加坡生产环境发布": "新加坡生产环境发布",
  "（提交后会创建新加坡生产环境发布申请，发布需走审批流程，并会自动创建一个发布单，请先确保新加披uat已验证通过）": "（提交后会创建新加坡生产环境发布申请，发布需走审批流程，并会自动创建一个发布单，请先确保新加披uat已验证通过）",
  "（提交后会按服务顺序直接发布，并会根据发布单类型创建或关联一个发布单）": "（提交后会按服务顺序直接发布，并会根据发布单类型创建或关联一个发布单）",
  "默认查60天git提交记录": "默认查60天git提交记录",
  "分支检查失败": "分支检查失败",
  "分支落后检查": "分支落后检查",
  "已关联发布单服务分支清单": "已关联发布单服务分支清单",
  "请选择发布单类型": "请选择发布单类型",
  "请选择或输入需求名称": "请选择或输入需求名称",
  "本次发布关联的产品需求": "本次发布关联的产品需求",
  "请选择或输入迭代名称": "请选择或输入迭代名称",
  "本次发布关联的Sprint": "本次发布关联的Sprint",
  "请选择或输入线上问题名称": "请选择或输入线上问题名称",
  "本次发布关联的线上问题": "本次发布关联的线上问题",
  "如果拉取，则会将该载体下所有commit记录的服务分支拉取出来并填充": "如果拉取，则会将该载体下所有commit记录的服务分支拉取出来并填充",
  "添加服务分支": "添加服务分支",
  "非常重要！！！服务将按照当前表格顺序发布，默认顺序为后端基础、后端核心、后端其他、前端基础、前端核心、前端其他，可拖动修改发布顺序。": "非常重要！！！服务将按照当前表格顺序发布，默认顺序为后端基础、后端核心、后端其他、前端基础、前端核心、前端其他，可拖动修改发布顺序。",
  "待发布": "待发布",
  "发布检查": "发布检查",
  "分支检查结果": "分支检查结果",
  "未发布发布单": "未发布发布单",
  "发布单": "发布单",
  "已取消": "已取消",
  "排队中": "排队中",
  "暂无流水线明细": "暂无流水线明细",
  "原发布流水线": "原发布流水线",
  "服务 / 分支": "服务 / 分支",
  "分支：": "分支：",
  "环境：": "环境：",
  "当前发布状态": "当前发布状态",
  "耗时：": "耗时：",
  "部署实际状态": "部署实际状态",
  "前往 K8s 查看": "前往 K8s 查看",
  "发布历史 / 日志": "发布历史 / 日志",
  "保留原发布信息和流水线明细；展开服务可查看流水线。K8s 实际运行情况请点击对应入口，页面每 3 秒自动刷新。": "保留原发布信息和流水线明细；展开服务可查看流水线。K8s 实际运行情况请点击对应入口，页面每 3 秒自动刷新。",
  "查看 K8s 服务详情": "查看 K8s 服务详情",
  "K8s 详情": "K8s 详情",
  "【新加坡生产环境】发布需要走审批流程。（tips：在表格中勾选的服务可被直接代入提交表单）": "【新加坡生产环境】发布需要走审批流程。（tips：在表格中勾选的服务可被直接代入提交表单）",
  "【非生产环境】可以不走正常发布流程。（tips：在表格中勾选的服务可被直接代入提交表单）": "【非生产环境】可以不走正常发布流程。（tips：在表格中勾选的服务可被直接代入提交表单）",
  "申请发布": "申请发布",
  "创建发布": "创建发布",
  "【Hot Fix】可在这提交申请。（tips：1、若【二次发布】提交的服务为首次发布，则发布单发布次数不会加1）2、在表格中勾选的服务可被直接代入提交表单": "【Hot Fix】可在这提交申请。（tips：1、若【二次发布】提交的服务为首次发布，则发布单发布次数不会加1）2、在表格中勾选的服务可被直接代入提交表单",
  "确定要回滚": "确定要回滚",
  "确定要中断部署": "确定要中断部署",
  "点击查看服务部署流水线，（": "点击查看服务部署流水线，（",
  "）个服务正在部署流程中": "）个服务正在部署流程中",
  "（发布成功后发布单将变为【待回归】状态，需要测试回归需求）": "（发布成功后发布单将变为【待回归】状态，需要测试回归需求）",
  "服务代码分支": "服务代码分支",
  "存在以下SQL工单未通过，请确定是否忽略？": "存在以下SQL工单未通过，请确定是否忽略？",
  "请输入发布单名称": "请输入发布单名称",
  "确定一键发布?": "确定一键发布?",
  "一键发布流程创建成功": "一键发布流程创建成功",
  "】 发布单吗？": "】 发布单吗？",
  "】 发布单是否已经完成发布？": "】 发布单是否已经完成发布？",
  "确定后该发布单未发布服务分支将会被删除，状态将会变为【待回归】状态！": "确定后该发布单未发布服务分支将会被删除，状态将会变为【待回归】状态！",
  "确定要验收 【": "确定要验收 【",
  "】 发布单中的所有需求吗？": "】 发布单中的所有需求吗？",
  "操作后发布单状态将更新为【已验收】、需求状态更新为【已关闭】且无法回退": "操作后发布单状态将更新为【已验收】、需求状态更新为【已关闭】且无法回退",
  "确定要拒绝验收 【": "确定要拒绝验收 【",
  "】发布单中的所有需求吗？": "】发布单中的所有需求吗？",
  "操作后发布单状态将变为【验收失败】": "操作后发布单状态将变为【验收失败】",
  "已将发布单分享链接至剪切板": "已将发布单分享链接至剪切板",
  "可以将发布单状态手动设置为【待回归】状态": "可以将发布单状态手动设置为【待回归】状态",
  "手动完成发布": "手动完成发布",
  "查看审批详情": "查看审批详情",
  "回归": "回归",
  "验收": "验收",
  "检查项详情": "检查项详情",
  "操作失败": "操作失败",
  "暂无操作日志": "暂无操作日志",
  "（操作后发布单状态将更新为【待验收】、需求状态更新为【已发布】且无法回退）": "（操作后发布单状态将更新为【待验收】、需求状态更新为【已发布】且无法回退）",
  "需求已经发布成功，请及时进行线上验收并进行结果确认": "需求已经发布成功，请及时进行线上验收并进行结果确认",
  "查看所有": "查看所有",
  "请确认检查项内容": "请确认检查项内容",
  "暂无内容": "暂无内容",
  "更多（+": "更多（+",
  "关联发布单操作（无需操作可直接关闭）": "关联发布单操作（无需操作可直接关闭）",
  "发布单吗？": "发布单吗？",
  "确定要验收": "确定要验收",
  "发布单中的所有需求吗？": "发布单中的所有需求吗？",
  "是否紧急发布": "是否紧急发布",
  "预期发布日期": "预期发布日期",
  "实际发布日期": "实际发布日期",
  "点击查看任务": "点击查看任务",
  "服务分支": "服务分支",
  "关联工作项": "关联工作项",
  "删除发布单": "删除发布单",
  "已生产发布单分享链接至剪切板": "已生产发布单分享链接至剪切板",
  "（下面为任务中未发布的服务分支，提交后将直接发起发布）": "（下面为任务中未发布的服务分支，提交后将直接发起发布）",
  "已指定责任人": "已指定责任人",
  "已指定": "已指定",
  "今日部署：": "今日部署：",
  "今日部署服务数量（与昨日环比情况）": "今日部署服务数量（与昨日环比情况）",
  "部署成功率：": "部署成功率：",
  "今日部署成功的服务数量 / 今日部署服务数量": "今日部署成功的服务数量 / 今日部署服务数量",
  "待部署：": "待部署：",
  "今日创建的发布单中还未部署的服务数量": "今日创建的发布单中还未部署的服务数量",
  "紧急发布：": "紧急发布：",
  "今日紧急发布发布单中的服务总数": "今日紧急发布发布单中的服务总数",
  "今日申请Hot fix的服务数量": "今日申请Hot fix的服务数量",
  "预计明日：": "预计明日：",
  "预计发布时间为明日且未发布的服务数量": "预计发布时间为明日且未发布的服务数量",
  "已回归": "已回归",
  "今日创建的发布单中已回归状态的发布单数量": "今日创建的发布单中已回归状态的发布单数量",
  "待回归": "待回归",
  "今日创建的发布单中待回归状态的发布单数量": "今日创建的发布单中待回归状态的发布单数量",
  "已验收": "已验收",
  "今日创建的发布单中已验收状态的发布单数量": "今日创建的发布单中已验收状态的发布单数量",
  "今日创建的发布单中待发布状态的发布单数量": "今日创建的发布单中待发布状态的发布单数量",
  "上线失败：": "上线失败：",
  "今日创建的发布单中上线失败状态的发布单数量": "今日创建的发布单中上线失败状态的发布单数量",
  "发布窗口期内无需审批即可创建发布单": "发布窗口期内无需审批即可创建发布单",
  "今日部署": "今日部署",
  "部署成功率": "部署成功率",
  "待部署": "待部署",
  "预计明日": "预计明日",
  "待验收": "待验收",
  "上线失败": "上线失败",
  "已复制到剪贴板": "已复制到剪贴板",
  "问题数": "问题数",
  "最新提交问题统计": "最新提交问题统计",
  "规则": "规则",
  "文件路径": "文件路径",
  "发现": "发现",
  "个问题": "个问题",
  "代码提交详情": "代码提交详情",
  "文件代码详情": "文件代码详情",
  "跳转至GitLab": "跳转至GitLab",
  "复制Commit ID": "复制Commit ID",
  "复制文件路径": "复制文件路径",
  "搜索服务": "搜索服务",
  "提交人：": "提交人：",
  "提交信息：": "提交信息：",
  "提交时间：": "提交时间：",
  "请输入...": "请输入...",
  "严重性": "严重性",
  "输入文件路径": "输入文件路径",
  "问题行号": "问题行号",
  "错误信息": "错误信息",
  "早到之星": "早到之星",
  "披星戴月": "披星戴月",
  "迟到最多": "迟到最多",
  "迟到": "迟到",
  "各部门平均工时": "各部门平均工时",
  "最近七天": "最近七天",
  "排名Top 20": "排名Top 20",
  "各部门平均工时排名": "各部门平均工时排名",
  "各岗位平均工时": "各岗位平均工时",
  "各Base地平均工时": "各Base地平均工时",
  "各人员平均工时": "各人员平均工时",
  "人员月度排名Top 20": "人员月度排名Top 20",
  "个人加班工时": "个人加班工时",
  "部门加班工时": "部门加班工时",
  "Base地加班工时": "Base地加班工时",
  "新增/交付需求": "新增/交付需求",
  "近12月内新增需求数、已交付（取值以需求关闭时间）需求数量；": "近12月内新增需求数、已交付（取值以需求关闭时间）需求数量；",
  "线上问题解决时效与数量趋势（横向）": "线上问题解决时效与数量趋势（横向）",
  "线上问题修复时长指标：平均问题修复时长反映了研发过程质量，指标反映了测试缺陷修复效率。": "线上问题修复时长指标：平均问题修复时长反映了研发过程质量，指标反映了测试缺陷修复效率。",
  "1、平均响应耗时=∑（确认时间-指派时间）/n，该耗时越长研发需要改进。": "1、平均响应耗时=∑（确认时间-指派时间）/n，该耗时越长研发需要改进。",
  "2、平均修复耗时=∑（解决时间-确认时间）/n，该耗时越长研发需要改进。": "2、平均修复耗时=∑（解决时间-确认时间）/n，该耗时越长研发需要改进。",
  "3、平均关闭耗时=∑（关闭时间-解决时间）/n，该耗时越长缺陷提交人需要改进。": "3、平均关闭耗时=∑（关闭时间-解决时间）/n，该耗时越长缺陷提交人需要改进。",
  "4、平均修复总耗时=∑（关闭时间-首次指派时间）/n，该耗时越长缺陷提交人需要改进。": "4、平均修复总耗时=∑（关闭时间-首次指派时间）/n，该耗时越长缺陷提交人需要改进。",
  "5、全局平均修复耗时：∑（T1+T2+...+Tn）/ n（缺陷个数），单位时间区间内各系统，业务领域，研发整体测试缺陷解决耗时的平均基线，高于该基线的团队需要改进。": "5、全局平均修复耗时：∑（T1+T2+...+Tn）/ n（缺陷个数），单位时间区间内各系统，业务领域，研发整体测试缺陷解决耗时的平均基线，高于该基线的团队需要改进。",
  "缺陷解决时效与数量趋势（横向）": "缺陷解决时效与数量趋势（横向）",
  "测试缺陷修复时长指标：平均问题修复时长反映了研发过程质量，指标反映了测试缺陷修复效率。": "测试缺陷修复时长指标：平均问题修复时长反映了研发过程质量，指标反映了测试缺陷修复效率。",
  "线上问题解决时效与数量趋势（时间）": "线上问题解决时效与数量趋势（时间）",
  "缺陷解决时效与数量趋势（时间）": "缺陷解决时效与数量趋势（时间）",
  "线上问题新增趋势": "线上问题新增趋势",
  "新增缺陷趋势": "新增缺陷趋势",
  "趋势": "趋势",
  "占比(状态)": "占比(状态)",
  "占比(优先级)": "占比(优先级)",
  "所选时间段内未关闭缺陷优先级占比": "所选时间段内未关闭缺陷优先级占比",
  "按成员排名": "按成员排名",
  "按项目/业务领域排名": "按项目/业务领域排名",
  "\"存量缺陷按系统/领域排名\"这一指标，对全局存量缺陷进行比较，并依据数量进行排名，以观测各研发团队的质量情况。": "\"存量缺陷按系统/领域排名\"这一指标，对全局存量缺陷进行比较，并依据数量进行排名，以观测各研发团队的质量情况。",
  "这个指标的主要价值和意义在于：": "这个指标的主要价值和意义在于：",
  "排名靠前（即存量缺陷多）的团队可能需要进行更深入的代码审查或质量改进。": "排名靠前（即存量缺陷多）的团队可能需要进行更深入的代码审查或质量改进。",
  "风险识别：如果某团队存量缺陷持续较多，那么可能代表该组织需求交付存在一定的风险，研发管理者需要引起注意，进行风险控制。": "风险识别：如果某团队存量缺陷持续较多，那么可能代表该组织需求交付存在一定的风险，研发管理者需要引起注意，进行风险控制。",
  "进展情况：通过查看各团队的存量缺陷排名，存量缺陷多可能说明团队进度较慢，存量缺陷少则可能说明团队进度较快。": "进展情况：通过查看各团队的存量缺陷排名，存量缺陷多可能说明团队进度较慢，存量缺陷少则可能说明团队进度较快。",
  "持续改进：此指标可以作为团队质量持续改进的一种工具，比如用来制定缺陷减少的目标，或者在各个研发组织之间推广成功的优秀实践等。": "持续改进：此指标可以作为团队质量持续改进的一种工具，比如用来制定缺陷减少的目标，或者在各个研发组织之间推广成功的优秀实践等。",
  "每人创建的Bug数": "每人创建的Bug数",
  "每人解决的Bug数": "每人解决的Bug数",
  "每人关闭的Bug数": "每人关闭的Bug数",
  "按Bug严重程度统计": "按Bug严重程度统计",
  "按Bug解决方案统计": "按Bug解决方案统计",
  "按Bug类型统计": "按Bug类型统计",
  "缺陷关闭数": "缺陷关闭数",
  "缺陷新增数": "缺陷新增数",
  "历史缺陷存量": "历史缺陷存量",
  "截至前一天21时未关闭的缺陷数量": "截至前一天21时未关闭的缺陷数量",
  "截至七天前21时未关闭的缺陷数量": "截至七天前21时未关闭的缺陷数量",
  "日清率(%)": "日清率(%)",
  "日清率(含存量)=（今日内缺陷关闭数/（今日新增缺陷数+至今日之前的缺陷存量））*100%": "日清率(含存量)=（今日内缺陷关闭数/（今日新增缺陷数+至今日之前的缺陷存量））*100%",
  "周清率(%)": "周清率(%)",
  "周清率(含存量)=（近7天缺陷关闭数/(近7天新增缺陷数+至7天前的缺陷存量））*100%": "周清率(含存量)=（近7天缺陷关闭数/(近7天新增缺陷数+至7天前的缺陷存量））*100%",
  "截至十四天前21时未关闭的缺陷数量": "截至十四天前21时未关闭的缺陷数量",
  "日清率(含存量)=（昨日缺陷关闭数/（昨日缺陷新增数+至昨日之前的缺陷存量））*100%": "日清率(含存量)=（昨日缺陷关闭数/（昨日缺陷新增数+至昨日之前的缺陷存量））*100%",
  "周清率(含存量)=（近7~14天内缺陷关闭数/（近7~14天内缺陷新增数+至14天前的缺陷存量））*100%": "周清率(含存量)=（近7~14天内缺陷关闭数/（近7~14天内缺陷新增数+至14天前的缺陷存量））*100%",
  "实时缺陷数据统计": "实时缺陷数据统计",
  "日清率": "日清率",
  "周清率": "周清率",
  "历史列表": "历史列表",
  "返回实时数据": "返回实时数据",
  "总共": "总共",
  "展示条数": "展示条数",
  "代码提交规范率趋势": "代码提交规范率趋势",
  "代码提交规范率排行": "代码提交规范率排行",
  "点击查看CR详情": "点击查看CR详情",
  "关闭搜索": "关闭搜索",
  "展开搜索": "展开搜索",
  "导出数据": "导出数据",
  "下载文件失败：": "下载文件失败：",
  "总体需求数量（自然年）": "总体需求数量（自然年）",
  "年度累计交付需求总量": "年度累计交付需求总量",
  "年度累计交付需求需满足以下条件：": "年度累计交付需求需满足以下条件：",
  "1）需求状态为：已发布、已关闭；": "1）需求状态为：已发布、已关闭；",
  "2）需求发布时间在本年1月1日至今天之间；": "2）需求发布时间在本年1月1日至今天之间；",
  "3）不包括技术需求。": "3）不包括技术需求。",
  "年度累计新增需求总量": "年度累计新增需求总量",
  "年度累计新增需求需满足以下条件：": "年度累计新增需求需满足以下条件：",
  "1）需求创建时间在本年1月1日至今天之间；": "1）需求创建时间在本年1月1日至今天之间；",
  "2）不包括技术需求。": "2）不包括技术需求。",
  "当前需求存量": "当前需求存量",
  "当前需求存量需满足以下条件：": "当前需求存量需满足以下条件：",
  "1）需求状态不包括：已发布、已关闭；": "1）需求状态不包括：已发布、已关闭；",
  "当周需求数量（自然周）": "当周需求数量（自然周）",
  "当周交付需求数": "当周交付需求数",
  "当周交付需求需满足以下条件：": "当周交付需求需满足以下条件：",
  "2）需求发布时间晚于上周日；": "2）需求发布时间晚于上周日；",
  "当周新增需求数": "当周新增需求数",
  "当周新增需求需满足以下条件：": "当周新增需求需满足以下条件：",
  "1）需求发布时间在本周一至今天之间；": "1）需求发布时间在本周一至今天之间；",
  "需求准入数量": "需求准入数量",
  "超1个月未准入需求数": "超1个月未准入需求数",
  "超1个月未准入需求需满足以下条件：": "超1个月未准入需求需满足以下条件：",
  "1）需求状态为：待介入；": "1）需求状态为：待介入；",
  "2）需求创建时间早于近1月（相对于今天）的最后一天；": "2）需求创建时间早于近1月（相对于今天）的最后一天；",
  "近1周准入通过需求数": "近1周准入通过需求数",
  "近1周准入通过需求需满足以下条件：": "近1周准入通过需求需满足以下条件：",
  "1）需求状态从待介入（产品需求以产品方案中等状态代替）更新为其他状态（不包含已取消）；": "1）需求状态从待介入（产品需求以产品方案中等状态代替）更新为其他状态（不包含已取消）；",
  "进入研发需求数量": "进入研发需求数量",
  "超1个月待排期需求数": "超1个月待排期需求数",
  "超1个月待排期需求需满足以下条件：": "超1个月待排期需求需满足以下条件：",
  "1）需求状态不包括已取消及已排期之前的需求状态；": "1）需求状态不包括已取消及已排期之前的需求状态；",
  "近1周排期需求数": "近1周排期需求数",
  "近1周排期需求需满足以下条件：": "近1周排期需求需满足以下条件：",
  "1）已排期状态更新时间为：近1周（相对于今天的上1周时间范围）；": "1）已排期状态更新时间为：近1周（相对于今天的上1周时间范围）；",
  "实时需求数据统计": "实时需求数据统计",
  "如果选择了多个业务领域或系统，那预估结果为所选": "如果选择了多个业务领域或系统，那预估结果为所选",
  "与": "与",
  "的聚合结果": "的聚合结果",
  "获取预估结果失败": "获取预估结果失败",
  "请至少选择一个筛选条件": "请至少选择一个筛选条件",
  "已设为默认筛选条件": "已设为默认筛选条件",
  "操作区": "操作区",
  "新需求交付时间预估": "新需求交付时间预估",
  "产品需求概览": "产品需求概览",
  "产品需求看板": "产品需求看板",
  "预估完成时间": "预估完成时间",
  "未来8周整体资源使用情况": "未来8周整体资源使用情况",
  "资源利用率计算说明": "资源利用率计算说明",
  "📊 计算公式": "📊 计算公式",
  "(角色人员任务排期已覆盖的工作日数 /": "(角色人员任务排期已覆盖的工作日数 /",
  "(当周工作日数 × 角色人员数量)) × 100%": "(当周工作日数 × 角色人员数量)) × 100%",
  "💡 示例说明": "💡 示例说明",
  "• 当前系统下有": "• 当前系统下有",
  "2 个前端": "2 个前端",
  "• 本周有": "• 本周有",
  "5 个工作日": "5 个工作日",
  "，总人天为": "，总人天为",
  "• 任务排期分别覆盖了": "• 任务排期分别覆盖了",
  "和": "和",
  "个工作日": "个工作日",
  "➜ 前端投入人天为 5，资源利用率为": "➜ 前端投入人天为 5，资源利用率为",
  "研发角色资源明细": "研发角色资源明细",
  "未来第几周忙不忙？": "未来第几周忙不忙？",
  "📋 产品经理角色": "📋 产品经理角色",
  "1. 计算该产品经理最近 90 天的业务需求介入速率": "1. 计算该产品经理最近 90 天的业务需求介入速率",
  "例如：3 天/个": "例如：3 天/个",
  "2. 计算预估介入完成时间": "2. 计算预估介入完成时间",
  "未介入业务需求数 × 介入速率": "未介入业务需求数 × 介入速率",
  "3. 判断：当前时间 &gt; 预估完成时间 → 不忙": "3. 判断：当前时间 &gt; 预估完成时间 → 不忙",
  "💻 研发与测试角色": "💻 研发与测试角色",
  "指定周工作日内任务排期时间未排满 → 不忙": "指定周工作日内任务排期时间未排满 → 不忙",
  "指定周工作日内任务排期时间已排满 → 忙": "指定周工作日内任务排期时间已排满 → 忙",
  "任务数：": "任务数：",
  "业务需求数：": "业务需求数：",
  "数量：": "数量：",
  "职位:": "职位:",
  "暂无角色资源数据": "暂无角色资源数据",
  "未来第几周:": "未来第几周:",
  "繁忙人员": "繁忙人员",
  "空闲人员": "空闲人员",
  "繁忙率": "繁忙率",
  "繁忙人员:": "繁忙人员:",
  "空闲人员:": "空闲人员:",
  "健康度雷达图": "健康度雷达图",
  "获取系统列表失败:": "获取系统列表失败:",
  "重置筛选": "重置筛选",
  "业务领域不能为空": "业务领域不能为空",
  "业务满意度(0-4)": "业务满意度(0-4)",
  "删除原因": "删除原因",
  "已创建": "已创建",
  "预估工时（人天）": "预估工时（人天）",
  "部分任务类型默认不展示": "部分任务类型默认不展示",
  "实际工时（人天）": "实际工时（人天）",
  "成本分析": "成本分析",
  "成本月对比": "成本月对比",
  "成本分布": "成本分布",
  "提交失败，请检查必填项": "提交失败，请检查必填项",
  "请选择要添加的指标": "请选择要添加的指标",
  "所选指标已全部存在，请选择其他指标": "所选指标已全部存在，请选择其他指标",
  "指标描述：": "指标描述：",
  "暂无描述": "暂无描述",
  "指标极性：": "指标极性：",
  "正向指标": "正向指标",
  "负向指标": "负向指标",
  "权重值": "权重值",
  "请输入权重值": "请输入权重值",
  "权重值不能小于0": "权重值不能小于0",
  "权重值不能大于100": "权重值不能大于100",
  "满分线": "满分线",
  "请输入满分线": "请输入满分线",
  "满分线不能小于0": "满分线不能小于0",
  "零分线": "零分线",
  "请输入零分线": "请输入零分线",
  "零分线不能小于0": "零分线不能小于0",
  "指标顺序已更新": "指标顺序已更新",
  "新建模型": "新建模型",
  "编辑模型": "编辑模型",
  "查看模型详情": "查看模型详情",
  "模型基础信息": "模型基础信息",
  "模型名称": "模型名称",
  "请输入模型名称": "请输入模型名称",
  "模型名称不能超过100个字符": "模型名称不能超过100个字符",
  "基础分": "基础分",
  "请输入基础分": "请输入基础分",
  "基础分不能小于0": "基础分不能小于0",
  "基础分不能大于100": "基础分不能大于100",
  "请选择关联的业务领域（支持多选）": "请选择关联的业务领域（支持多选）",
  "请选择关联业务领域": "请选择关联业务领域",
  "模型指标配置": "模型指标配置",
  "请为以下指标配置权重值、满分线和零分线": "请为以下指标配置权重值、满分线和零分线",
  "请选择要添加的指标（支持多选）": "请选择要添加的指标（支持多选）",
  "批量添加指标 (": "批量添加指标 (",
  "个指标，点击按钮批量添加": "个指标，点击按钮批量添加",
  "获取团队汇总数据失败": "获取团队汇总数据失败",
  "获取团队汇总数据失败:": "获取团队汇总数据失败:",
  "🏢 业务领域": "🏢 业务领域",
  "📅 年月": "📅 年月",
  "实际值": "实际值",
  "实际分": "实际分",
  "加权得分": "加权得分",
  "⚠️ 事故扣分": "⚠️ 事故扣分",
  "📊 总加权得分": "📊 总加权得分",
  "📈 同比变化": "📈 同比变化",
  "正在加载团队汇总数据...": "正在加载团队汇总数据...",
  "📊 数据概览": "📊 数据概览",
  "🎯 当前平均分": "🎯 当前平均分",
  "📈 环比变化": "📈 环比变化",
  "📊 去年同期": "📊 去年同期",
  "📊 同比变化": "📊 同比变化",
  "🏆 得分排名": "🏆 得分排名",
  "汇总平均": "汇总平均",
  "📡 效能指标雷达图": "📡 效能指标雷达图",
  "🏢 选择业务领域:": "🏢 选择业务领域:",
  "当前指标得分（加权得分）": "当前指标得分（加权得分）",
  "同比指标对比（加权得分）": "同比指标对比（加权得分）",
  "暂无雷达图数据，请先选择一个业务领域查看指标对比": "暂无雷达图数据，请先选择一个业务领域查看指标对比",
  "创建效能评分模型": "创建效能评分模型",
  "获取团队详情数据失败": "获取团队详情数据失败",
  "获取团队详情数据失败:": "获取团队详情数据失败:",
  "正在加载团队数据...": "正在加载团队数据...",
  "请先选择业务领域": "请先选择业务领域",
  "在筛选条件中选择一个业务领域以查看团队详情数据": "在筛选条件中选择一个业务领域以查看团队详情数据",
  "📊 年度数据概览": "📊 年度数据概览",
  "月": "月",
  "平均分": "平均分",
  "📈 年度提升": "📈 年度提升",
  "🏆 最高月份（": "🏆 最高月份（",
  "⚠️ 最低月份（": "⚠️ 最低月份（",
  "📈 月度得分趋势": "📈 月度得分趋势",
  "📅 月度得分详情": "📅 月度得分详情",
  "📅 选择月份（多选，不选则显示所有月份）:": "📅 选择月份（多选，不选则显示所有月份）:",
  "请选择月份，不选则显示所有月份数据": "请选择月份，不选则显示所有月份数据",
  "年度平均指标对比（加权得分）": "年度平均指标对比（加权得分）",
  "暂无雷达图数据": "暂无雷达图数据",
  "暂无选中月份的雷达图数据，请选择其他月份或清空选择查看所有月份数据": "暂无选中月份的雷达图数据，请选择其他月份或清空选择查看所有月份数据",
  "您不是业务领域负责人，无法查看": "您不是业务领域负责人，无法查看",
  "您不是业务领域负责人，无法查询团队视图": "您不是业务领域负责人，无法查询团队视图",
  "查询已触发": "查询已触发",
  "全局视图数据已刷新": "全局视图数据已刷新",
  "团队视图数据已刷新": "团队视图数据已刷新",
  "请选择时间范围": "请选择时间范围",
  "团队视图": "团队视图",
  "全局视图": "全局视图",
  "还没有效能评分模型哦": "还没有效能评分模型哦",
  "立即创建": "立即创建",
  "💯 满分部门（100%）": "💯 满分部门（100%）",
  "👍 优秀部门（≥90%）": "👍 优秀部门（≥90%）",
  "💔 待改进部门（＜90%）": "💔 待改进部门（＜90%）",
  "指标/部门": "指标/部门",
  "确认关闭": "确认关闭",
  "请至少选择一个邮件接收人": "请至少选择一个邮件接收人",
  "邮件发送成功": "邮件发送成功",
  "提交失败，请重试": "提交失败，请重试",
  "选择邮件收件人": "选择邮件收件人",
  "是否发送水印图表": "是否发送水印图表",
  "水印图表异步发送，存在失败的情况，且发送时间较长，请谨慎发送": "水印图表异步发送，存在失败的情况，且发送时间较长，请谨慎发送",
  "请输入有效的邮箱地址": "请输入有效的邮箱地址",
  "需求吞吐量趋势（业务领域）": "需求吞吐量趋势（业务领域）",
  "统计口径：当月已发布/当月新增*100%": "统计口径：当月已发布/当月新增*100%",
  "交付需求数（个）": "交付需求数（个）",
  "创建需求数（个）": "创建需求数（个）",
  "未完成需求数（个）": "未完成需求数（个）",
  "吞吐率平均值（%）": "吞吐率平均值（%）",
  "高于平均吞吐率的业务领域 (共": "高于平均吞吐率的业务领域 (共",
  "个, 上期": "个, 上期",
  "个 )": "个 )",
  "连续2个月高于平均值的业务领域": "连续2个月高于平均值的业务领域",
  "技术需求占比": "技术需求占比",
  "统计口径：当月发布技术需求/当月发布总需求*100%": "统计口径：当月发布技术需求/当月发布总需求*100%",
  "技术需求交付占比平均值(%)": "技术需求交付占比平均值(%)",
  "技术需求占比最多": "技术需求占比最多",
  "技术需求占比最少": "技术需求占比最少",
  "开发交付周期": "开发交付周期",
  "统计口径：已发布时间-产品阶段结束时间": "统计口径：已发布时间-产品阶段结束时间",
  "所有类型需求平均交付周期(天)": "所有类型需求平均交付周期(天)",
  "产品需求平均交付周期(天)": "产品需求平均交付周期(天)",
  "技术需求平均交付周期(天)": "技术需求平均交付周期(天)",
  "产品需求开发交付周期最长": "产品需求开发交付周期最长",
  "技术需求开发交付周期最长": "技术需求开发交付周期最长",
  "产品需求开发交付周期最短": "产品需求开发交付周期最短",
  "技术需求开发交付周期最短": "技术需求开发交付周期最短",
  "交付需求的创建时间分布": "交付需求的创建时间分布",
  "bug关闭与新增情况": "bug关闭与新增情况",
  "统计口径：bug关闭占比=当月bug关闭数/新增数": "统计口径：bug关闭占比=当月bug关闭数/新增数",
  "关闭总数(个)": "关闭总数(个)",
  "新增总数(个)": "新增总数(个)",
  "各领域关闭占比平均值(%)": "各领域关闭占比平均值(%)",
  "关闭bug创建时间分布": "关闭bug创建时间分布",
  "bug类型及业务领域占比": "bug类型及业务领域占比",
  "线上bug逃逸率（按照逃逸率降序排序）": "线上bug逃逸率（按照逃逸率降序排序）",
  "统计口径：线上bug关闭数/(过程bug关闭数+线上bug关闭数)*100%": "统计口径：线上bug关闭数/(过程bug关闭数+线上bug关闭数)*100%",
  "bug逃逸率平均值(%)": "bug逃逸率平均值(%)",
  "逃逸率最高": "逃逸率最高",
  "逃逸率最低": "逃逸率最低",
  "bug关闭时效": "bug关闭时效",
  "平均响应耗时=∑(确认时间-指派时间)/bug关闭数 该耗时越长研发需要改进": "平均响应耗时=∑(确认时间-指派时间)/bug关闭数 该耗时越长研发需要改进",
  "平均修复耗时=∑(解决时间-确认时间)/bug关闭数 该耗时越长研发需要改进": "平均修复耗时=∑(解决时间-确认时间)/bug关闭数 该耗时越长研发需要改进",
  "平均关闭耗时=∑(关闭时间-解决时间)/bug关闭数 该耗时越长缺陷提交人需要改进": "平均关闭耗时=∑(关闭时间-解决时间)/bug关闭数 该耗时越长缺陷提交人需要改进",
  "指标统计说明": "指标统计说明",
  "所有bug平均关闭时效(天)": "所有bug平均关闭时效(天)",
  "有效线上bug平均关闭时效(天)": "有效线上bug平均关闭时效(天)",
  "平均关闭时效最长": "平均关闭时效最长",
  "平均关闭时效最短": "平均关闭时效最短",
  "关闭bug总数(个)": "关闭bug总数(个)",
  "关闭量占比(%)": "关闭量占比(%)",
  "有效bug关闭数(个)": "有效bug关闭数(个)",
  "生产事故概况": "生产事故概况",
  "事故总数(个)": "事故总数(个)",
  "事故归属业务领域": "事故归属业务领域",
  "事故级别分布": "事故级别分布",
  "原因类型分布": "原因类型分布",
  "月度事故分布": "月度事故分布",
  "生产事故改进情况": "生产事故改进情况",
  "措施总数": "措施总数",
  "超期未完成": "超期未完成",
  "改进措施分布情况": "改进措施分布情况",
  "事故负责人改进状态分布图": "事故负责人改进状态分布图",
  "需求分析": "需求分析",
  "需求吞吐量趋势": "需求吞吐量趋势",
  "过程缺陷分析": "过程缺陷分析",
  "线上bug分析": "线上bug分析",
  "线上bug关闭与新增情况": "线上bug关闭与新增情况",
  "线上bug创建时间分布": "线上bug创建时间分布",
  "线上bug类型及业务领域占比": "线上bug类型及业务领域占比",
  "线上bug关闭时效": "线上bug关闭时效",
  "线上bug逃逸率": "线上bug逃逸率",
  "生产事故落地进展": "生产事故落地进展",
  "研发数据分析": "研发数据分析",
  "需求吞吐量": "需求吞吐量",
  "交付需求的创建时间分布 (按当月发布需求总数降序排列)": "交付需求的创建时间分布 (按当月发布需求总数降序排列)",
  "bug关闭与新增情况（按照bug关闭占比降序排序）": "bug关闭与新增情况（按照bug关闭占比降序排序）",
  "关闭bug创建时间分布（按照关闭bug数降序排序）": "关闭bug创建时间分布（按照关闭bug数降序排序）",
  "bug类型占比": "bug类型占比",
  "bug业务领域占比": "bug业务领域占比",
  "bug关闭时效（按照总体关闭时间降序排序）": "bug关闭时效（按照总体关闭时间降序排序）",
  "线上bug关闭与新增情况（按照bug关闭占比降序排序）": "线上bug关闭与新增情况（按照bug关闭占比降序排序）",
  "线上bug创建时间分布（按照线上bug数降序排序）": "线上bug创建时间分布（按照线上bug数降序排序）",
  "线上bug执行方案占比": "线上bug执行方案占比",
  "线上bug有效占比": "线上bug有效占比",
  "线上bug类型占比": "线上bug类型占比",
  "线上bug业务领域占比": "线上bug业务领域占比",
  "线上bug关闭时效（按照关闭时间降序排序）": "线上bug关闭时效（按照关闭时间降序排序）",
  "研发管理荣誉榜": "研发管理荣誉榜",
  "代码提交规范率部门排行": "代码提交规范率部门排行",
  "上期": "上期",
  "超平均": "超平均",
  "交付需求数": "交付需求数",
  "吞吐率": "吞吐率",
  "关闭bug数": "关闭bug数",
  "关闭占比（关闭数/新增数）": "关闭占比（关闭数/新增数）",
  "关闭量": "关闭量",
  "关闭量占比": "关闭量占比",
  "新增bug数": "新增bug数",
  "交付需求数量TOP3": "交付需求数量TOP3",
  "关闭bug总数TOP3": "关闭bug总数TOP3",
  "占比最多TOP3": "占比最多TOP3",
  "占比最少TOP3": "占比最少TOP3",
  "新增bug总数TOP3": "新增bug总数TOP3",
  "正在生成邮件报告（请勿关闭页面），请稍后...": "正在生成邮件报告（请勿关闭页面），请稍后...",
  "月报已生成,请选择发送邮件人": "月报已生成,请选择发送邮件人",
  "处理失败:": "处理失败:",
  "分享链接已复制到剪贴板": "分享链接已复制到剪贴板",
  "发送邮件": "发送邮件",
  "业务指标看板": "业务指标看板",
  "仅主管指标": "仅主管指标",
  "业务领域（可多选）": "业务领域（可多选）",
  "系统（可多选）": "系统（可多选）",
  "指标（可多选）": "指标（可多选）",
  "刷新当前视图": "刷新当前视图",
  "展示业务指标当前值，并提供往年同比（%）对照（": "展示业务指标当前值，并提供往年同比（%）对照（",
  "当前范围暂无可展示指标": "当前范围暂无可展示指标",
  "同比": "同比",
  "环比": "环比",
  "当期平均": "当期平均",
  "往年同期": "往年同期",
  "小贴士：点击卡片可查看业务指标趋势的明细数据": "小贴士：点击卡片可查看业务指标趋势的明细数据",
  "数据更新于": "数据更新于",
  "个人指标看板": "个人指标看板",
  "角色（可多选）": "角色（可多选）",
  "展示个人指标当前值，并提供往年同比（%）对照（": "展示个人指标当前值，并提供往年同比（%）对照（",
  "小贴士：点击卡片可查看指标趋势的明细数据": "小贴士：点击卡片可查看指标趋势的明细数据",
  "业务领域名称": "业务领域名称",
  "当前范围暂无可展示数据": "当前范围暂无可展示数据",
  "岗位名": "岗位名",
  "业务汇总": "业务汇总",
  "人员汇总": "人员汇总",
  "导出 Excel": "导出 Excel",
  "展示汇总统计表格数据，支持业务汇总与人员汇总视图切换": "展示汇总统计表格数据，支持业务汇总与人员汇总视图切换",
  "岗位（可多选）": "岗位（可多选）",
  "人员（可多选）": "人员（可多选）",
  "均值": "均值",
  "点击角色卡片可筛选下方表格，再次点击当前角色可恢复全部": "点击角色卡片可筛选下方表格，再次点击当前角色可恢复全部",
  "配置成员": "配置成员",
  "配置团队成员": "配置团队成员",
  "团队名称": "团队名称",
  "给团队起个名字": "给团队起个名字",
  "保存团队": "保存团队",
  "请先填写团队名称": "请先填写团队名称",
  "团队配置已保存": "团队配置已保存",
  "团队配置保存失败，请稍后重试": "团队配置保存失败，请稍后重试",
  "团队指标看板": "团队指标看板",
  "暂未配置团队名称": "暂未配置团队名称",
  "导出所有角色人员指标明细": "导出所有角色人员指标明细",
  "导出": "导出",
  "团队整体视图": "团队整体视图",
  "人员明细视图": "人员明细视图",
  "第一步：点击这里配置团队": "第一步：点击这里配置团队",
  "请先配置团队成员": "请先配置团队成员",
  "先补齐产品、研发、测试成员，再查看团队指标。": "先补齐产品、研发、测试成员，再查看团队指标。",
  "配置团队": "配置团队",
  "团队": "团队",
  "小贴士：先配置团队角色成员，再查看团队维度指标趋势与变化": "小贴士：先配置团队角色成员，再查看团队维度指标趋势与变化",
  "里程碑记录": "里程碑记录",
  "需求记录": "需求记录",
  "缺陷记录": "缺陷记录",
  "事故记录": "事故记录",
  "技术债务记录": "技术债务记录",
  "指标详情": "指标详情",
  "暂无指标详情": "暂无指标详情",
  "提示：点击柱子可查看记录明细": "提示：点击柱子可查看记录明细",
  "当前区间暂无趋势数据": "当前区间暂无趋势数据",
  "选择部门": "选择部门",
  "请选择本部门线中的部门": "请选择本部门线中的部门",
  "单独选人": "单独选人",
  "可单独选择人员，与部门选择取并集": "可单独选择人员，与部门选择取并集",
  "选择人员": "选择人员",
  "已自动选择人员，可继续调整": "已自动选择人员，可继续调整",
  "请先选择部门或单独选人": "请先选择部门或单独选人",
  "已选": "已选",
  "紧急发布 & HotFix趋势": "紧急发布 & HotFix趋势",
  "总次数": "总次数",
  "窗口期发布次数": "窗口期发布次数",
  "成功次数": "成功次数",
  "成功率（%）": "成功率（%）",
  "研发平均交付周期（Day）": "研发平均交付周期（Day）",
  "需求在各阶段的停留时长之和的平均值，指需求交付之前，从研发开始到结束所经历的时间；（不包含技术类需求）": "需求在各阶段的停留时长之和的平均值，指需求交付之前，从研发开始到结束所经历的时间；（不包含技术类需求）",
  "需求数量排名": "需求数量排名",
  "平均交付周期（Day）": "平均交付周期（Day）",
  "需求在各阶段的停留时长之和的平均值，指需求交付之前，从开始到结束所经历的时间；（不包含技术类需求）": "需求在各阶段的停留时长之和的平均值，指需求交付之前，从开始到结束所经历的时间；（不包含技术类需求）",
  "需求分布图": "需求分布图",
  "按日": "按日",
  "按周": "按周",
  "按月": "按月",
  "执行人类型：": "执行人类型：",
  "选择执行人类型": "选择执行人类型",
  "执行人：": "执行人：",
  "选择执行人": "选择执行人",
  "复杂度：": "复杂度：",
  "选择复杂度": "选择复杂度",
  "优先级：": "优先级：",
  "选择优先级": "选择优先级",
  "需求延期交付数": "需求延期交付数",
  "需求延期交付数：": "需求延期交付数：",
  "1、需求交付月度指标，预计到期日为当月的需求（需求已发布时间-预计到期日&lt;0的数量累计，即为延期交付数量。": "1、需求交付月度指标，预计到期日为当月的需求（需求已发布时间-预计到期日&lt;0的数量累计，即为延期交付数量。",
  "2、平均需求延期交付时间，根据系统或者领域，或者全局选择，需求延期交付时间的平均值。": "2、平均需求延期交付时间，根据系统或者领域，或者全局选择，需求延期交付时间的平均值。",
  "新增需求趋势": "新增需求趋势",
  "新增需求趋势：": "新增需求趋势：",
  "本指标反映各团队的新增需求数量的变化趋势，期待新增需求持续输入且数量相对稳定，若需求数量（story points）新增较多，需要考虑研发资源与交付时效是否可以按期完成。": "本指标反映各团队的新增需求数量的变化趋势，期待新增需求持续输入且数量相对稳定，若需求数量（story points）新增较多，需要考虑研发资源与交付时效是否可以按期完成。",
  "存量需求趋势": "存量需求趋势",
  "存量需求趋势：": "存量需求趋势：",
  "所选时间区间项目尚未完成需求的数量和，存量需求趋势 = （当前期的存量需求 - 前一期的存量需求） / 前一期的存量需求，其列成一个时间序列。如果存量需求呈现上升趋势，需要考虑研发资源分配和交付时效，反之亦然。": "所选时间区间项目尚未完成需求的数量和，存量需求趋势 = （当前期的存量需求 - 前一期的存量需求） / 前一期的存量需求，其列成一个时间序列。如果存量需求呈现上升趋势，需要考虑研发资源分配和交付时效，反之亦然。",
  "存量需求占比(状态)": "存量需求占比(状态)",
  "所选时间段内未关闭需求各状态占比": "所选时间段内未关闭需求各状态占比",
  "存量需求占比(优先级)": "存量需求占比(优先级)",
  "所选时间段内未关闭需求优先级占比": "所选时间段内未关闭需求优先级占比",
  "需求交付时长分布": "需求交付时长分布",
  "需求交付时长分布：": "需求交付时长分布：",
  "所选时间区间内完成的需求，按完成日期排列，并分别统计每日完成需求从创建到完成的耗时时长分布。有助于团队了解需求交付的速度和效率，并从中找出可能存在的问题和瓶颈。": "所选时间区间内完成的需求，按完成日期排列，并分别统计每日完成需求从创建到完成的耗时时长分布。有助于团队了解需求交付的速度和效率，并从中找出可能存在的问题和瓶颈。",
  "需求趋势": "需求趋势",
  "需求趋势：": "需求趋势：",
  "需求趋势指标用于衡量在一段特定时间内需求的变化趋势。该图表会显示每天新增、发布需求数量以及仍然活跃的或未解决的需求数量（通常称为\"需求存量\"），故我们的需求颗粒度标准需要统一。": "需求趋势指标用于衡量在一段特定时间内需求的变化趋势。该图表会显示每天新增、发布需求数量以及仍然活跃的或未解决的需求数量（通常称为\"需求存量\"），故我们的需求颗粒度标准需要统一。",
  "需求阶段数量累积": "需求阶段数量累积",
  "需求阶段累积（数量）：": "需求阶段累积（数量）：",
  "截止所选时间段内各个需求阶段的数量累积": "截止所选时间段内各个需求阶段的数量累积",
  "需求阶段耗时累积": "需求阶段耗时累积",
  "需求阶段累积（耗时）：": "需求阶段累积（耗时）：",
  "截止所选时间段内各个需求阶段的耗时累积": "截止所选时间段内各个需求阶段的耗时累积",
  "选择来源": "选择来源",
  "平均时效": "平均时效",
  "平均时效:": "平均时效:",
  "已完成处理": "已完成处理",
  "待处理": "待处理",
  "获取点赞详情数据失败": "获取点赞详情数据失败",
  "获取点赞详情数据失败:": "获取点赞详情数据失败:",
  "正向": "正向",
  "中性": "中性",
  "负面": "负面",
  "显示所有类型的反馈": "显示所有类型的反馈",
  "等待处理的反馈": "等待处理的反馈",
  "已经处理完成的反馈": "已经处理完成的反馈",
  "当前用户提交的反馈": "当前用户提交的反馈",
  "图标": "图标",
  "Tab名称": "Tab名称",
  "Tab代码": "Tab代码",
  "默认Tab": "默认Tab",
  "App Tab页配置": "App Tab页配置",
  "管理移动端App中反馈页面的Tab标签配置": "管理移动端App中反馈页面的Tab标签配置",
  "搜索Tab名称或代码": "搜索Tab名称或代码",
  "新增Tab": "新增Tab",
  "配置已删除": "配置已删除",
  "编辑功能待实现": "编辑功能待实现",
  "配置详情": "配置详情",
  "反馈来源:": "反馈来源:",
  "反馈国家:": "反馈国家:",
  "一级类型数量:": "一级类型数量:",
  "二级类型数量:": "二级类型数量:",
  "清空筛选": "清空筛选",
  "中文内容为必填项，请填写中文内容": "中文内容为必填项，请填写中文内容",
  "英文内容为必填项，请填写英文内容": "英文内容为必填项，请填写英文内容",
  "规则中的反馈来源和默认负责人均为必填项": "规则中的反馈来源和默认负责人均为必填项",
  "同一类型下不能配置相同来源的规则": "同一类型下不能配置相同来源的规则",
  "编辑反馈类型成功": "编辑反馈类型成功",
  "新增反馈类型成功": "新增反馈类型成功",
  "请输入Code": "请输入Code",
  "命名规则：全大写字母，单词之间使用下划线分隔": "命名规则：全大写字母，单词之间使用下划线分隔",
  "请输入Code（例如：PRODUCT_ISSUE）": "请输入Code（例如：PRODUCT_ISSUE）",
  "命名规则：只能包含大写字母，单词之间使用下划线分隔，例如：PRODUCT_ISSUE": "命名规则：只能包含大写字母，单词之间使用下划线分隔，例如：PRODUCT_ISSUE",
  "配置级别": "配置级别",
  "请选择配置级别": "请选择配置级别",
  "主配置": "主配置",
  "次配置": "次配置",
  "自定义规则配置": "自定义规则配置",
  "多语言内容": "多语言内容",
  "内容（必填）": "内容（必填）",
  "内容": "内容",
  "描述（选填）": "描述（选填）",
  "排序号": "排序号",
  "默认负责人": "默认负责人",
  "关注人": "关注人",
  "已配置规则的来源": "已配置规则的来源",
  "语言内容包": "语言内容包",
  "个语言": "个语言",
  "属性删除成功": "属性删除成功",
  "获取属性列表失败:": "获取属性列表失败:",
  "获取属性列表失败": "获取属性列表失败",
  "批量添加属性失败:": "批量添加属性失败:",
  "批量添加属性失败": "批量添加属性失败",
  "删除属性失败:": "删除属性失败:",
  "删除属性失败": "删除属性失败",
  "添加子节点": "添加子节点",
  "请选择要添加的属性": "请选择要添加的属性",
  "批量添加": "批量添加",
  "父节点：": "父节点：",
  "搜索属性名称...": "搜索属性名称...",
  "项，已选择": "项，已选择",
  "项": "项",
  "清除成功": "清除成功",
  "清除失败:": "清除失败:",
  "清除失败": "清除失败",
  "不能复制到自己": "不能复制到自己",
  "💡 提示：已配置的单元格可以拖拽复制到其他单元格，未配置的单元格可以作为拖拽目标": "💡 提示：已配置的单元格可以拖拽复制到其他单元格，未配置的单元格可以作为拖拽目标",
  "正在复制:": "正在复制:",
  "一级:": "一级:",
  "二级:": "二级:",
  "总数:": "总数:",
  "未配置": "未配置",
  "编辑配置": "编辑配置",
  "确定要一键复制该来源配置到所有空白配置的国家与来源吗？": "确定要一键复制该来源配置到所有空白配置的国家与来源吗？",
  "一键复制": "一键复制",
  "确定要清除此配置吗？": "确定要清除此配置吗？",
  "清除配置": "清除配置",
  "添加配置": "添加配置",
  "获取FAQ详情失败:": "获取FAQ详情失败:",
  "删除FAQ配置失败:": "删除FAQ配置失败:",
  "该FAQ暂无语言包配置": "该FAQ暂无语言包配置",
  "问题内容": "问题内容",
  "答案内容": "答案内容",
  "语言包数量": "语言包数量",
  "确定要删除这条FAQ配置吗？": "确定要删除这条FAQ配置吗？",
  "FAQ管理": "FAQ管理",
  "请输入问题标题、内容或答案": "请输入问题标题、内容或答案",
  "新增FAQ": "新增FAQ",
  "反馈来源": "反馈来源",
  "请选择反馈来源": "请选择反馈来源",
  "请选择默认负责人": "请选择默认负责人",
  "请选择关注人": "请选择关注人",
  "默认无需处理": "默认无需处理",
  "是否默认无需处理": "是否默认无需处理",
  "添加规则": "添加规则",
  "语言内容详情": "语言内容详情",
  "暂无语言内容": "暂无语言内容",
  "新增成功": "新增成功",
  "编辑功能": "编辑功能",
  "新增功能": "新增功能",
  "命名规则：只能包含大写字母，单词之间使用下划线分隔，例如：FUNCTION_SWITCH": "命名规则：只能包含大写字母，单词之间使用下划线分隔，例如：FUNCTION_SWITCH",
  "请输入Code（例如：FUNCTION_SWITCH）": "请输入Code（例如：FUNCTION_SWITCH）",
  "删除配置成功": "删除配置成功",
  "删除配置失败": "删除配置失败",
  "配置类型": "配置类型",
  "消息群ID": "消息群ID",
  "确定要删除这条配置吗？": "确定要删除这条配置吗？",
  "基础数据配置": "基础数据配置",
  "如国家、来源、站点等基础配置信息": "如国家、来源、站点等基础配置信息",
  "请输入展示内容或配置值": "请输入展示内容或配置值",
  "配置类型:": "配置类型:",
  "请选择配置类型": "请选择配置类型",
  "新增配置": "新增配置",
  "编辑配置成功": "编辑配置成功",
  "新增配置成功": "新增配置成功",
  "请输入消息群ID": "请输入消息群ID",
  "获取FAQ详情失败": "获取FAQ详情失败",
  "删除FAQ配置成功": "删除FAQ配置成功",
  "删除FAQ配置失败": "删除FAQ配置失败",
  "FAQ配置": "FAQ配置",
  "管理常见问题解答，支持多语言配置": "管理常见问题解答，支持多语言配置",
  "中文问题和答案为必填项，请填写中文内容": "中文问题和答案为必填项，请填写中文内容",
  "英文问题和答案为必填项，请填写英文内容": "英文问题和答案为必填项，请填写英文内容",
  "编辑FAQ成功": "编辑FAQ成功",
  "新增FAQ成功": "新增FAQ成功",
  "编辑FAQ": "编辑FAQ",
  "问题内容（必填）": "问题内容（必填）",
  "答案内容（必填）": "答案内容（必填）",
  "请选择语言类型": "请选择语言类型",
  "请输入敏感词": "请输入敏感词",
  "请输入有效的敏感词": "请输入有效的敏感词",
  "批量添加敏感词失败": "批量添加敏感词失败",
  "批量添加敏感词": "批量添加敏感词",
  "语言类型": "语言类型",
  "敏感词列表": "敏感词列表",
  "请输入敏感词，支持以下格式：&#10;1. 每行一个敏感词&#10;2. 用逗号分隔：敏感词1,敏感词2,敏感词3&#10;3. 用分号分隔：敏感词1;敏感词2;敏感词3&#10;4. 混合使用：敏感词1,敏感词2&#10;敏感词3;敏感词4": "请输入敏感词，支持以下格式：&#10;1. 每行一个敏感词&#10;2. 用逗号分隔：敏感词1,敏感词2,敏感词3&#10;3. 用分号分隔：敏感词1;敏感词2;敏感词3&#10;4. 混合使用：敏感词1,敏感词2&#10;敏感词3;敏感词4",
  "预览敏感词 (": "预览敏感词 (",
  "个)：": "个)：",
  "使用说明：": "使用说明：",
  "• 支持多种分隔符：逗号(,)、分号(;)、换行符": "• 支持多种分隔符：逗号(,)、分号(;)、换行符",
  "• 系统会自动去除空白字符和重复项": "• 系统会自动去除空白字符和重复项",
  "• 建议每批添加不超过100个敏感词": "• 建议每批添加不超过100个敏感词",
  "• 添加前请确认语言类型选择正确": "• 添加前请确认语言类型选择正确",
  "语言名称": "语言名称",
  "敏感词": "敏感词",
  "敏感词配置": "敏感词配置",
  "配置各语言的敏感词，包括政治、色情、暴力、赌博、毒品、恐怖主义、宗教、种族歧视等敏感词": "配置各语言的敏感词，包括政治、色情、暴力、赌博、毒品、恐怖主义、宗教、种族歧视等敏感词",
  "语言类型:": "语言类型:",
  "请选择语言": "请选择语言",
  "新增敏感词": "新增敏感词",
  "编辑敏感词成功": "编辑敏感词成功",
  "新增敏感词成功": "新增敏感词成功",
  "编辑敏感词": "编辑敏感词",
  "反馈类型配置": "反馈类型配置",
  "功能配置": "功能配置",
  "暂无类型数据": "暂无类型数据",
  "暂无次类型数据": "暂无次类型数据",
  "反馈类型筛选": "反馈类型筛选",
  "主类型": "主类型",
  "次类型": "次类型",
  "反馈类型": "反馈类型",
  "个已选": "个已选",
  "聊天消息": "聊天消息",
  "暂无可翻译的原文内容": "暂无可翻译的原文内容",
  "缺少反馈ID": "缺少反馈ID",
  "翻译成功": "翻译成功",
  "翻译失败": "翻译失败",
  "请输入回复内容或上传附件": "请输入回复内容或上传附件",
  "回复成功": "回复成功",
  "回复失败": "回复失败",
  "暂无可翻译内容": "暂无可翻译内容",
  "反馈信息": "反馈信息",
  "翻译后": "翻译后",
  "手动翻译": "手动翻译",
  "处理与回复": "处理与回复",
  "翻译中": "翻译中",
  "翻译": "翻译",
  "暂无处理与回复记录": "暂无处理与回复记录",
  "回复后您会被添加到关注人": "回复后您会被添加到关注人",
  "发送": "发送",
  "反馈记录不存在了": "反馈记录不存在了",
  "操作日志": "操作日志",
  "评分": "评分",
  "来源渠道": "来源渠道",
  "问题解决类型": "问题解决类型",
  "是否弹幕": "是否弹幕",
  "关联标签": "关联标签",
  "反馈主类型": "反馈主类型",
  "反馈次类型": "反馈次类型",
  "站点": "站点",
  "用户删除": "用户删除",
  "聊天记录": "聊天记录",
  "原文：": "原文：",
  "翻译：": "翻译：",
  "反馈人ID": "反馈人ID",
  "被指派人": "被指派人",
  "关联BUG": "关联BUG",
  "暂无状态记录": "暂无状态记录",
  "状态变更失败": "状态变更失败",
  "介入时间": "介入时间",
  "下架": "下架",
  "上架": "上架",
  "请选择反馈主类型": "请选择反馈主类型",
  "保存失败:": "保存失败:",
  "请先选择主类型": "请先选择主类型",
  "该主类型下暂无次类型": "该主类型下暂无次类型",
  "选择反馈类型": "选择反馈类型",
  "（可选）": "（可选）",
  "关联业务需求": "关联业务需求",
  "确定要删除这个关联需求吗？": "确定要删除这个关联需求吗？",
  "请选择要添加的需求": "请选择要添加的需求",
  "关联需求详情": "关联需求详情",
  "添加需求：": "添加需求：",
  "请输入备注内容": "请输入备注内容",
  "备注添加成功": "备注添加成功",
  "备注添加失败": "备注添加失败",
  "暂无数据可导出": "暂无数据可导出",
  "导出成功": "导出成功",
  "请先选择需要分享的反馈": "请先选择需要分享的反馈",
  "批量分享内容已复制": "批量分享内容已复制",
  "批量分享失败": "批量分享失败",
  "翻译失败:": "翻译失败:",
  "用户是否删除": "用户是否删除",
  "批量分享": "批量分享",
  "反馈类型负责人": "反馈类型负责人",
  "人员类型": "人员类型",
  "请选择人员类型（可选）": "请选择人员类型（可选）",
  "取消关联成功": "取消关联成功",
  "取消关联失败": "取消关联失败",
  "请选择要关联的线上问题": "请选择要关联的线上问题",
  "确定要取消关联吗？": "确定要取消关联吗？",
  "添加线上问题：": "添加线上问题：",
  "请选择线上问题": "请选择线上问题",
  "关联成功": "关联成功",
  "关联失败": "关联失败",
  "请选择要关联的业务需求": "请选择要关联的业务需求",
  "请选择业务需求": "请选择业务需求",
  "无需处理后，反馈状态将自动更新为已关闭": "无需处理后，反馈状态将自动更新为已关闭",
  "翻译中...": "翻译中...",
  "反馈翻译": "反馈翻译",
  "反馈原文": "反馈原文",
  "处理状态": "处理状态",
  "添加关联业务需求": "添加关联业务需求",
  "添加关联BUG": "添加关联BUG",
  "最新回复内容": "最新回复内容",
  "最新回复内容翻译": "最新回复内容翻译",
  "反馈人名称": "反馈人名称",
  "设备型号": "设备型号",
  "系统版本": "系统版本",
  "app版本": "app版本",
  "反馈提交时间": "反馈提交时间",
  "变更处理人": "变更处理人",
  "变更关注人": "变更关注人",
  "转业务需求": "转业务需求",
  "转线上问题": "转线上问题",
  "编辑关联标签": "编辑关联标签",
  "编辑备注": "编辑备注",
  "查看图片": "查看图片",
  "查看消息": "查看消息",
  "查看操作记录": "查看操作记录",
  "暂无可分享的反馈信息": "暂无可分享的反馈信息",
  "分享内容已复制": "分享内容已复制",
  "分享失败": "分享失败",
  "暂不转换": "暂不转换",
  "备注保存成功": "备注保存成功",
  "备注保存失败": "备注保存失败",
  "修改失败": "修改失败",
  "业务需求创建失败": "业务需求创建失败",
  "全部类型": "全部类型",
  "事件类型": "事件类型",
  "事件详情": "事件详情",
  "工单ID:": "工单ID:",
  "工单名称": "工单名称",
  "工程师": "工程师",
  "所属组": "所属组",
  "是否备份": "是否备份",
  "已备份": "已备份",
  "未备份": "未备份",
  "完成时间": "完成时间",
  "SQL内容": "SQL内容",
  "审核结果": "审核结果",
  "影响行数:": "影响行数:",
  "应用ID": "应用ID",
  "发布标题": "发布标题",
  "集群": "集群",
  "配置变更详情": "配置变更详情",
  "原值:": "原值:",
  "新值:": "新值:",
  "运行ID:": "运行ID:",
  "发布ID:": "发布ID:",
  "服务基本信息": "服务基本信息",
  "服务类别": "服务类别",
  "运行信息": "运行信息",
  "操作人信息": "操作人信息",
  "电话": "电话",
  "错误日志对象:": "错误日志对象:",
  "加载详情中...": "加载详情中...",
  "暂无详情数据": "暂无详情数据",
  "事件名": "事件名",
  "• 数据库变更：为数据库名": "• 数据库变更：为数据库名",
  "• 配置变更：为应用ID": "• 配置变更：为应用ID",
  "• 服务发布：为服务名": "• 服务发布：为服务名",
  "个事件": "个事件",
  "暂无事件数据": "暂无事件数据",
  "时间轴视图": "时间轴视图",
  "网格视图": "网格视图",
  "获取事件数据失败:": "获取事件数据失败:",
  "获取事件数据失败": "获取事件数据失败",
  "获取字典数据失败:": "获取字典数据失败:",
  "获取事件类型数据失败": "获取事件类型数据失败",
  "时间范围不能超过180天": "时间范围不能超过180天",
  "时间范围不能超过180天，请重新选择": "时间范围不能超过180天，请重新选择",
  "发起审计成功": "发起审计成功",
  "发起审计失败": "发起审计失败",
  "发起审计失败:": "发起审计失败:",
  "GOC统一事件看板": "GOC统一事件看板",
  "总事件": "总事件",
  "时间范围：": "时间范围：",
  "业务领域：": "业务领域：",
  "请选择环境": "请选择环境",
  "发起审计": "发起审计",
  "请输入审批标题": "请输入审批标题",
  "指派工单": "指派工单",
  "必须选择一个工单": "必须选择一个工单",
  "指派成功": "指派成功",
  "指派失败": "指派失败",
  "请选择被指派人员": "请选择被指派人员",
  "获取运维人员失败:": "获取运维人员失败:",
  "获取可处理人员失败，将继续提交工单": "获取可处理人员失败，将继续提交工单",
  "创建工单成功！": "创建工单成功！",
  "表单验证失败:": "表单验证失败:",
  "创建工单": "创建工单",
  "紧急程度": "紧急程度",
  "请选择紧急程度": "请选择紧急程度",
  "问题分类": "问题分类",
  "请选择问题分类": "请选择问题分类",
  "问题描述": "问题描述",
  "请输入问题描述": "请输入问题描述",
  "缺少工单ID": "缺少工单ID",
  "请选择评价分数": "请选择评价分数",
  "评价成功": "评价成功",
  "评价失败": "评价失败",
  "评价工单失败:": "评价工单失败:",
  "评价工单": "评价工单",
  "评价分数：": "评价分数：",
  "评价内容：": "评价内容：",
  "请输入评价内容（可选）": "请输入评价内容（可选）",
  "获取聊天记录失败:": "获取聊天记录失败:",
  "回复失败:": "回复失败:",
  "工单信息": "工单信息",
  "创建时间：": "创建时间：",
  "（可处理人：": "（可处理人：",
  "请输入回复内容": "请输入回复内容",
  "工单详情": "工单详情",
  "1分": "1分",
  "2分": "2分",
  "3分": "3分",
  "4分": "4分",
  "5分": "5分",
  "工单筛选": "工单筛选",
  "指派人员": "指派人员",
  "请选择指派人员": "请选择指派人员",
  "评价分数": "评价分数",
  "获取工单详情失败:": "获取工单详情失败:",
  "工单已完成": "工单已完成",
  "完成工单失败": "完成工单失败",
  "请至少选择一个可指派的工单": "请至少选择一个可指派的工单",
  "工单编号": "工单编号",
  "可处理人员": "可处理人员",
  "被指派人员": "被指派人员",
  "实际处理人员": "实际处理人员",
  "分数范围为1~5分": "分数范围为1~5分",
  "评价内容": "评价内容",
  "处理完成": "处理完成",
  "服务评价": "服务评价",
  "确定要删除此工单吗？": "确定要删除此工单吗？",
  "删除工单失败:": "删除工单失败:",
  "批量指派": "批量指派",
  "确认完成工单": "确认完成工单",
  "确定要完成此工单吗？": "确定要完成此工单吗？",
  "请等待文件上传完成": "请等待文件上传完成",
  "点击或拖拽文件到此区域上传": "点击或拖拽文件到此区域上传",
  "支持多文件上传，单个文件不超过10MB": "支持多文件上传，单个文件不超过10MB",
  "已读完成": "已读完成",
  "去填写": "去填写",
  "已读": "已读",
  "未读": "未读",
  "系统通知": "系统通知",
  "全部已读": "全部已读",
  "全部设为已读": "全部设为已读",
  "加载里程碑失败": "加载里程碑失败",
  "请先选择一个里程碑": "请先选择一个里程碑",
  "关联迭代": "关联迭代",
  "下一步": "下一步",
  "项目：": "项目：",
  "请选择一个里程碑：": "请选择一个里程碑：",
  "请选择里程碑": "请选择里程碑",
  "项目ID不能为空": "项目ID不能为空",
  "预算已更新": "预算已更新",
  "编辑预算": "编辑预算",
  "预估人天不能为空": "预估人天不能为空",
  "须大于 0": "须大于 0",
  "机器预算（人民币）": "机器预算（人民币）",
  "其他预算（人民币）": "其他预算（人民币）",
  "预期收益（人民币）": "预期收益（人民币）",
  "预期收益不能为空": "预期收益不能为空",
  "项目编码：": "项目编码：",
  "空间 / 业务领域未配置": "空间 / 业务领域未配置",
  "空间": "空间",
  "年份:": "年份:",
  "周期:": "周期:",
  "规模": "规模",
  "时间进度": "时间进度",
  "进度根据时间流逝计算占比：(当前日期 - 开始日期) / (结束日期 - 开始日期) × 100%": "进度根据时间流逝计算占比：(当前日期 - 开始日期) / (结束日期 - 开始日期) × 100%",
  "点击查看迭代明细": "点击查看迭代明细",
  "完成数/总数": "完成数/总数",
  "点击查看需求明细": "点击查看需求明细",
  "点击查看任务明细": "点击查看任务明细",
  "质量评分:": "质量评分:",
  "未评分": "未评分",
  "未完成不可评分": "未完成不可评分",
  "项目团队": "项目团队",
  "立项后技术接口人仅可变更主开发、主测试、其他干系人；如需变更其他人员，请联系Zola周华变更。": "立项后技术接口人仅可变更主开发、主测试、其他干系人；如需变更其他人员，请联系Zola周华变更。",
  "暂无": "暂无",
  "暂无项目": "暂无项目",
  "点击\"新建项目\"开始创建": "点击\"新建项目\"开始创建",
  "项目完成": "项目完成",
  "确认完成项目": "确认完成项目",
  "实际人天": "实际人天",
  "请填写实际人天": "请填写实际人天",
  "请输入实际人天，可保留两位小数": "请输入实际人天，可保留两位小数",
  "人力成本约为": "人力成本约为",
  "（实际人天 × 平均工资 ¥": "（实际人天 × 平均工资 ¥",
  "/人天）": "/人天）",
  "机器成本（元）": "机器成本（元）",
  "请填写机器成本": "请填写机器成本",
  "请输入机器成本": "请输入机器成本",
  "其他成本（元）": "其他成本（元）",
  "请填写其他成本": "请填写其他成本",
  "请输入其他成本": "请输入其他成本",
  "实际收益（元）": "实际收益（元）",
  "请填写实际收益": "请填写实际收益",
  "请输入实际收益": "请输入实际收益",
  "暂无验收标准": "暂无验收标准",
  "添加验收标准": "添加验收标准",
  "关键结果": "关键结果",
  "权重": "权重",
  "验收时间": "验收时间",
  "请选择日期": "请选择日期",
  "验收人": "验收人",
  "验收标准": "验收标准",
  "确定要删除此验收标准吗？": "确定要删除此验收标准吗？",
  "项目不存在，无法保存里程碑": "项目不存在，无法保存里程碑",
  "请输入里程碑名称": "请输入里程碑名称",
  "请输入完成目标": "请输入完成目标",
  "请选择截止日期": "请选择截止日期",
  "编辑里程碑": "编辑里程碑",
  "新增里程碑": "新增里程碑",
  "如：立项启动、各系统改动点确认": "如：立项启动、各系统改动点确认",
  "开始日期 / 截止日期": "开始日期 / 截止日期",
  "请选择开始日期和截止日期": "请选择开始日期和截止日期",
  "项目不存在，无法保存风险": "项目不存在，无法保存风险",
  "编辑风险": "编辑风险",
  "新增风险": "新增风险",
  "请输入风险类型": "请输入风险类型",
  "风险描述": "风险描述",
  "请输入风险描述": "请输入风险描述",
  "请输入风险原因": "请输入风险原因",
  "风险等级": "风险等级",
  "请选择风险等级": "请选择风险等级",
  "应对措施": "应对措施",
  "请输入应对措施": "请输入应对措施",
  "替换": "替换",
  "暂无人员": "暂无人员",
  "项目背景": "项目背景",
  "项目目标": "项目目标",
  "带此图标的字段可在详情中快速编辑。立项通过后需要变更项目基础与预算信息，可联系Zola周华": "带此图标的字段可在详情中快速编辑。立项通过后需要变更项目基础与预算信息，可联系Zola周华",
  "项目编码": "项目编码",
  "所属空间": "所属空间",
  "项目状态": "项目状态",
  "请选择年份": "请选择年份",
  "项目背景与目标": "项目背景与目标",
  "请编辑项目背景（支持富文本格式）": "请编辑项目背景（支持富文本格式）",
  "请编辑项目目标（支持富文本格式）": "请编辑项目目标（支持富文本格式）",
  "项目预算与资源": "项目预算与资源",
  "人力预算": "人力预算",
  "人力成本": "人力成本",
  "机器预算": "机器预算",
  "机器成本": "机器成本",
  "其他预算": "其他预算",
  "其他成本": "其他成本",
  "预期收益": "预期收益",
  "实际收益": "实际收益",
  "预期ROI": "预期ROI",
  "实际ROI": "实际ROI",
  "当前进度:": "当前进度:",
  "预算进度": "预算进度",
  "预算进度 = 当前已用预算 ÷ 总预算 × 100%": "预算进度 = 当前已用预算 ÷ 总预算 × 100%",
  "请选择时间或预估人天": "请选择时间或预估人天",
  "编辑任务时间": "编辑任务时间",
  "开始结束:": "开始结束:",
  "预估人天:": "预估人天:",
  "请至少选择一项": "请至少选择一项",
  "完成关联": "完成关联",
  "多少天之内的创建的迭代": "多少天之内的创建的迭代",
  "多少天之内的创建的需求": "多少天之内的创建的需求",
  "最近7天": "最近7天",
  "最近30天": "最近30天",
  "最近180天": "最近180天",
  "最近360天": "最近360天",
  "选择要关联的迭代": "选择要关联的迭代",
  "选择要关联的需求": "选择要关联的需求",
  "没有迭代？": "没有迭代？",
  "没有产品需求？": "没有产品需求？",
  "去创建": "去创建",
  "仅支持删除任务类型工作项": "仅支持删除任务类型工作项",
  "确定要删除该工作项吗？": "确定要删除该工作项吗？",
  "确定要将该工作项移出项目吗？": "确定要将该工作项移出项目吗？",
  "项目或工作项信息异常": "项目或工作项信息异常",
  "当前工作项类型不支持移出项目": "当前工作项类型不支持移出项目",
  "解绑成功": "解绑成功",
  "暂无关联链接": "暂无关联链接",
  "创建能力待接入": "创建能力待接入",
  "知道了": "知道了",
  "添加备注成功": "添加备注成功",
  "迭代详情": "迭代详情",
  "任务详情": "任务详情",
  "展示内容：": "展示内容：",
  "里程碑时间轴": "里程碑时间轴",
  "工作项明细": "工作项明细",
  "已完成 / 总数": "已完成 / 总数",
  "暂无里程碑数据": "暂无里程碑数据",
  "只看未完成": "只看未完成",
  "暂无工作项数据": "暂无工作项数据",
  "暂无迭代数据": "暂无迭代数据",
  "迭代名称": "迭代名称",
  "周期": "周期",
  "未完成": "未完成",
  "暂无明细记录": "暂无明细记录",
  "暂无需求数据": "暂无需求数据",
  "暂无任务数据": "暂无任务数据",
  "实际工时(h)": "实际工时(h)",
  "任务不支持直接关联项目：请先在关联需求，然后在需求下创建任务，任务会通过需求自动关联到该项目": "任务不支持直接关联项目：请先在关联需求，然后在需求下创建任务，任务会通过需求自动关联到该项目",
  "仅项目技术接口人可编辑周报模板并写周报": "仅项目技术接口人可编辑周报模板并写周报",
  "编辑周报模板": "编辑周报模板",
  "新增周报模板": "新增周报模板",
  "当前无权限编辑该角色成员": "当前无权限编辑该角色成员",
  "确定要移除此人员吗？": "确定要移除此人员吗？",
  "暂无活动记录": "暂无活动记录",
  "总数": "总数",
  "查看": "查看",
  "请先完成所有内容": "请先完成所有内容",
  "验收完成": "验收完成",
  "完成验收失败": "完成验收失败",
  "工作项完成情况": "工作项完成情况",
  "工作项完成情况检查": "工作项完成情况检查",
  "暂无完成明细": "暂无完成明细",
  "存在未完成工作项，无法完成验收，请先完成所有内容。": "存在未完成工作项，无法完成验收，请先完成所有内容。",
  "迭代明细": "迭代明细",
  "业务接口人（BPM）": "业务接口人（BPM）",
  "技术接口人（产品经理）": "技术接口人（产品经理）",
  "业务负责人": "业务负责人",
  "验收负责人": "验收负责人",
  "主开发": "主开发",
  "主测试": "主测试",
  "系统落地负责人": "系统落地负责人",
  "系统培训负责人": "系统培训负责人",
  "其他干系人": "其他干系人",
  "该角色至少保留一名人员，无法全部移除": "该角色至少保留一名人员，无法全部移除",
  "已移除": "已移除",
  "项目名称不能为空": "项目名称不能为空",
  "项目编号不能为空": "项目编号不能为空",
  "项目编号不能超过20个字符": "项目编号不能超过20个字符",
  "项目编号仅支持字母、数字、中划线、下划线": "项目编号仅支持字母、数字、中划线、下划线",
  "项目背景不能为空": "项目背景不能为空",
  "项目目标不能为空": "项目目标不能为空",
  "时间进度总览": "时间进度总览",
  "周报": "周报",
  "活动时间线": "活动时间线",
  "查看审批单": "查看审批单",
  "开始项目": "开始项目",
  "重新发起审批": "重新发起审批",
  "发起立项审批": "发起立项审批",
  "质量打分": "质量打分",
  "完整编辑": "完整编辑",
  "项目信息不存在": "项目信息不存在",
  "未指定": "未指定",
  "验收评价": "验收评价",
  "暂无评价": "暂无评价",
  "明细": "明细",
  "完成里程碑": "完成里程碑",
  "完成": "完成",
  "里程碑已完成": "里程碑已完成",
  "验收分数须为 1～5 分": "验收分数须为 1～5 分",
  "验收已保存": "验收已保存",
  "验收保存失败": "验收保存失败",
  "里程碑验收": "里程碑验收",
  "完成评分（满分 5 分）：": "完成评分（满分 5 分）：",
  "完成评价：": "完成评价：",
  "请填写对该里程碑完成情况的评价（选填）": "请填写对该里程碑完成情况的评价（选填）",
  "加载项目风险失败": "加载项目风险失败",
  "风险已标记为已处理": "风险已标记为已处理",
  "删除风险": "删除风险",
  "解决风险": "解决风险",
  "检索值": "检索值",
  "请输入项目名称、编码或描述": "请输入项目名称、编码或描述",
  "项目类型": "项目类型",
  "请选择类型": "请选择类型",
  "加载更多": "加载更多",
  "保存草稿": "保存草稿",
  "起草完成": "起草完成",
  "提交并进入技术起草": "提交并进入技术起草",
  "开始日期、预计完成日期": "开始日期、预计完成日期",
  "所属年份": "所属年份",
  "项目规模": "项目规模",
  "业务接口人": "业务接口人",
  "技术接口人": "技术接口人",
  "至少填写一条里程碑": "至少填写一条里程碑",
  "风险为选填，若添加则每条须填写完整": "风险为选填，若添加则每条须填写完整",
  "一、项目基本信息": "一、项目基本信息",
  "二、项目背景与目标": "二、项目背景与目标",
  "三、项目团队": "三、项目团队",
  "四、项目预算与资源": "四、项目预算与资源",
  "五、项目关键里程碑": "五、项目关键里程碑",
  "六、项目风险": "六、项目风险",
  "业务起草已提交，项目已流转至技术起草": "业务起草已提交，项目已流转至技术起草",
  "草稿已保存": "草稿已保存",
  "起草完成，可发起立项审批": "起草完成，可发起立项审批",
  "编写说明": "编写说明",
  "请按顺序填写下列区域，点击区域名称可快速定位到对应表单。绿色勾表示该区域已填写完整。": "请按顺序填写下列区域，点击区域名称可快速定位到对应表单。绿色勾表示该区域已填写完整。",
  "仅业务接口人和技术接口人可编写项目信息。": "仅业务接口人和技术接口人可编写项目信息。",
  "整体预览": "整体预览",
  "待填": "待填",
  "选填": "选填",
  "待填写": "待填写",
  "提示：点击上方步骤标题可快速跳转到对应区域。": "提示：点击上方步骤标题可快速跳转到对应区域。",
  "请输入项目背景": "请输入项目背景",
  "请描述项目的背景、现状和需要解决的问题": "请描述项目的背景、现状和需要解决的问题",
  "请输入项目目标": "请输入项目目标",
  "请描述项目的预期目标、关键成果和成功标准": "请描述项目的预期目标、关键成果和成功标准",
  "请输入项目名称": "请输入项目名称",
  "项目名称不能超过100个字符": "项目名称不能超过100个字符",
  "请选择所属年份": "请选择所属年份",
  "项目的计划开始和结束时间": "项目的计划开始和结束时间",
  "请选择项目周期": "请选择项目周期",
  "请选择所属空间": "请选择所属空间",
  "请选择项目类型": "请选择项目类型",
  "请选择项目规模": "请选择项目规模",
  "人力预算：--（请先填写预估人天）": "人力预算：--（请先填写预估人天）",
  "人力预算：": "人力预算：",
  "万（人民币）": "万（人民币）",
  "计算方式：预估人天 ×": "计算方式：预估人天 ×",
  "元/人天（人民币）": "元/人天（人民币）",
  "预期ROI：--": "预期ROI：--",
  "计算公式：预期ROI = （预期收益 - 总投资） ÷ 总投资 × 100%，其中总投资 = 人力预算（预估人天 × 3000） + 机器预算 + 其他预算": "计算公式：预期ROI = （预期收益 - 总投资） ÷ 总投资 × 100%，其中总投资 = 人力预算（预估人天 × 3000） + 机器预算 + 其他预算",
  "大于0，支持两位小数": "大于0，支持两位小数",
  "请输入预估人天": "请输入预估人天",
  "须大于0，且可保留两位小数": "须大于0，且可保留两位小数",
  "请输入金额（元）": "请输入金额（元）",
  "请输入预期收益": "请输入预期收益",
  "五、项目关键里程碑（业务与技术协作编写）": "五、项目关键里程碑（业务与技术协作编写）",
  "请至少填写一条里程碑，每条里程碑的「里程碑名称」「完成目标」「开始日期」「预计完成日期」「负责人」均必填。": "请至少填写一条里程碑，每条里程碑的「里程碑名称」「完成目标」「开始日期」「预计完成日期」「负责人」均必填。",
  "六、项目风险（选填）": "六、项目风险（选填）",
  "风险为选填，若添加则每条须填写完整（风险类型、描述、风险原因、风险程度、风险应对方法）。": "风险为选填，若添加则每条须填写完整（风险类型、描述、风险原因、风险程度、风险应对方法）。",
  "请选择业务接口人（可多选）": "请选择业务接口人（可多选）",
  "请选择业务接口人": "请选择业务接口人",
  "请选择技术接口人（可多选）": "请选择技术接口人（可多选）",
  "请选择技术接口人": "请选择技术接口人",
  "请选择业务负责人（可多选）": "请选择业务负责人（可多选）",
  "请选择业务负责人": "请选择业务负责人",
  "请选择验收负责人（可多选）": "请选择验收负责人（可多选）",
  "请选择验收负责人": "请选择验收负责人",
  "请选择主开发（可多选）": "请选择主开发（可多选）",
  "请选择主测试（可多选）": "请选择主测试（可多选）",
  "请选择系统落地负责人（可多选）": "请选择系统落地负责人（可多选）",
  "请选择系统落地负责人": "请选择系统落地负责人",
  "请选择系统培训负责人（可多选）": "请选择系统培训负责人（可多选）",
  "请选择系统培训负责人": "请选择系统培训负责人",
  "请选择其他干系人（可多选）": "请选择其他干系人（可多选）",
  "请选择开始日期和预计完成时间": "请选择开始日期和预计完成时间",
  "添加里程碑": "添加里程碑",
  "低": "低",
  "高": "高",
  "请选择风险程度": "请选择风险程度",
  "请输入风险应对方法": "请输入风险应对方法",
  "添加风险": "添加风险",
  "结项": "结项",
  "确定要删除这个项目吗？": "确定要删除这个项目吗？",
  "质量评分": "质量评分",
  "待评分": "待评分",
  "完成数/总数，点击查看迭代明细": "完成数/总数，点击查看迭代明细",
  "完成数/总数，点击查看需求明细": "完成数/总数，点击查看需求明细",
  "完成数/总数，点击查看任务明细": "完成数/总数，点击查看任务明细",
  "发起审批": "发起审批",
  "重发审批": "重发审批",
  "打分": "打分",
  "个项目": "个项目",
  "新建项目": "新建项目",
  "隐藏筛选": "隐藏筛选",
  "显示筛选": "显示筛选",
  "卡片": "卡片",
  "表格": "表格",
  "看板": "看板",
  "点击选择 1-5 星": "点击选择 1-5 星",
  "所有的": "所有的",
  "获取项目详情失败": "获取项目详情失败",
  "加载项目详情...": "加载项目详情...",
  "项目ID为空，无法写周报": "项目ID为空，无法写周报",
  "正在提交评分...": "正在提交评分...",
  "评分成功": "评分成功",
  "正在删除项目...": "正在删除项目...",
  "项目已删除": "项目已删除",
  "正在开始项目...": "正在开始项目...",
  "项目已开始": "项目已开始",
  "正在发起立项审批...": "正在发起立项审批...",
  "已发起立项审批": "已发起立项审批",
  "暂无审批单信息": "暂无审批单信息",
  "正在完成项目...": "正在完成项目...",
  "项目已完成": "项目已完成",
  "没有找到符合条件的项目": "没有找到符合条件的项目",
  "暂无项目数据": "暂无项目数据",
  "清除筛选条件": "清除筛选条件",
  "创建项目": "创建项目",
  "项目需求明细": "项目需求明细",
  "项目任务明细": "项目任务明细",
  "项目迭代明细": "项目迭代明细",
  "编辑空间": "编辑空间",
  "确定要删除这个空间吗？": "确定要删除这个空间吗？",
  "删除后空间下的所有项目将无法访问": "删除后空间下的所有项目将无法访问",
  "删除空间": "删除空间",
  "成员（": "成员（",
  "暂无成员": "暂无成员",
  "创建于": "创建于",
  "暂无空间": "暂无空间",
  "点击\"新建空间\"开始创建": "点击\"新建空间\"开始创建",
  "空间名称": "空间名称",
  "项目数": "项目数",
  "最后更新人": "最后更新人",
  "最后更新时间": "最后更新时间",
  "成员管理": "成员管理",
  "其他成员": "其他成员",
  "暂无其他成员": "暂无其他成员",
  "空间详情": "空间详情",
  "在此空间下创建项目": "在此空间下创建项目",
  "空间信息不存在": "空间信息不存在",
  "活跃空间": "活跃空间",
  "新建空间": "新建空间",
  "请输入空间名称": "请输入空间名称",
  "空间名称不能超过50个字符": "空间名称不能超过50个字符",
  "空间负责人": "空间负责人",
  "请选择空间负责人": "请选择空间负责人",
  "空间描述": "空间描述",
  "请输入空间描述（可选）": "请输入空间描述（可选）",
  "空间成员": "空间成员",
  "请选择成员（可多选）": "请选择成员（可多选）",
  "个空间": "个空间",
  "空间名称或描述": "空间名称或描述",
  "没有找到符合条件的空间": "没有找到符合条件的空间",
  "暂无空间数据": "暂无空间数据",
  "创建空间": "创建空间",
  "产品需求原型或需求文档": "产品需求原型或需求文档",
  "产品经理响应速度": "产品经理响应速度",
  "产品经理对业务方需求的理解度": "产品经理对业务方需求的理解度",
  "与产品经理沟通过程": "与产品经理沟通过程",
  "研发开发和交付效率": "研发开发和交付效率",
  "产品功能交付质量": "产品功能交付质量",
  "提交成功": "提交成功",
  "产品需求交付验收单": "产品需求交付验收单",
  "尊敬的业务方：": "尊敬的业务方：",
  "您好！": "您好！",
  "非常感谢您对我们工作的支持！为了不断改进我们的服务质量，我们诚邀您填写此份简短的问卷，以便我们了解您对我们产品需求交付的满意度以及任何改进建议。您的反馈对我们非常重要！": "非常感谢您对我们工作的支持！为了不断改进我们的服务质量，我们诚邀您填写此份简短的问卷，以便我们了解您对我们产品需求交付的满意度以及任何改进建议。您的反馈对我们非常重要！",
  "产品需求基本信息": "产品需求基本信息",
  "需求相关时间和时长": "需求相关时间和时长",
  "需求创建时间": "需求创建时间",
  "需求交付时间": "需求交付时间",
  "研发投入时间": "研发投入时间",
  "前端：": "前端：",
  "(小时)": "(小时)",
  "后端：": "后端：",
  "测试：": "测试：",
  "产品阶段耗时": "产品阶段耗时",
  "研发阶段耗时": "研发阶段耗时",
  "测试阶段耗时": "测试阶段耗时",
  "是否与您确认期待完成时间": "是否与您确认期待完成时间",
  "需求验收意见": "需求验收意见",
  "请选择验收结果": "请选择验收结果",
  "请填写不通过原因": "请填写不通过原因",
  "改进建议或意见": "改进建议或意见",
  "请填写改进建议或意见": "请填写改进建议或意见",
  "满意度评价": "满意度评价",
  "请您对以下方面进行满意度评价,并在相应选项后打分。": "请您对以下方面进行满意度评价,并在相应选项后打分。",
  "请根据实际情况进行评价，评价结果将作为需求交付质量的重要参考。": "请根据实际情况进行评价，评价结果将作为需求交付质量的重要参考。",
  "总体评价": "总体评价",
  "对本次需求交付的整体满意度": "对本次需求交付的整体满意度",
  "提交问卷": "提交问卷",
  "需求背景描述": "需求背景描述",
  "问题清晰度": "问题清晰度",
  "原型或者需求设计": "原型或者需求设计",
  "产品需求评审质量评价": "产品需求评审质量评价",
  "尊敬的需求评审参与人员：": "尊敬的需求评审参与人员：",
  "非常感谢您参与此次产品需求评审，为了了解此次需求评审质量情况，我们诚邀您匿名填写此份简短的问卷，感谢您的支持！": "非常感谢您参与此次产品需求评审，为了了解此次需求评审质量情况，我们诚邀您匿名填写此份简短的问卷，感谢您的支持！",
  "需求评审后是否有修改？": "需求评审后是否有修改？",
  "亲, 您已填写过该问卷哦, 感谢您的参与!": "亲, 您已填写过该问卷哦, 感谢您的参与!",
  "感谢您的反馈, 我们将努力做得更好!": "感谢您的反馈, 我们将努力做得更好!",
  "(未填写详细内容)": "(未填写详细内容)",
  "导出失败": "导出失败",
  "导出Word": "导出Word",
  "变更记录": "变更记录",
  "事故名称和链接已剪贴板": "事故名称和链接已剪贴板",
  "事故名称": "事故名称",
  "影响范围": "影响范围",
  "分类": "分类",
  "影响值": "影响值",
  "暂无影响范围数据": "暂无影响范围数据",
  "备注说明": "备注说明",
  "时间节点": "时间节点",
  "恢复时间": "恢复时间",
  "影响开始时间": "影响开始时间",
  "影响结束时间": "影响结束时间",
  "定级依据": "定级依据",
  "暂无定级依据": "暂无定级依据",
  "责任人与团队": "责任人与团队",
  "事故处理责任组长": "事故处理责任组长",
  "暂无服务数据": "暂无服务数据",
  "事件时间线": "事件时间线",
  "暂无时间线数据": "暂无时间线数据",
  "事故原因": "事故原因",
  "改进措施和计划": "改进措施和计划",
  "措施内容": "措施内容",
  "计划完成时间": "计划完成时间",
  "永久": "永久",
  "跟踪备注": "跟踪备注",
  "查看添加": "查看添加",
  "暂无改进措施": "暂无改进措施",
  "暂无附件": "暂无附件",
  "选择责任人": "选择责任人",
  "事故序列号": "事故序列号",
  "请输入事故名称或序列号": "请输入事故名称或序列号",
  "进行中并且截止日期在3天内的措施发企微消息提醒": "进行中并且截止日期在3天内的措施发企微消息提醒",
  "发送失败": "发送失败",
  "进行中临期提醒": "进行中临期提醒",
  "到达开始时间但未开始和超过完成时间的措施给责任人发送企微消息提醒": "到达开始时间但未开始和超过完成时间的措施给责任人发送企微消息提醒",
  "未开始逾期提醒": "未开始逾期提醒",
  "热力图": "热力图",
  "事故等级分布": "事故等级分布",
  "事故序列分布": "事故序列分布",
  "月度事故趋势": "月度事故趋势",
  "改进措施状态概览": "改进措施状态概览",
  "改进措施改进状态分布图": "改进措施改进状态分布图",
  "改进措施负责人超期未完成": "改进措施负责人超期未完成",
  "前置过程（背景）": "前置过程（背景）",
  "事故发生": "事故发生",
  "事件发现/处置": "事件发现/处置",
  "善后处理": "善后处理",
  "暂存报告时，事故名称不能为空": "暂存报告时，事故名称不能为空",
  "有附件正在上传中，请稍后再试！": "有附件正在上传中，请稍后再试！",
  "操作失败：": "操作失败：",
  "文件上传失败:": "文件上传失败:",
  "暂存": "暂存",
  "1. 事故概况": "1. 事故概况",
  "请输入事故名称": "请输入事故名称",
  "2. 影响范围": "2. 影响范围",
  "数值": "数值",
  "请输入有效数字": "请输入有效数字",
  "3. 责任分析": "3. 责任分析",
  "已存在群": "已存在群",
  "拉群人数小于3人": "拉群人数小于3人",
  "是否拉群": "是否拉群",
  "4. 关联服务": "4. 关联服务",
  "请选择服务类型": "请选择服务类型",
  "请选择服务": "请选择服务",
  "选择服务": "选择服务",
  "添加服务": "添加服务",
  "5. 事件时间线": "5. 事件时间线",
  "添加时间节点": "添加时间节点",
  "请选择时间": "请选择时间",
  "文字颜色": "文字颜色",
  "字体加粗": "字体加粗",
  "加粗": "加粗",
  "6. 原因分析": "6. 原因分析",
  "7. 改进措施和计划": "7. 改进措施和计划",
  "改进措施": "改进措施",
  "设为永久": "设为永久",
  "8. 附件": "8. 附件",
  "未暂存的更改将在关闭后清空，是否继续？": "未暂存的更改将在关闭后清空，是否继续？",
  "推送邮件": "推送邮件",
  "确定删除吗？": "确定删除吗？",
  "新建事故报告": "新建事故报告",
  "配置影响范围": "配置影响范围",
  "选择影响指标": "选择影响指标",
  "请选择影响范围": "请选择影响范围",
  "指标名称(单位)": "指标名称(单位)",
  "是否加粗": "是否加粗",
  "组名": "组名",
  "项)": "项)",
  "显示顺序": "显示顺序",
  "新建指标": "新建指标",
  "批量编辑": "批量编辑",
  "批量删除": "批量删除",
  "批量操作": "批量操作",
  "必选": "必选",
  "选择分类": "选择分类",
  "最长20字": "最长20字",
  "例如：包裹量": "例如：包裹量",
  "最长50字": "最长50字",
  "例如：件": "例如：件",
  "添加指标": "添加指标",
  "确定要删除这些指标吗？此操作不可逆！": "确定要删除这些指标吗？此操作不可逆！",
  "刷新措施详情失败:": "刷新措施详情失败:",
  "添加备注失败": "添加备注失败",
  "添加备注错误:": "添加备注错误:",
  "备注删除成功": "备注删除成功",
  "删除备注失败": "删除备注失败",
  "删除备注错误:": "删除备注错误:",
  "确认删除这条备注？": "确认删除这条备注？",
  "措施跟踪备注": "措施跟踪备注",
  "措施信息": "措施信息",
  "备注记录": "备注记录",
  "暂无备注": "暂无备注",
  "不能超过1000字符": "不能超过1000字符",
  "请输入备注内容...": "请输入备注内容...",
  "下载失败，请手动右键另存为": "下载失败，请手动右键另存为",
  "该格式文件不支持预览，已自动触发下载": "该格式文件不支持预览，已自动触发下载",
  "若未下载成功，请": "若未下载成功，请",
  "点击此处": "点击此处",
  "文件预览": "文件预览",
  "推送有点慢，但我没放弃——": "推送有点慢，但我没放弃——",
  "用户列表加载失败": "用户列表加载失败",
  "必须选择一个收件人": "必须选择一个收件人",
  "发射成功～邮件正在路上！": "发射成功～邮件正在路上！",
  "发射失败…请稍后再试": "发射失败…请稍后再试",
  "确认发送事故邮件？": "确认发送事故邮件？",
  "收件人：": "收件人：",
  "标题：": "标题：",
  "标题：默认标题": "标题：默认标题",
  "确认发送": "确认发送",
  "再检查一下": "再检查一下",
  "发送事故邮件": "发送事故邮件",
  "默认已填充事故相关人员邮箱，可自行删减/追加；支持按姓名或邮箱搜索。": "默认已填充事故相关人员邮箱，可自行删减/追加；支持按姓名或邮箱搜索。",
  "邮件标题": "邮件标题",
  "留空将使用默认标题（事故名称-事故报告）": "留空将使用默认标题（事故名称-事故报告）",
  "收件人": "收件人",
  "按姓名/邮箱搜索，支持多选": "按姓名/邮箱搜索，支持多选",
  "抄送人员": "抄送人员",
  "可选：按姓名/邮箱搜索抄送人员": "可选：按姓名/邮箱搜索抄送人员",
  "抄送组织": "抄送组织",
  "团队邮箱": "团队邮箱",
  "可选：选择团队邮箱": "可选：选择团队邮箱",
  "事故报告": "事故报告",
  "草稿箱": "草稿箱",
  "数据看板": "数据看板",
  "需求编号": "需求编号",
  "需求文档": "需求文档",
  "是否与您沟通确认": "是否与您沟通确认",
  "请选择是否与您沟通确认": "请选择是否与您沟通确认",
  "(对本次需求交付的整体满意度)": "(对本次需求交付的整体满意度)",
  "请对总体情况进行评分": "请对总体情况进行评分",
  "需求业务方": "需求业务方",
  "评价状态": "评价状态",
  "已评价": "已评价",
  "未评价": "未评价",
  "验收意见": "验收意见",
  "不通过验收的原因": "不通过验收的原因",
  "评价状态：": "评价状态：",
  "请选择评价情况": "请选择评价情况",
  "所有": "所有",
  "COE 等级分布": "COE 等级分布",
  "根因类型分布": "根因类型分布",
  "责任人 COE 分布": "责任人 COE 分布",
  "COE编号": "COE编号",
  "等级": "等级",
  "发生时间": "发生时间",
  "发现耗时": "发现耗时",
  "恢复耗时": "恢复耗时",
  "故障责任人": "故障责任人",
  "直接资损": "直接资损",
  "间接资损": "间接资损",
  "Todo 内容": "Todo 内容",
  "交付时间": "交付时间",
  "延期情况": "延期情况",
  "延期": "延期",
  "COE 明细": "COE 明细",
  "COE Todo 明细": "COE Todo 明细",
  "月度 COE 趋势": "月度 COE 趋势",
  "COE 总数": "COE 总数",
  "高等级 COE": "高等级 COE",
  "故障等级为 P0 或 P1 的 COE 数量": "故障等级为 P0 或 P1 的 COE 数量",
  "平均发现时长": "平均发现时长",
  "当前筛选范围内，从故障发生到发现的平均耗时；缺少有效时间对时不参与计算": "当前筛选范围内，从故障发生到发现的平均耗时；缺少有效时间对时不参与计算",
  "平均恢复时长": "平均恢复时长",
  "当前筛选范围内，从故障发现到恢复的平均耗时；缺少有效时间对时不参与计算": "当前筛选范围内，从故障发现到恢复的平均耗时；缺少有效时间对时不参与计算",
  "累计资损": "累计资损",
  "直接损失 + 间接损失": "直接损失 + 间接损失",
  "延期 Todo": "延期 Todo",
  "Todo 完成率": "Todo 完成率",
  "已完成 Todo ÷ Todo 总数 × 100%": "已完成 Todo ÷ Todo 总数 × 100%",
  "COE Todo 状态概览": "COE Todo 状态概览",
  "Todo 总数": "Todo 总数",
  "逾期未完成": "逾期未完成",
  "COE Todo 状态分布": "COE Todo 状态分布",
  "完成率": "完成率",
  "负责人 COE Todo 状态分布": "负责人 COE Todo 状态分布",
  "负责人逾期 COE Todo": "负责人逾期 COE Todo",
  "COE 全局数据看板": "COE 全局数据看板",
  "全部打开": "全部打开",
  "部分看板数据加载失败，请点击刷新重试": "部分看板数据加载失败，请点击刷新重试",
  "加载 COE 评论失败": "加载 COE 评论失败",
  "评论已删除": "评论已删除",
  "删除 COE 评论失败": "删除 COE 评论失败",
  "保存 COE 评论失败": "保存 COE 评论失败",
  "评论已更新": "评论已更新",
  "输入评论，使用 @ 提醒相关人员": "输入评论，使用 @ 提醒相关人员",
  "添加图片": "添加图片",
  "Enter 发送，Shift + Enter 换行": "Enter 发送，Shift + Enter 换行",
  "修改评论，使用 @ 提醒相关人员": "修改评论，使用 @ 提醒相关人员",
  "回复当前讨论，使用 @ 提醒相关人员": "回复当前讨论，使用 @ 提醒相关人员",
  "Enter 保存，Shift + Enter 换行": "Enter 保存，Shift + Enter 换行",
  "收起评论": "收起评论",
  "展开评论": "展开评论",
  "原文位置已变更，暂无法定位": "原文位置已变更，暂无法定位",
  "编辑评论": "编辑评论",
  "删除这条评论？": "删除这条评论？",
  "编辑回复": "编辑回复",
  "删除这条回复？": "删除这条回复？",
  "暂无评论": "暂无评论",
  "原文已修改，评论仅作备案，无法定位": "原文已修改，评论仅作备案，无法定位",
  "暂无原文已修改评论": "暂无原文已修改评论",
  "变更记录加载失败": "变更记录加载失败",
  "重新加载": "重新加载",
  "暂无变更记录": "暂无变更记录",
  "图片": "图片",
  "详情加载失败": "详情加载失败",
  "故障级别": "故障级别",
  "持续时长": "持续时长",
  "归属系统": "归属系统",
  "1-故障基础信息": "1-故障基础信息",
  "故障责任组长": "故障责任组长",
  "内外因素": "内外因素",
  "归属部门": "归属部门",
  "复盘组织者": "复盘组织者",
  "复盘参与人": "复盘参与人",
  "2-故障现象": "2-故障现象",
  "3-故障影响": "3-故障影响",
  "关联系统影响": "关联系统影响",
  "异常数据量": "异常数据量",
  "资损能否追回": "资损能否追回",
  "客户投诉量": "客户投诉量",
  "故障发现人": "故障发现人",
  "影响时长": "影响时长",
  "客诉渠道": "客诉渠道",
  "故障上报人": "故障上报人",
  "用户/客户通知人": "用户/客户通知人",
  "4-故障处理时间线": "4-故障处理时间线",
  "操作人员：": "操作人员：",
  "暂无处理时间线": "暂无处理时间线",
  "5-5 Why 根因分析": "5-5 Why 根因分析",
  "暂无该阶段分析": "暂无该阶段分析",
  "问题": "问题",
  "答案": "答案",
  "6-综合根因总结": "6-综合根因总结",
  "暂无根因总结": "暂无根因总结",
  "根因类型": "根因类型",
  "7-改进措施": "7-改进措施",
  "暂无该类改进措施": "暂无该类改进措施",
  "措施": "措施",
  "关联5Why": "关联5Why",
  "8-Todo 列表": "8-Todo 列表",
  "暂无Todo": "暂无Todo",
  "任务内容": "任务内容",
  "故障现象": "故障现象",
  "故障影响": "故障影响",
  "处理时间线": "处理时间线",
  "根因总结": "根因总结",
  "请先填写发生时间和恢复时间": "请先填写发生时间和恢复时间",
  "当前持续时长已是计算结果": "当前持续时长已是计算结果",
  "覆盖持续时长？": "覆盖持续时长？",
  "确认覆盖": "确认覆盖",
  "请填写问题": "请填写问题",
  "请填写措施": "请填写措施",
  "发现本机未同步的编辑内容": "发现本机未同步的编辑内容",
  "恢复内容": "恢复内容",
  "放弃缓存": "放弃缓存",
  "最新内容尚未保存，且本机缓存失败，请先点击暂存后再关闭": "最新内容尚未保存，且本机缓存失败，请先点击暂存后再关闭",
  "内容已更新，请确认后重新保存": "内容已更新，请确认后重新保存",
  "请先填写故障名称后再暂存": "请先填写故障名称后再暂存",
  "保存成功，但本机备份清理失败，已保留当前页面内容，请稍后重试": "保存成功，但本机备份清理失败，已保留当前页面内容，请稍后重试",
  "动作": "动作",
  "图片/附件": "图片/附件",
  "请填写根因总结": "请填写根因总结",
  "如：5.1-Why1": "如：5.1-Why1",
  "搜索并选择需求（可多选）": "搜索并选择需求（可多选）",
  "暂无需求": "暂无需求",
  "请选择故障级别": "请选择故障级别",
  "请输入持续时长": "请输入持续时长",
  "恢复时间减去发生时间，不足 1 分钟向下取整；点击后回填到持续时长": "恢复时间减去发生时间，不足 1 分钟向下取整；点击后回填到持续时长",
  "计算": "计算",
  "请选择归属系统": "请选择归属系统",
  "请选择内外因素": "请选择内外因素",
  "外部原因无需选择归属部门": "外部原因无需选择归属部门",
  "请选择归属部门（可多选）": "请选择归属部门（可多选）",
  "搜索并选择迭代（可多选）": "搜索并选择迭代（可多选）",
  "暂无迭代": "暂无迭代",
  "请输入故障现象": "请输入故障现象",
  "请输入直接资损金额": "请输入直接资损金额",
  "请输入间接资损金额": "请输入间接资损金额",
  "8-Todo列表": "8-Todo列表",
  "编辑COE复盘记录": "编辑COE复盘记录",
  "新建COE复盘记录": "新建COE复盘记录",
  "复盘目录": "复盘目录",
  "时间线": "时间线",
  "根因": "根因",
  "COE复盘名称和链接已复制到剪贴板": "COE复盘名称和链接已复制到剪贴板",
  "刷新详情和评论": "刷新详情和评论",
  "Todo 状态更新失败": "Todo 状态更新失败",
  "Todo 状态已更新": "Todo 状态已更新",
  "Todo 至少需要保留一名执行人": "Todo 至少需要保留一名执行人",
  "Todo 更新失败": "Todo 更新失败",
  "Todo 已更新": "Todo 已更新",
  "请选择执行人": "请选择执行人",
  "搜索关联需求": "搜索关联需求",
  "延期提醒发送成功": "延期提醒发送成功",
  "延期提醒发送失败": "延期提醒发送失败",
  "COE编号、故障名称或任务内容": "COE编号、故障名称或任务内容",
  "确认发送延期提醒？": "确认发送延期提醒？",
  "将向已延期且未完成 Todo 的执行人发送飞书汇总提醒。": "将向已延期且未完成 Todo 的执行人发送飞书汇总提醒。",
  "延期提醒": "延期提醒",
  "已复制COE编号": "已复制COE编号",
  "Todo列表": "Todo列表",
  "请输入故障名称": "请输入故障名称",
  "5.1-5Why根因分析-1故障原因（为什么会发生）": "5.1-5Why根因分析-1故障原因（为什么会发生）",
  "5.2-5Why根因分析-2故障感知（为什么没有及时发现）": "5.2-5Why根因分析-2故障感知（为什么没有及时发现）",
  "5.3-5Why根因分析-3故障止损（为什么没快速阻止损失扩大）": "5.3-5Why根因分析-3故障止损（为什么没快速阻止损失扩大）",
  "5.4-5Why根因分析-4故障定位（为什么排查耗时长）": "5.4-5Why根因分析-4故障定位（为什么排查耗时长）",
  "技术架构根因": "技术架构根因",
  "研发质量根因": "研发质量根因",
  "监控观测根因": "监控观测根因",
  "应急处置根因": "应急处置根因",
  "流程制度根因": "流程制度根因",
  "7.1-改进措施-故障预防": "7.1-改进措施-故障预防",
  "7.2-改进措施-故障感知": "7.2-改进措施-故障感知",
  "7.3-改进措施-故障止损": "7.3-改进措施-故障止损",
  "7.4-改进措施-故障定位": "7.4-改进措施-故障定位",
  "告警类型": "告警类型",
  "值班人员": "值班人员",
  "告警详情": "告警详情",
  "该群已被解散": "该群已被解散",
  "进群成功": "进群成功",
  "确认要解散该群吗？": "确认要解散该群吗？",
  "解散后，该群将无法使用。": "解散后，该群将无法使用。",
  "解散成功": "解散成功",
  "仅该群创建者可以解散": "仅该群创建者可以解散",
  "解散": "解散",
  "今日告警记录": "今日告警记录",
  "系统崩溃": "系统崩溃",
  "数据错误": "数据错误",
  "运营受阻": "运营受阻",
  "确认覆盖内容": "确认覆盖内容",
  "确认清空": "确认清空",
  "拨打告警电话": "拨打告警电话",
  "告警记录": "告警记录",
  "该业务领域今日没有值班人员": "该业务领域今日没有值班人员",
  "一键告警": "一键告警",
  "新增自定义告警电话": "新增自定义告警电话",
  "（非必须，默认拨打值班人员电话）": "（非必须，默认拨打值班人员电话）",
  "将相关值班人员加入应急响应群。": "将相关值班人员加入应急响应群。",
  "仅拉群": "仅拉群",
  "拉群成功": "拉群成功",
  "拉群人数不足": "拉群人数不足",
  "给相关值班人员以及自定义电话拨打告警电话。": "给相关值班人员以及自定义电话拨打告警电话。",
  "仅拨打告警电话": "仅拨打告警电话",
  "将相关值班人员加入应急响应群，并给相关值班人员以及自定义电话拨打告警电话。": "将相关值班人员加入应急响应群，并给相关值班人员以及自定义电话拨打告警电话。",
  "拉群+拨打告警电话": "拉群+拨打告警电话",
  "请输入有效的中国手机号码": "请输入有效的中国手机号码",
  "请输入电话": "请输入电话",
  "输入或选择电话号码": "输入或选择电话号码",
  "添加电话": "添加电话",
  "报警详情": "报警详情",
  "选择模板可快速填充内容": "选择模板可快速填充内容",
  "选择模板": "选择模板",
  "专属号码模式：": "专属号码模式：",
  "使用专属号码(0571-23677999)呼叫": "使用专属号码(0571-23677999)呼叫",
  "公共模式：": "公共模式：",
  "使用系统分配的公共号码呼叫": "使用系统分配的公共号码呼叫",
  "（推荐优先使用专属号码保证通话质量）": "（推荐优先使用专属号码保证通话质量）",
  "是否使用专属号码呼叫": "是否使用专属号码呼叫",
  "请输入报警详情": "请输入报警详情",
  "报警详情不能超过200个字": "报警详情不能超过200个字",
  "请输入或选择模板编辑...": "请输入或选择模板编辑...",
  "呼叫成功": "呼叫成功",
  "_验收报告": "_验收报告",
  "开发人员": "开发人员",
  "发送人员": "发送人员",
  "需求匹配度": "需求匹配度",
  "功能完备性": "功能完备性",
  "功能流畅性": "功能流畅性",
  "设计满意度": "设计满意度",
  "总体意见": "总体意见",
  "需求细项": "需求细项",
  "验收人员": "验收人员",
  "验收结果": "验收结果",
  "补充意见": "补充意见",
  "备注不能为空": "备注不能为空",
  "备注成功": "备注成功",
  "提交备注": "提交备注",
  "流转": "流转",
  "发布列表": "发布列表",
  "仅被指派人可操作": "仅被指派人可操作",
  "实际任务不能超过120个小时": "实际任务不能超过120个小时",
  "最多保留两位小数，总位数不超过四位": "最多保留两位小数，总位数不超过四位",
  "单个任务不能超过3天，请拆解任务": "单个任务不能超过3天，请拆解任务",
  "文件或视频上传失败，请重试！": "文件或视频上传失败，请重试！",
  "上传文件不能超过500MB": "上传文件不能超过500MB",
  "重现步骤(双击开始编辑)": "重现步骤(双击开始编辑)",
  "视频 & 附件": "视频 & 附件",
  "点击或者将\"视频\"拖动到区域上传": "点击或者将\"视频\"拖动到区域上传",
  "点击或者将\"文件\"拖动到区域上传": "点击或者将\"文件\"拖动到区域上传",
  "名称和链接已剪贴板": "名称和链接已剪贴板",
  "进群失败": "进群失败",
  "指派给产品经理": "指派给产品经理",
  "已读取暂存需求": "已读取暂存需求",
  "简要说明": "简要说明",
  "具体举例说明": "具体举例说明",
  "系统、服务、重要组件、停止或者无法正常运行，严重影响或阻碍测试执行": "系统、服务、重要组件、停止或者无法正常运行，严重影响或阻碍测试执行",
  "1、系统崩渍或者挂起": "1、系统崩渍或者挂起",
  "2、服务挂掉": "2、服务挂掉",
  "3、中间件等重要组件无法正常使用": "3、中间件等重要组件无法正常使用",
  "4、核心功能的严重错误": "4、核心功能的严重错误",
  "1、程序无法执行、应用模块无法启动或异常退出": "1、程序无法执行、应用模块无法启动或异常退出",
  "2、系统崩渍、死锁、内存泄露、导致严重问题或致命错误": "2、系统崩渍、死锁、内存泄露、导致严重问题或致命错误",
  "3、存在主流程核心功能的严重功能错误、逻辑错误、严重影响或阻碍测试执行": "3、存在主流程核心功能的严重功能错误、逻辑错误、严重影响或阻碍测试执行",
  "4、 APP 闪退": "4、 APP 闪退",
  "主流程严重的功能性缺陷,影响测试执行": "主流程严重的功能性缺陷,影响测试执行",
  "1、影响主流程的严重错误": "1、影响主流程的严重错误",
  "2、主流程功能不符合要求或未完成": "2、主流程功能不符合要求或未完成",
  "1、存在影响结果和使用的主流程功能的重大功能错误、逻辑错误、影响测试执行": "1、存在影响结果和使用的主流程功能的重大功能错误、逻辑错误、影响测试执行",
  "2、不符合或未完成的主流程器求和交互": "2、不符合或未完成的主流程器求和交互",
  "3、内存泄露": "3、内存泄露",
  "4、严重的数值计算错误": "4、严重的数值计算错误",
  "主流程功能性缺陷,不影响测试执行": "主流程功能性缺陷,不影响测试执行",
  "1、影响主流程的错误": "1、影响主流程的错误",
  "2、严重影响用户体验和使用的缺陷": "2、严重影响用户体验和使用的缺陷",
  "1、存在影响结果和使用的主流程功能的较大功能错误、逻辑错误、不影响测试执行": "1、存在影响结果和使用的主流程功能的较大功能错误、逻辑错误、不影响测试执行",
  "2、严重影响用户体验和使用的 UI 问题，如严重兼容性适配问题": "2、严重影响用户体验和使用的 UI 问题，如严重兼容性适配问题",
  "3、影咱系统性能的问题": "3、影咱系统性能的问题",
  "4、不符合大部分用户操作习惯": "4、不符合大部分用户操作习惯",
  "一般功能性缺陷，主流程功能无异常": "一般功能性缺陷，主流程功能无异常",
  "1、不影响主流程的错误": "1、不影响主流程的错误",
  "2、直接影响用户体验和使用的缺陷": "2、直接影响用户体验和使用的缺陷",
  "3、主流程功能不符合需求或未完成": "3、主流程功能不符合需求或未完成",
  "1、存在不影响结果和使用的非主流程小的功能错误，逻辑错误": "1、存在不影响结果和使用的非主流程小的功能错误，逻辑错误",
  "2、不符合或未完成的非主流程需求和交互": "2、不符合或未完成的非主流程需求和交互",
  "3、直接影响用户体验和使用的 UI 问题，如兼容性适配问题，界面截断、折行、溢出等": "3、直接影响用户体验和使用的 UI 问题，如兼容性适配问题，界面截断、折行、溢出等",
  "4、提示信息错误，有歧义，或者未给出提示信息而直接影响用户体验": "4、提示信息错误，有歧义，或者未给出提示信息而直接影响用户体验",
  "5、操作界面不友好，不符合部分用户习惯": "5、操作界面不友好，不符合部分用户习惯",
  "保存中...": "保存中...",
  "已保存到云端": "已保存到云端",
  "重现步骤（粘贴链接后输入空格变为超链接）": "重现步骤（粘贴链接后输入空格变为超链接）",
  "上传视频": "上传视频",
  "视频文件不能超过50MB,仅支持.mp4,.avi,.mov,.flv.mp4,.avi,.mov,.wmv,.mkv,.flv,.webm,.3gp,.mpeg,.asf格式": "视频文件不能超过50MB,仅支持.mp4,.avi,.mov,.flv.mp4,.avi,.mov,.wmv,.mkv,.flv,.webm,.3gp,.mpeg,.asf格式",
  "附件不能超过10MB": "附件不能超过10MB",
  "请选择严重程度": "请选择严重程度",
  "研发": "研发",
  "请输入指派给": "请输入指派给",
  "Bug页面地址(一个地址一行)": "Bug页面地址(一个地址一行)",
  "不支持在ALL系统下拖动，请切换具体系统后操作！": "不支持在ALL系统下拖动，请切换具体系统后操作！",
  "添加子模块": "添加子模块",
  "重命名": "重命名",
  "取消编辑": "取消编辑",
  "新建模块": "新建模块",
  "不支持在ALL系统下创建模块，请切换具体系统后操作！": "不支持在ALL系统下创建模块，请切换具体系统后操作！",
  "一次仅支持创建一个模块，请保存后在新建！": "一次仅支持创建一个模块，请保存后在新建！",
  "所有模块": "所有模块",
  "出现bug的页面": "出现bug的页面",
  "添加链接：": "添加链接：",
  "链接不能为空": "链接不能为空",
  "按创建时间最早": "按创建时间最早",
  "按创建时间最晚": "按创建时间最晚",
  "按更新时间最早": "按更新时间最早",
  "按更新时间最晚": "按更新时间最晚",
  "按截止时间最早": "按截止时间最早",
  "按截止时间最晚": "按截止时间最晚",
  "保存为默认排序": "保存为默认排序",
  "在\"只看我\"下，不能选择人物相关": "在\"只看我\"下，不能选择人物相关",
  "请选择反馈人": "请选择反馈人",
  "请选择责任人": "请选择责任人",
  "请选择被指派人": "请选择被指派人",
  "解决人": "解决人",
  "已复制全页内容到剪贴板": "已复制全页内容到剪贴板",
  "全页复制": "全页复制",
  "展示与自己相关的": "展示与自己相关的",
  "缺陷确认时间": "缺陷确认时间",
  "缺陷解决时间": "缺陷解决时间",
  "缺陷关闭时间": "缺陷关闭时间",
  "记录不存在了": "记录不存在了",
  "进行中": "进行中",
  "概览": "概览",
  "在途需求": "在途需求",
  "在途异常需求": "在途异常需求",
  "我提的业务需求": "我提的业务需求",
  "关联我的产品需求": "关联我的产品需求",
  "在\"只看我\"下，不能选择产品对接人": "在\"只看我\"下，不能选择产品对接人",
  "请选择产品对接人": "请选择产品对接人",
  "请选择提出人": "请选择提出人",
  "在\"只看我\"下，不能选择创建人": "在\"只看我\"下，不能选择创建人",
  "我提出": "我提出",
  "交接成功": "交接成功",
  "当前产品对接": "当前产品对接",
  "交接产品": "交接产品",
  "请选择交接产品": "请选择交接产品",
  "请先选择交接产品": "请先选择交接产品",
  "已批量填充空白交接产品": "已批量填充空白交接产品",
  "请先选择需要清空的业务需求": "请先选择需要清空的业务需求",
  "已清空所选业务需求的交接产品": "已清空所选业务需求的交接产品",
  "请先选择需要交接的业务需求": "请先选择需要交接的业务需求",
  "业务需求交接": "业务需求交接",
  "交接的业务需求（": "交接的业务需求（",
  "，可操作": "，可操作",
  "交接产品：": "交接产品：",
  "统一选择交接产品": "统一选择交接产品",
  "批量填充空值": "批量填充空值",
  "清空交接": "清空交接",
  "隐藏无法操作的需求": "隐藏无法操作的需求",
  "驳回时间": "驳回时间",
  "驳回人": "驳回人",
  "交付时长分布": "交付时长分布",
  "4周内交付率：": "4周内交付率：",
  "认领": "认领",
  "驳回": "驳回",
  "拒绝验收": "拒绝验收",
  "是否删除需求": "是否删除需求",
  "确认要删除需求吗？": "确认要删除需求吗？",
  "添加产品对接人": "添加产品对接人",
  "驳回业务需求": "驳回业务需求",
  "请输入任务名称": "请输入任务名称",
  "在“只看我”下，不能选择产品对接人": "在“只看我”下，不能选择产品对接人",
  "期待开始": "期待开始",
  "期待结束": "期待结束",
  "在“只看我”下，不能选择创建人": "在“只看我”下，不能选择创建人",
  "展示产品经理、业务方、创建人为自己的记录": "展示产品经理、业务方、创建人为自己的记录",
  "产品需求名称": "产品需求名称",
  "产品需求创建时间": "产品需求创建时间",
  "产品介入时间": "产品介入时间",
  "产品评审完成时间": "产品评审完成时间",
  "预计开发投入时间": "预计开发投入时间",
  "预计开发完成时间": "预计开发完成时间",
  "实际开发完成时间": "实际开发完成时间",
  "预计测试投入时间": "预计测试投入时间",
  "预计测试完成时间": "预计测试完成时间",
  "实际测试完成时间": "实际测试完成时间",
  "实际验收完成时间": "实际验收完成时间",
  "期望上线时间": "期望上线时间",
  "实际上线时间": "实际上线时间",
  "请勾选要复制的需求": "请勾选要复制的需求",
  "已复制需求内容到剪贴板": "已复制需求内容到剪贴板",
  "业务需求，记录的业务需求描述，产品经理可以认领**需求并创建产品需求进入研发任务。": "业务需求，记录的业务需求描述，产品经理可以认领**需求并创建产品需求进入研发任务。",
  "导出Excel": "导出Excel",
  "请先勾选需要交接的业务需求": "请先勾选需要交接的业务需求",
  "业务交接": "业务交接",
  "使用人": "使用人",
  "介入人": "介入人",
  "发布人": "发布人",
  "需求描述(双击开始编辑)": "需求描述(双击开始编辑)",
  "点击或者将文件拖动到区域上传": "点击或者将文件拖动到区域上传",
  "变更需求描述模版": "变更需求描述模版",
  "当前产品经理设置了专属需求模板，切换会覆盖现有内容(当前需求描述内容将被复制到剪贴板)。": "当前产品经理设置了专属需求模板，切换会覆盖现有内容(当前需求描述内容将被复制到剪贴板)。",
  "确定要执行此操作吗？": "确定要执行此操作吗？",
  "原先需求描述内容已复制到剪贴板": "原先需求描述内容已复制到剪贴板",
  "该需求功能提出的具体人，或者具体使用用户": "该需求功能提出的具体人，或者具体使用用户",
  "系统使用人": "系统使用人",
  "简单 - 小于5个工作日": "简单 - 小于5个工作日",
  "中等 - 5~10个工作日": "中等 - 5~10个工作日",
  "复杂 - 大于10个工作日": "复杂 - 大于10个工作日",
  "业务方提出的需求功能或者目标为了服务该国家，不适用于全球通用业务场景": "业务方提出的需求功能或者目标为了服务该国家，不适用于全球通用业务场景",
  "业务方提出的需求功能或者目标为了服务该垂直行业线，适用于全球通用业务场景": "业务方提出的需求功能或者目标为了服务该垂直行业线，适用于全球通用业务场景",
  "需求描述": "需求描述",
  "编辑需求主要归属": "编辑需求主要归属",
  "业务需求名称": "业务需求名称",
  "业务需求创建时间": "业务需求创建时间",
  "业务需求期望上线时间": "业务需求期望上线时间",
  "业务需求实际上线时间": "业务需求实际上线时间",
  "请选择待关联需求": "请选择待关联需求",
  "综合数据看板🔥": "综合数据看板🔥",
  "预测数据看板🔥": "预测数据看板🔥",
  "我的数据看板📊": "我的数据看板📊",
  "只能上传.xmind文件!": "只能上传.xmind文件!",
  "上传测试用例": "上传测试用例",
  "参与总人数 * 工时（天）": "参与总人数 * 工时（天）",
  "成本预估=人/天*3000，可直观告知业务方预估花费成本，需对方考虑ROI是否合理。": "成本预估=人/天*3000，可直观告知业务方预估花费成本，需对方考虑ROI是否合理。",
  "以及后期如果成本过高，需要上升到不同维度进行决策。": "以及后期如果成本过高，需要上升到不同维度进行决策。",
  "任务参与相关人员": "任务参与相关人员",
  "展开更多录入项": "展开更多录入项",
  "该任务相关联的服务": "该任务相关联的服务",
  "服务相关联的分支": "服务相关联的分支",
  "已经是用例了": "已经是用例了",
  "导入用例": "导入用例",
  "模块": "模块",
  "请选择模块": "请选择模块",
  "请切换到具体项目在创建": "请切换到具体项目在创建",
  "暂时还不支持保存": "暂时还不支持保存",
  "脑图渲染慢，请耐心等待": "脑图渲染慢，请耐心等待",
  "暂无数据，请点击左侧模块": "暂无数据，请点击左侧模块",
  "模块视图需要切换到具体项目下查看": "模块视图需要切换到具体项目下查看",
  "模块视图": "模块视图",
  "提测记录": "提测记录",
  "请输入规划名称": "请输入规划名称",
  "绑定成功": "绑定成功",
  "业务需求名称已复制到剪贴板": "业务需求名称已复制到剪贴板",
  "业务需求描述": "业务需求描述",
  "暂无关联业务需求": "暂无关联业务需求",
  "暂无业务需求": "暂无业务需求",
  "请填写所有验收人员": "请填写所有验收人员",
  "请填写所有验收结果": "请填写所有验收结果",
  "提交过程中出错:": "提交过程中出错:",
  "人员信息": "人员信息",
  "验收结论": "验收结论",
  "：通过": "：通过",
  "：不通过": "：不通过",
  "必填项：1-5分制，满分20分。原则上，总分12分以下不通过。": "必填项：1-5分制，满分20分。原则上，总分12分以下不通过。",
  "应用": "应用",
  "操作类型": "操作类型",
  "旧值": "旧值",
  "新值": "新值",
  "变更类型": "变更类型",
  "配置Key": "配置Key",
  "变更Key": "变更Key",
  "无变更": "无变更",
  "变更数量": "变更数量",
  "发布备注": "发布备注",
  "操作者": "操作者",
  "Apollo配置工单列表": "Apollo配置工单列表",
  "确定（已选": "确定（已选",
  "项）": "项）",
  "选择环境": "选择环境",
  "应用ID：": "应用ID：",
  "选择应用ID": "选择应用ID",
  "收起变更明细": "收起变更明细",
  "展开查看变更明细": "展开查看变更明细",
  "工单状态": "工单状态",
  "备份": "备份",
  "组": "组",
  "SQL工单列表": "SQL工单列表",
  "隐藏": "隐藏",
  "待办需求池": "待办需求池",
  "只有方案中需求才可以在发起业务评审！": "只有方案中需求才可以在发起业务评审！",
  "发起业务评审": "发起业务评审",
  "请输入删除原因": "请输入删除原因",
  "是否解绑Sprint": "是否解绑Sprint",
  "确认要解绑Sprint吗？": "确认要解绑Sprint吗？",
  "解绑Sprint": "解绑Sprint",
  "绑定Sprint": "绑定Sprint",
  "添加任务": "添加任务",
  "草稿不支持查看详情，请保存为正常需求后操作！": "草稿不支持查看详情，请保存为正常需求后操作！",
  "计划需求评审日期": "计划需求评审日期",
  "计划技术方案评审日期": "计划技术方案评审日期",
  "计划测试用例评审日期": "计划测试用例评审日期",
  "计划提测日期": "计划提测日期",
  "计划业务验收日期": "计划业务验收日期",
  "点击查看后端任务详情": "点击查看后端任务详情",
  "点击查看前端任务详情": "点击查看前端任务详情",
  "点击查看测试任务详情": "点击查看测试任务详情",
  "点击查看UI任务详情": "点击查看UI任务详情",
  "产品阶段截止时间": "产品阶段截止时间",
  "研发阶段截止时间": "研发阶段截止时间",
  "测试阶段截止时间": "测试阶段截止时间",
  "阶段耗时明细": "阶段耗时明细",
  "确定取消暂停吗？": "确定取消暂停吗？",
  "取消暂停后状态将会恢复到": "取消暂停后状态将会恢复到",
  "最后一次": "最后一次",
  "操作状态": "操作状态",
  "取消暂停成功": "取消暂停成功",
  "取消暂停": "取消暂停",
  "克隆成功": "克隆成功",
  "复制名称和链接": "复制名称和链接",
  "仅复制链接": "仅复制链接",
  "请先勾选需要复制的行": "请先勾选需要复制的行",
  "已复制选中行的内容到剪贴板": "已复制选中行的内容到剪贴板",
  "创建Sprint": "创建Sprint",
  "所勾选需求中存在不可验收需求": "所勾选需求中存在不可验收需求",
  "批量验收": "批量验收",
  "所选需求必须都有发布权限且属于同一业务领域": "所选需求必须都有发布权限且属于同一业务领域",
  "批量发布": "批量发布",
  "产品交接": "产品交接",
  "查看需求阶段耗时": "查看需求阶段耗时",
  "查看需求状态数量统计": "查看需求状态数量统计",
  "在研发过程中，增量代码缺陷率的高低直接影响软件质量和团队效率。这个数值越高，说明研发质量越低。": "在研发过程中，增量代码缺陷率的高低直接影响软件质量和团队效率。这个数值越高，说明研发质量越低。",
  "增量代码缺陷率:": "增量代码缺陷率:",
  "通常指在特定代码变更中发现的缺陷数量与该变更所涉及的代码行数的比率。较低的缺陷率通常意味着代码质量较高，反之则可能表明存在较多问题。": "通常指在特定代码变更中发现的缺陷数量与该变更所涉及的代码行数的比率。较低的缺陷率通常意味着代码质量较高，反之则可能表明存在较多问题。",
  "高质量代码:": "高质量代码:",
  "低的增量代码缺陷率通常表明代码质量较高，开发团队在编码时遵循了良好的实践和标准。": "低的增量代码缺陷率通常表明代码质量较高，开发团队在编码时遵循了良好的实践和标准。",
  "高缺陷率的潜在问题:": "高缺陷率的潜在问题:",
  "质量控制不足: 高的增量代码缺陷率可能表明在开发过程中存在质量控制不足的问题，可能是测试覆盖率不够或开发人员对需求理解不清。": "质量控制不足: 高的增量代码缺陷率可能表明在开发过程中存在质量控制不足的问题，可能是测试覆盖率不够或开发人员对需求理解不清。",
  "千行代码缺陷率（Bug Rate）": "千行代码缺陷率（Bug Rate）",
  "是软件开发中常用的质量指标，用于衡量每千行代码中存在的缺陷数量。这个指标在评估软件质量和开发团队绩效时具有重要意义。以下是关于千行代码缺陷率考核指标的详细说明：": "是软件开发中常用的质量指标，用于衡量每千行代码中存在的缺陷数量。这个指标在评估软件质量和开发团队绩效时具有重要意义。以下是关于千行代码缺陷率考核指标的详细说明：",
  "千行代码bug率=bug数/ (代码行数/1000)": "千行代码bug率=bug数/ (代码行数/1000)",
  "例如，如果一个项目有 2000 行代码，发现了 4 个缺陷，则千行代码缺陷率为： 千行代码bug率=4/（2000/1000）=2‰": "例如，如果一个项目有 2000 行代码，发现了 4 个缺陷，则千行代码缺陷率为： 千行代码bug率=4/（2000/1000）=2‰",
  "CMMI 级别与千行代码缺陷率": "CMMI 级别与千行代码缺陷率",
  "CMMI（能力成熟度模型集成）为不同成熟度级别的组织设定了千行代码缺陷率的标准：": "CMMI（能力成熟度模型集成）为不同成熟度级别的组织设定了千行代码缺陷率的标准：",
  "CMMI 1 级:": "CMMI 1 级:",
  "CMMI 2 级:": "CMMI 2 级:",
  "CMMI 3 级:": "CMMI 3 级:",
  "CMMI 4 级:": "CMMI 4 级:",
  "CMMI 5 级:": "CMMI 5 级:",
  "缺少需求名称！": "缺少需求名称！",
  "确认提交": "确认提交",
  "已存在相同类型和名称的任务，如下：": "已存在相同类型和名称的任务，如下：",
  "请选择操作：": "请选择操作：",
  "仍要全部创建": "仍要全部创建",
  "仅创建不存在的": "仅创建不存在的",
  "（注：任务时间不能超过需求起始至交付时间段）": "（注：任务时间不能超过需求起始至交付时间段）",
  "时间跨度不能超过3天，请拆解": "时间跨度不能超过3天，请拆解",
  "单个任务不能超过3天，请拆解": "单个任务不能超过3天，请拆解",
  "请填入必填字段后在创建": "请填入必填字段后在创建",
  "提测检查不通过，请确认itp平台用例冒烟是否通过~": "提测检查不通过，请确认itp平台用例冒烟是否通过~",
  "提测检查通过，可以申请提测": "提测检查通过，可以申请提测",
  "填写提测申请": "填写提测申请",
  "提测检查": "提测检查",
  "CR报告：": "CR报告：",
  "服务名：": "服务名：",
  "分支名：": "分支名：",
  "点击复制CommitId": "点击复制CommitId",
  "CommitId已复制至剪贴板": "CommitId已复制至剪贴板",
  "必填项 (": "必填项 (",
  "此项为必填项": "此项为必填项",
  "确定清空该选项及内容吗？": "确定清空该选项及内容吗？",
  "选择/重新选择配置": "选择/重新选择配置",
  "请输入数据库相关内容": "请输入数据库相关内容",
  "请输入配置相关内容": "请输入配置相关内容",
  "请输入相关内容": "请输入相关内容",
  "重新选择配置": "重新选择配置",
  "最近由": "最近由",
  "于": "于",
  "非必填项 (": "非必填项 (",
  "需求上线检查项": "需求上线检查项",
  "若检查项已被确认，请再次认真核对！": "若检查项已被确认，请再次认真核对！",
  "4周内达成率": "4周内达成率",
  "需求评审": "需求评审",
  "技术评审": "技术评审",
  "用例评审": "用例评审",
  "联调": "联调",
  "提测": "提测",
  "计划上线": "计划上线",
  "产品截止": "产品截止",
  "研发截止": "研发截止",
  "测试截止": "测试截止",
  "技术方案": "技术方案",
  "注意：研发排队后不支持更改需求类型": "注意：研发排队后不支持更改需求类型",
  "迭代周期": "迭代周期",
  "查看业务需求描述": "查看业务需求描述",
  "只读权限！": "只读权限！",
  "计划时间": "计划时间",
  "交付物": "交付物",
  "提测详情": "提测详情",
  "是否创建任务(后端、前端、测试、UI)": "是否创建任务(后端、前端、测试、UI)",
  "不创建": "不创建",
  "点击创建将会给后端、前端、测试、UI创建对应的测试任务，如果已存在任务则不创建！": "点击创建将会给后端、前端、测试、UI创建对应的测试任务，如果已存在任务则不创建！",
  "提测申请正在提交中，稍后会自动退出~": "提测申请正在提交中，稍后会自动退出~",
  "提测申请提交成功，已通知相关人员": "提测申请提交成功，已通知相关人员",
  "请输入需求名称": "请输入需求名称",
  "存为草稿": "存为草稿",
  "请输入需求描述": "请输入需求描述",
  "粘贴链接后输入空格变为超链接": "粘贴链接后输入空格变为超链接",
  "业务需求接口人": "业务需求接口人",
  "如果经由技术支持或产品中转的需求，务必填写正确的需求提出人。": "如果经由技术支持或产品中转的需求，务必填写正确的需求提出人。",
  "需求状态变更时会自动通知到关注人。以便关注人知晓此需求进展情况": "需求状态变更时会自动通知到关注人。以便关注人知晓此需求进展情况",
  "如果业务有明确期望上线日期，则填写此数据即可。": "如果业务有明确期望上线日期，则填写此数据即可。",
  "期待时间": "期待时间",
  "需求状态变更时会自动通知到对应国家的技术支持。以便技术支持知晓此需求进展情况。": "需求状态变更时会自动通知到对应国家的技术支持。以便技术支持知晓此需求进展情况。",
  "产品需求可以归属于国家线或行业线，或同时具备两者的特性，但必须以其中一方为主。具体定义如下：": "产品需求可以归属于国家线或行业线，或同时具备两者的特性，但必须以其中一方为主。具体定义如下：",
  "国家线：业务方提出的需求功能或目标主要服务于特定国家的业务场景，不适用于全球通用业务场景。": "国家线：业务方提出的需求功能或目标主要服务于特定国家的业务场景，不适用于全球通用业务场景。",
  "行业线：业务方提出的需求功能或目标主要服务于特定垂直行业的业务场景，适用于全球通用业务场景。": "行业线：业务方提出的需求功能或目标主要服务于特定垂直行业的业务场景，适用于全球通用业务场景。",
  "默认选择当前需求影响国家下的技术支持。": "默认选择当前需求影响国家下的技术支持。",
  "是否给前端、后端、测试、UI创建对应的任务，一端已存在任务的负责人将不在创建": "是否给前端、后端、测试、UI创建对应的任务，一端已存在任务的负责人将不在创建",
  "自动创建任务": "自动创建任务",
  "不创建任务": "不创建任务",
  "请选择是否自动创建任务": "请选择是否自动创建任务",
  "如果已明确后端开发人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "如果已明确后端开发人员，可预选对应人员。相应人员将会提前收到需求进行预览。",
  "如果已明确前端开发人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "如果已明确前端开发人员，可预选对应人员。相应人员将会提前收到需求进行预览。",
  "如果已明确测试人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "如果已明确测试人员，可预选对应人员。相应人员将会提前收到需求进行预览。",
  "如果已明确UI设计人员，可预选对应人员。相应人员将会提前收到需求进行预览。": "如果已明确UI设计人员，可预选对应人员。相应人员将会提前收到需求进行预览。",
  "该下拉列表展示的是研发效能内部标签。": "该下拉列表展示的是研发效能内部标签。",
  "添加标��": "添加标��",
  "UI设计交付物": "UI设计交付物",
  "技术方案交付物": "技术方案交付物",
  "技术需求": "技术需求",
  "如果需要使用系统培训，将会给系统培训师发消息": "如果需要使用系统培训，将会给系统培训师发消息",
  "未保存的更改": "未保存的更改",
  "离开": "离开",
  "请选择要编辑的需求": "请选择要编辑的需求",
  "编辑现有需求": "编辑现有需求",
  "是否是技术需求": "是否是技术需求",
  "需求描述（粘贴链接后输入空格变为超链接）": "需求描述（粘贴链接后输入空格变为超链接）",
  "按期待完成时间最早": "按期待完成时间最早",
  "按期待完成时间最晚": "按期待完成时间最晚",
  "按实际完成时间最早": "按实际完成时间最早",
  "按实际完成时间最晚": "按实际完成时间最晚",
  "按优先级最高": "按优先级最高",
  "按优先级最低": "按优先级最低",
  "在“只看我”下，不能选择需求执行人": "在“只看我”下，不能选择需求执行人",
  "请选择需求执行人类型": "请选择需求执行人类型",
  "请选择需求执行人": "请选择需求执行人",
  "请选择Sprint": "请选择Sprint",
  "业务满意度": "业务满意度",
  "0~1 代表 大于等于0 ，小于1": "0~1 代表 大于等于0 ，小于1",
  "1~2 代表 大于等于1 ，小于2": "1~2 代表 大于等于1 ，小于2",
  "2~3 代表 大于等于2 ，小于3": "2~3 代表 大于等于2 ，小于3",
  "3~4 代表 大于等于3 ，小于4": "3~4 代表 大于等于3 ，小于4",
  "4 代表 等于4": "4 代表 等于4",
  "请选择业务满意度": "请选择业务满意度",
  "创建开始结束": "创建开始结束",
  "默认展示所有开发角色为自己的需求，并可与其他筛选条件“与”查询": "默认展示所有开发角色为自己的需求，并可与其他筛选条件“与”查询",
  "合并请求": "合并请求",
  "开发分支：": "开发分支：",
  "目标分支：": "目标分支：",
  "失败原因：": "失败原因：",
  "请输入删除原因：": "请输入删除原因：",
  "请先选择需要清空的需求": "请先选择需要清空的需求",
  "已清空所选需求的交接产品": "已清空所选需求的交接产品",
  "请先选择需要交接的需求": "请先选择需要交接的需求",
  "要交接的需求（": "要交接的需求（",
  "关联Bug数": "关联Bug数",
  "关联需求详情列表": "关联需求详情列表",
  "创建人名称": "创建人名称",
  "关联测试用例（冒烟通过率：": "关联测试用例（冒烟通过率：",
  "智能会议纪要数量": "智能会议纪要数量",
  "需求关联评审": "需求关联评审",
  "会议时间": "会议时间",
  "30分钟": "30分钟",
  "1小时": "1小时",
  "1.5小时": "1.5小时",
  "2小时": "2小时",
  "会议开始时提醒": "会议开始时提醒",
  "5分钟前提醒": "5分钟前提醒",
  "15分钟前提醒": "15分钟前提醒",
  "一小时前提醒": "一小时前提醒",
  "一天前提醒": "一天前提醒",
  "会议室": "会议室",
  "请先选择会议时间！": "请先选择会议时间！",
  "请选择发布环境": "请选择发布环境",
  "请输入预计发布时间": "请输入预计发布时间",
  "和这次发布相关的人": "和这次发布相关的人",
  "请输入协同人": "请输入协同人",
  "紧急发布原因": "紧急发布原因",
  "请输入紧急发布原因": "请输入紧急发布原因",
  "请详细说明紧急发布的原因...": "请详细说明紧急发布的原因...",
  "请输入发布描述信息...": "请输入发布描述信息...",
  "是否拉取": "是否拉取",
  "人员列表": "人员列表",
  "拉群人员列表": "拉群人员列表",
  "取消全选": "取消全选",
  "💡 勾选的人员将在创建发布单时自动加入发布群": "💡 勾选的人员将在创建发布单时自动加入发布群",
  "发布检查项": "发布检查项",
  "已显示所有关联服务（包括同仓库服务）": "已显示所有关联服务（包括同仓库服务）",
  "已隐藏同仓库的服务": "已隐藏同仓库的服务",
  "选择分支": "选择分支",
  "最新 Merged By": "最新 Merged By",
  "请先选择服务": "请先选择服务",
  "加载全部分支失败": "加载全部分支失败",
  "选": "选",
  "非常重要！": "非常重要！",
  "服务将按照当前表格顺序发布，默认顺序为后端基础、后端核心、后端其他、前端基础、前端核心、前端其他，可拖动修改发布顺序。": "服务将按照当前表格顺序发布，默认顺序为后端基础、后端核心、后端其他、前端基础、前端核心、前端其他，可拖动修改发布顺序。",
  "请按commit规范提交代码，规范为\"[需求或线上问题的序列号]你的提交描述\"，我们会直接从commit提交记录中拉取当前需求、迭代、回归缺陷、线上问题的服务分支。": "请按commit规范提交代码，规范为\"[需求或线上问题的序列号]你的提交描述\"，我们会直接从commit提交记录中拉取当前需求、迭代、回归缺陷、线上问题的服务分支。",
  "默认不带出同仓库的服务分支，如果需要带出，请点击“显示所有关联服务”": "默认不带出同仓库的服务分支，如果需要带出，请点击“显示所有关联服务”",
  "点击隐藏同仓库的服务": "点击隐藏同仓库的服务",
  "点击显示所有关联服务": "点击显示所有关联服务",
  "（服务：": "（服务：",
  "请选择一个分支": "请选择一个分支",
  "从全部分支中选择": "从全部分支中选择",
  "发布项名称": "发布项名称",
  "关联发布单数量": "关联发布单数量",
  "是否能创建发布单": "是否能创建发布单",
  "发布项明细": "发布项明细",
  "请至少添加一个服务分支": "请至少添加一个服务分支",
  "请完善所有服务分支的服务名称和分支信息": "请完善所有服务分支的服务名称和分支信息",
  "确认提交?": "确认提交?",
  "限制：": "限制：",
  "个/工作项": "个/工作项",
  "⚠️ 已达创建上限": "⚠️ 已达创建上限",
  "需要先预约发布才能创建发布单，": "需要先预约发布才能创建发布单，",
  "去预约": "去预约",
  "平均耗时(天)": "平均耗时(天)",
  "需求状态": "需求状态",
  "产品阶段耗时(天)": "产品阶段耗时(天)",
  "大于3天显示红色，小于等于3天显示绿色": "大于3天显示红色，小于等于3天显示绿色",
  "研发阶段耗时(天)": "研发阶段耗时(天)",
  "测试阶段耗时(天)": "测试阶段耗时(天)",
  "验收阶段耗时(天)": "验收阶段耗时(天)",
  "总耗时(天)": "总耗时(天)",
  "小于等于15天显示绿色，15-30天显示橙色，大于30天显示红色": "小于等于15天显示绿色，15-30天显示橙色，大于30天显示红色",
  "产品等待阶段开始": "产品等待阶段开始",
  "产品等待阶段结束": "产品等待阶段结束",
  "产品方案阶段开始": "产品方案阶段开始",
  "产品方案阶段结束": "产品方案阶段结束",
  "产品评审阶段开始": "产品评审阶段开始",
  "产品评审阶段结束": "产品评审阶段结束",
  "需求阶段耗时": "需求阶段耗时",
  "基础模式": "基础模式",
  "详细模式": "详细模式",
  "数据加载中...": "数据加载中...",
  "正在加载更多数据 (": "正在加载更多数据 (",
  "请填写检查项，红色为必填项": "请填写检查项，红色为必填项",
  "当前需求类型为【": "当前需求类型为【",
  "当前状态流转之后就无法更改需求类型了，请确认是否继续？如果不确定，请与需求相关人员确认后再做决定！": "当前状态流转之后就无法更改需求类型了，请确认是否继续？如果不确定，请与需求相关人员确认后再做决定！",
  "提测申请正在暂存中！": "提测申请正在暂存中！",
  "提测申请已暂存！": "提测申请已暂存！",
  "不是": "不是",
  "提测主题": "提测主题",
  "请输入提测主题": "请输入提测主题",
  "研发人员": "研发人员",
  "请选择研发人员": "请选择研发人员",
  "请选择测试人员": "请选择测试人员",
  "提测环境": "提测环境",
  "请选择提测环境": "请选择提测环境",
  "预计上线日期": "预计上线日期",
  "本地测试结果": "本地测试结果",
  "请选择本地测试结果": "请选择本地测试结果",
  "是否有P0测试用例": "是否有P0测试用例",
  "请选择是否有测试用例": "请选择是否有测试用例",
  "是否新增模块": "是否新增模块",
  "请选择是否新增模块": "请选择是否新增模块",
  "没有P0测试用例的原因": "没有P0测试用例的原因",
  "请填写没有测试用例的原因": "请填写没有测试用例的原因",
  "新增模块说明": "新增模块说明",
  "请填写新增模块说明": "请填写新增模块说明",
  "提测内容": "提测内容",
  "重点测试点": "重点测试点",
  "联调结果": "联调结果",
  "检查项加载中...": "检查项加载中...",
  "检查项信息": "检查项信息",
  "全部选择\"是\"": "全部选择\"是\"",
  "全部选择\"否\"": "全部选择\"否\"",
  "一键选择": "一键选择",
  "请选择是否": "请选择是否",
  "确定要清空该选项及内容吗？": "确定要清空该选项及内容吗？",
  "请输入分支名称": "请输入分支名称",
  "分支名只能包含数字、字母、小数点、短横线和下划线和斜杠分隔符": "分支名只能包含数字、字母、小数点、短横线和下划线和斜杠分隔符",
  "创建分支失败:": "创建分支失败:",
  "创建分支": "创建分支",
  "服务名称：": "服务名称：",
  "分支名称：": "分支名称：",
  "* 分支名只能包含数字、字母、小数点、短横线和下划线和斜杠分隔符": "* 分支名只能包含数字、字母、小数点、短横线和下划线和斜杠分隔符",
  "加载分支列表失败": "加载分支列表失败",
  "加载分支列表失败:": "加载分支列表失败:",
  "请选择开发分支！": "请选择开发分支！",
  "代码合并成功": "代码合并成功",
  "代码合并失败": "代码合并失败",
  "合并分支": "合并分支",
  "请选择开发分支": "请选择开发分支",
  "选择要合并到提测分支的开发分支": "选择要合并到提测分支的开发分支",
  "由": "由",
  "提测分支（目标分支）": "提测分支（目标分支）",
  "开发分支将合并到此分支": "开发分支将合并到此分支",
  "请先选择服务名称！": "请先选择服务名称！",
  "请先创建提测分支！": "请先创建提测分支！",
  "分支创建成功": "分支创建成功",
  "提测分支": "提测分支",
  "请&nbsp;": "请&nbsp;",
  "&nbsp;或&nbsp;": "&nbsp;或&nbsp;",
  "建": "建",
  "&nbsp;一个提测分支": "&nbsp;一个提测分支",
  "删除行": "删除行",
  "删": "删",
  "是否被驳回": "是否被驳回",
  "获取数据失败": "获取数据失败",
  "需求任务甘特图": "需求任务甘特图",
  "任务状况：": "任务状况：",
  "逾期": "逾期",
  "未逾期": "未逾期",
  "需求未设置任务或未设置任务时间": "需求未设置任务或未设置任务时间",
  "人员昵称": "人员昵称",
  "人员岗位": "人员岗位",
  "负责人名称": "负责人名称",
  "负责人岗位": "负责人岗位",
  "需求状态数量统计": "需求状态数量统计",
  "按系统分组": "按系统分组",
  "按人员分组": "按人员分组",
  "需求状态数量明细": "需求状态数量明细",
  "需求自定义阶段数量明细": "需求自定义阶段数量明细",
  "确认要删除任务吗？": "确认要删除任务吗？",
  "甘特图": "甘特图",
  "开始人": "开始人",
  "结束人": "结束人",
  "需求角色阶段耗时明细": "需求角色阶段耗时明细",
  "0.0天": "0.0天",
  "方案阶段": "方案阶段",
  "评审阶段": "评审阶段",
  "研发等待": "研发等待",
  "提测等待": "提测等待",
  "验收等待": "验收等待",
  "暂无信息": "暂无信息",
  "测试用例缺失的原因：": "测试用例缺失的原因：",
  "新增模块说明：": "新增模块说明：",
  "提测内容：": "提测内容：",
  "影响范围：": "影响范围：",
  "重点测试点：": "重点测试点：",
  "联调结果：": "联调结果：",
  "环境配置：": "环境配置：",
  "相关Sql：": "相关Sql：",
  "其他信息：": "其他信息：",
  "数据看板🔥": "数据看板🔥",
  "是否删除规划": "是否删除规划",
  "确认要删除该规划吗？": "确认要删除该规划吗？",
  "删除成功！": "删除成功！",
  "请选择视图": "请选择视图",
  "状态看板": "状态看板",
  "规划看板": "规划看板",
  "新建规划": "新建规划",
  "正在创建中，请勿重复提交": "正在创建中，请勿重复提交",
  "会议开始时间必须在当前时间之后": "会议开始时间必须在当前时间之后",
  "正在创建中，请稍等": "正在创建中，请稍等",
  "创建成功！": "创建成功！",
  "会议周期": "会议周期",
  "不重复": "不重复",
  "每天重复": "每天重复",
  "每个工作日重复": "每个工作日重复",
  "每周重复": "每周重复",
  "每月重复": "每月重复",
  "请选择周期": "请选择周期",
  "会议创建人将自动成为参与人，无需额外选择": "会议创建人将自动成为参与人，无需额外选择",
  "请选择会议参与人": "请选择会议参与人",
  "请输入内容": "请输入内容",
  "当前会议时间段空闲的会议室列表": "当前会议时间段空闲的会议室列表",
  "添加参与人": "添加参与人",
  "克隆评审（会议）": "克隆评审（会议）",
  "该会议相关信息已复制到剪贴板": "该会议相关信息已复制到剪贴板",
  "新建评审（会议）": "新建评审（会议）",
  "展示创建人为自己的记录": "展示创建人为自己的记录",
  "评审": "评审",
  "的会议吗？": "的会议吗？",
  "克隆评审会议": "克隆评审会议",
  "创建评审会议": "创建评审会议",
  "编辑评审会议": "编辑评审会议",
  "评审需求只能未关闭的需求": "评审需求只能未关闭的需求",
  "评审Sprint只能是进行中的Sprint": "评审Sprint只能是进行中的Sprint",
  "评审测试用例只能是未完成评审的用例": "评审测试用例只能是未完成评审的用例",
  "评审（会议）周期": "评审（会议）周期",
  "评审（会议）创建人将自动成为参与人，无需额外选择": "评审（会议）创建人将自动成为参与人，无需额外选择",
  "请选择评审（会议）参与人": "请选择评审（会议）参与人",
  "如果选择预约，在提交表单时会直接预约一个会议": "如果选择预约，在提交表单时会直接预约一个会议",
  "当前评审时间段空闲的会议室列表": "当前评审时间段空闲的会议室列表",
  "评审确认情况": "评审确认情况",
  "AI智能会议纪要": "AI智能会议纪要",
  "按章节": "按章节",
  "按主题": "按主题",
  "按发言人": "按发言人",
  "请选择当前评审时间段空闲的会议室": "请选择当前评审时间段空闲的会议室",
  "空闲": "空闲",
  "最多只能选6个会议室": "最多只能选6个会议室",
  "评审时间": "评审时间",
  "您不是会议参与人，没有权限查看该智能会议纪要": "您不是会议参与人，没有权限查看该智能会议纪要",
  "会议纪要(双击填写)": "会议纪要(双击填写)",
  "双击填写": "双击填写",
  "会议纪要附件": "会议纪要附件",
  "会议录制文件标题": "会议录制文件标题",
  "开始录制时间": "开始录制时间",
  "结束录制时间": "结束录制时间",
  "参会人": "参会人",
  "查看AI智能会议纪要": "查看AI智能会议纪要",
  "评审关联会议详情": "评审关联会议详情",
  "会议室（时间不得超过14天）": "会议室（时间不得超过14天）",
  "周期性会议不支持选择会议室": "周期性会议不支持选择会议室",
  "请先选择时间！": "请先选择时间！",
  "请先选择评审时间！": "请先选择评审时间！",
  "评审关联详情": "评审关联详情",
  "会议纪要": "会议纪要",
  "规划添加需求（默认展示自己创建的需求）": "规划添加需求（默认展示自己创建的需求）",
  "正在导出，请稍后...": "正在导出，请稍后...",
  "下载图片": "下载图片",
  "下载": "下载",
  "链接已失效": "链接已失效",
  "需求详情列表": "需求详情列表",
  "任务负责人": "任务负责人",
  "只允许任务负责人删除": "只允许任务负责人删除",
  "迭代开始后移入": "迭代开始后移入",
  "迭代开始后移出": "迭代开始后移出",
  "个工作项尚未完成，请处理后再完成迭代": "个工作项尚未完成，请处理后再完成迭代",
  "确认起始时间完成迭代": "确认起始时间完成迭代",
  "确认起始时间": "确认起始时间",
  "把它们移除本迭代，移至未规划": "把它们移除本迭代，移至未规划",
  "把它们移至其他迭代": "把它们移至其他迭代",
  "度量指标": "度量指标",
  "标准值": "标准值",
  "千行代码缺陷率": "千行代码缺陷率",
  "（缺陷总数/代码行数）* 1000": "（缺陷总数/代码行数）* 1000",
  "移动端：&lt;": "移动端：&lt;",
  "前端：&lt;": "前端：&lt;",
  "后端：&lt;": "后端：&lt;",
  "查看任务详情": "查看任务详情",
  "查看缺陷详情": "查看缺陷详情",
  "计划暂停至日期": "计划暂停至日期",
  "更换Sprint": "更换Sprint",
  "取消批量": "取消批量",
  "批量选择": "批量选择",
  "数据明细": "数据明细",
  "迭代已完成归档，如需查看请切换到「已归档」下查看": "迭代已完成归档，如需查看请切换到「已归档」下查看",
  "编辑迭代": "编辑迭代",
  "解锁": "解锁",
  "是否删除迭代吗": "是否删除迭代吗",
  "确认要删除迭代吗？": "确认要删除迭代吗？",
  "删除迭代": "删除迭代",
  "树形": "树形",
  "阶段看板": "阶段看板",
  "缺陷列表": "缺陷列表",
  "产品经理：": "产品经理：",
  "后端开发：": "后端开发：",
  "前端开发：": "前端开发：",
  "测试开发：": "测试开发：",
  "UI设计：": "UI设计：",
  "技术支持：": "技术支持：",
  "业务对接：": "业务对接：",
  "关注人：": "关注人：",
  "相关人：": "相关人：",
  "功能使用：": "功能使用：",
  "Sprint迭代": "Sprint迭代",
  "未规划工作项（产品需求）": "未规划工作项（产品需求）",
  "工作项": "工作项",
  "迭代名称和链接已复制到剪贴板": "迭代名称和链接已复制到剪贴板",
  "提醒成功": "提醒成功",
  "催开始": "催开始",
  "催结束": "催结束",
  "规划迭代": "规划迭代",
  "开始迭代": "开始迭代",
  "完成迭代": "完成迭代",
  "发布迭代": "发布迭代",
  "创建人：": "创建人：",
  "迭代周期：": "迭代周期：",
  "迭代进度：": "迭代进度：",
  "目标进度：": "目标进度：",
  "开始迭代：": "开始迭代：",
  "完成迭代：": "完成迭代：",
  "后端研发：": "后端研发：",
  "前端研发：": "前端研发：",
  "当前状态：": "当前状态：",
  "迭代目标：": "迭代目标：",
  "未规划项（拖动需要展开Sprint）": "未规划项（拖动需要展开Sprint）",
  "锁定已锁定，不能规划迭代，请联系负责人解锁后再操作": "锁定已锁定，不能规划迭代，请联系负责人解锁后再操作",
  "确认后，当前状态将被标记为该需求的迭代目标，操作完成！": "确认后，当前状态将被标记为该需求的迭代目标，操作完成！",
  "迭代目标状态：": "迭代目标状态：",
  "暂无迭代目标": "暂无迭代目标",
  "迭代尚未开始": "迭代尚未开始",
  "返回旧版": "返回旧版",
  "新建Sprint": "新建Sprint",
  "交接迭代": "交接迭代",
  "当前没有可交接的迭代": "当前没有可交接的迭代",
  "人天": "人天",
  "迭代工时概览": "迭代工时概览",
  "（1人天 = 8小时）": "（1人天 = 8小时）",
  "开始": "开始",
  "请到Sprint（新版）右上角完成迭代": "请到Sprint（新版）右上角完成迭代",
  "工作项变更": "工作项变更",
  "工作项概览": "工作项概览",
  "查看任务列表": "查看任务列表",
  "添加需求任务": "添加需求任务",
  "目标(双击开始编辑)": "目标(双击开始编辑)",
  "Sprint名称和链接已剪贴板": "Sprint名称和链接已剪贴板",
  "请先选择交接负责人": "请先选择交接负责人",
  "已批量填充空白交接负责人": "已批量填充空白交接负责人",
  "请先勾选需要清空的迭代": "请先勾选需要清空的迭代",
  "已清空选中迭代的交接负责人": "已清空选中迭代的交接负责人",
  "请先选择需要交接的迭代": "请先选择需要交接的迭代",
  "请选择交接负责人": "请选择交接负责人",
  "迭代目标": "迭代目标",
  "时间周期": "时间周期",
  "当前负责人": "当前负责人",
  "交接负责人": "交接负责人",
  "迭代交接": "迭代交接",
  "要交接的迭代（": "要交接的迭代（",
  "交接负责人：": "交接负责人：",
  "统一选择交接负责人": "统一选择交接负责人",
  "隐藏无法操作的迭代": "隐藏无法操作的迭代",
  "请输入Sprint名称": "请输入Sprint名称",
  "Sprint名称不能包含中文字符": "Sprint名称不能包含中文字符",
  "该Sprint包含的需求，一个需求只能属于一个Sprint": "该Sprint包含的需求，一个需求只能属于一个Sprint",
  "版本号只能以数字开头结尾并且用小数点连接（如 1.0.0），创建迭代会自动版本+1": "版本号只能以数字开头结尾并且用小数点连接（如 1.0.0），创建迭代会自动版本+1",
  "格式不正确，(如 1.0.0)": "格式不正确，(如 1.0.0)",
  "邮件抄送人": "邮件抄送人",
  "请输入迭代目标": "请输入迭代目标",
  "在“只看我”下，不能选择负责人": "在“只看我”下，不能选择负责人",
  "请至少选择一个状态": "请至少选择一个状态",
  "周期开始": "周期开始",
  "周期结束": "周期结束",
  "正在添加": "正在添加",
  "添加失败，请重试！": "添加失败，请重试！",
  "更新中": "更新中",
  "更新成功！": "更新成功！",
  "更新失败，请重试！": "更新失败，请重试！",
  "是否删除Sprint": "是否删除Sprint",
  "确认要删除Sprint吗？": "确认要删除Sprint吗？",
  "Sprint（新版）": "Sprint（新版）",
  "大类筛选（可选，不选则显示全部）": "大类筛选（可选，不选则显示全部）",
  "选择大类以缩小范围": "选择大类以缩小范围",
  "输入要创建的分支名称或选择分支": "输入要创建的分支名称或选择分支",
  "存在未创建的分支，请点击分支后的“ + ”创建后再保存任务": "存在未创建的分支，请点击分支后的“ + ”创建后再保存任务",
  "所属需求：": "所属需求：",
  "服务类型、服务、分支不能为空！": "服务类型、服务、分支不能为空！",
  "需求 & 服务分支(双击开始编辑)": "需求 & 服务分支(双击开始编辑)",
  "任务描述(双击开始编辑)": "任务描述(双击开始编辑)",
  "任务名称和链接已剪贴板": "任务名称和链接已剪贴板",
  "系统与Sprint、需求下拉框会有联动效果": "系统与Sprint、需求下拉框会有联动效果",
  "筛选大类": "筛选大类",
  "Sprint下拉选择只有筛选需求的作用，任务只会与需求直接关联": "Sprint下拉选择只有筛选需求的作用，任务只会与需求直接关联",
  "该下拉列表展示的是“任务中心”标签。": "该下拉列表展示的是“任务中心”标签。",
  "该任务相关联的服务(注:服务类型选择后，服务名称下拉框会自动加载服务名称)": "该任务相关联的服务(注:服务类型选择后，服务名称下拉框会自动加载服务名称)",
  "输入分支“+”创建或选择分支": "输入分支“+”创建或选择分支",
  "数字、字母、小数点、短横线、下划线": "数字、字母、小数点、短横线、下划线",
  "创建远程分支": "创建远程分支",
  "删除当前行": "删除当前行",
  "在“只看我”下，不能选择参与人": "在“只看我”下，不能选择参与人",
  "请选择参与人": "请选择参与人",
  "默认展示负责人、参与人、创建人为自己的记录，并可与其他筛选条件“与”查询": "默认展示负责人、参与人、创建人为自己的记录，并可与其他筛选条件“与”查询",
  "相关任务": "相关任务",
  "取消排序": "取消排序",
  "新建状态流转规则": "新建状态流转规则",
  "编辑状态流转规则": "编辑状态流转规则",
  "当工作项从": "当工作项从",
  "进入": "进入",
  "时，需要满足：": "时，需要满足：",
  "字段": "字段",
  "必填，": "必填，",
  "部分人": "部分人",
  "操作，": "操作，",
  "且": "且",
  "添加其它字段条件": "添加其它字段条件",
  "字段条件": "字段条件",
  "添加必填字段": "添加必填字段",
  "添加操作人员": "添加操作人员",
  "执行人角色": "执行人角色",
  "具体人员": "具体人员",
  "添加状态": "添加状态",
  "状态阶段列表": "状态阶段列表",
  "新增阶段": "新增阶段",
  "请输入阶段名称或描述或编码": "请输入阶段名称或描述或编码",
  "】 状态阶段吗？": "】 状态阶段吗？",
  "状态名称（中文）": "状态名称（中文）",
  "状态名称（英文）": "状态名称（英文）",
  "状态描述": "状态描述",
  "状态阶段名称": "状态阶段名称",
  "状态阶段回显颜色": "状态阶段回显颜色",
  "状态列表": "状态列表",
  "新增状态": "新增状态",
  "请输入状态名称或描述或编码": "请输入状态名称或描述或编码",
  "】 状态吗？": "】 状态吗？",
  "配置状态": "配置状态",
  "配置状态阶段": "配置状态阶段",
  "创建一个工作流": "创建一个工作流",
  "排序号：": "排序号：",
  "编辑工作所属状态": "编辑工作所属状态",
  "编辑工作流基础信息": "编辑工作流基础信息",
  "克隆工作流": "克隆工作流",
  "删除工作流": "删除工作流",
  "点击转正草稿": "点击转正草稿",
  "点击关闭对外展示": "点击关闭对外展示",
  "对外展示": "对外展示",
  "点击开启对外展示": "点击开启对外展示",
  "对外隐藏": "对外隐藏",
  "确定删除 【": "确定删除 【",
  "】 工作流吗": "】 工作流吗",
  "确定克隆 【": "确定克隆 【",
  "确定转正 【": "确定转正 【",
  "工作流草稿已成功转正": "工作流草稿已成功转正",
  "】 工作流对外展示吗": "】 工作流对外展示吗",
  "配置 【": "配置 【",
  "】 工作流状态": "】 工作流状态",
  "配置工作流所属状态及状态流转": "配置工作流所属状态及状态流转",
  "创建完成": "创建完成",
  "工作流已成功创建，请点击完成按钮完成创建并退出！": "工作流已成功创建，请点击完成按钮完成创建并退出！",
  "创建 【": "创建 【",
  "】 工作流": "】 工作流",
  "上一步": "上一步",
  "请先点击保存按钮保存工作流基础信息": "请先点击保存按钮保存工作流基础信息",
  "工作流已成功创建": "工作流已成功创建",
  "工作流名称": "工作流名称",
  "工作流描述": "工作流描述",
  "请输入排序号": "请输入排序号",
  "工作流Logo": "工作流Logo",
  "状态名称(中文)": "状态名称(中文)",
  "状态名称(英文)": "状态名称(英文)",
  "状态所属阶段": "状态所属阶段",
  "阶段名称(中文)": "阶段名称(中文)",
  "阶段名称(英文)": "阶段名称(英文)",
  "阶段描述": "阶段描述",
  "】 工作流基础信息": "】 工作流基础信息",
  "鼠标左键按住拖动调整顺序": "鼠标左键按住拖动调整顺序",
  "移除状态": "移除状态",
  "确定移除": "确定移除",
  "吗": "吗",
  "移除成功": "移除成功",
  "的流转规则吗": "的流转规则吗",
  "审批流程配置 -": "审批流程配置 -",
  "添加审批节点": "添加审批节点",
  "编辑审批类型": "编辑审批类型",
  "添加审批类型": "添加审批类型",
  "请输入审批类型名称，如：请假审批、报销审批等": "请输入审批类型名称，如：请假审批、报销审批等",
  "请输入审批类型名称": "请输入审批类型名称",
  "Code是审批类型的唯一标识，用于在审批流程中引用，命名规则：全大写字母，用_分割，如：PROJECT_APPLY等": "Code是审批类型的唯一标识，用于在审批流程中引用，命名规则：全大写字母，用_分割，如：PROJECT_APPLY等",
  "请输入审批类型Code，全大写字母，用_分割": "请输入审批类型Code，全大写字母，用_分割",
  "请输入审批类型Code": "请输入审批类型Code",
  "请详细描述这个审批类型的用途和流程，帮助用户更好地理解": "请详细描述这个审批类型的用途和流程，帮助用户更好地理解",
  "管理人员": "管理人员",
  "请选择审批类型管理人员": "请选择审批类型管理人员",
  "管理人员可修改已发起审批单的审批人": "管理人员可修改已发起审批单的审批人",
  "解析审批者类别 ruleScope 失败:": "解析审批者类别 ruleScope 失败:",
  "节点配置 -": "节点配置 -",
  "基础配置": "基础配置",
  "是否合并审批": "是否合并审批",
  "合并审批说明：": "合并审批说明：",
  "合并": "合并",
  "：将该规则节点的所有审批人员视为一个整体发起审批": "：将该规则节点的所有审批人员视为一个整体发起审批",
  "独立": "独立",
  "：按照业务领域或系统或服务作为审批小组独立发起审批": "：按照业务领域或系统或服务作为审批小组独立发起审批",
  "注意：合并模式适用于需要统一审批的场景，独立模式适用于按业务分组审批的场景": "注意：合并模式适用于需要统一审批的场景，独立模式适用于按业务分组审批的场景",
  "审批者类别": "审批者类别",
  "通过规则": "通过规则",
  "审批人员": "审批人员",
  "追加固定审批人": "追加固定审批人",
  "请选择审批人员": "请选择审批人员",
  "可选：追加固定审批人": "可选：追加固定审批人",
  "作用域配置": "作用域配置",
  "域范围": "域范围",
  "只用于": "只用于",
  "不用于": "不用于",
  "域类型": "域类型",
  "域值": "域值",
  "删除节点": "删除节点",
  "上移": "上移",
  "下移": "下移",
  "克隆节点": "克隆节点",
  "在此节点后添加": "在此节点后添加",
  "没有配置人员": "没有配置人员",
  "自动获取 +": "自动获取 +",
  "系统自动获取": "系统自动获取",
  "业务": "业务",
  "放大": "放大",
  "重置聚焦": "重置聚焦",
  "重置视图": "重置视图",
  "重置缩放": "重置缩放",
  "暂无审批节点，点击\"添加审批节点\"开始设计流程": "暂无审批节点，点击\"添加审批节点\"开始设计流程",
  "结束": "结束",
  "加载审批规则失败": "加载审批规则失败",
  "节点克隆成功": "节点克隆成功",
  "保存失败": "保存失败",
  "禁用": "禁用",
  "编辑类型": "编辑类型",
  "删除类型": "删除类型",
  "确定要删除这个审批类型吗？": "确定要删除这个审批类型吗？",
  "规则配置": "规则配置",
  "搜索审批类型名称、Code或描述": "搜索审批类型名称、Code或描述",
  "状态更新失败，请重试！": "状态更新失败，请重试！",
  "确认关闭该业务领域？": "确认关闭该业务领域？",
  "关联部门": "关联部门",
  "企微群ID": "企微群ID",
  "飞书群ID": "飞书群ID",
  "飞书BUG群ID": "飞书BUG群ID",
  "业务群机器人url": "业务群机器人url",
  "新增业务领域": "新增业务领域",
  "请输入业务领域名称": "请输入业务领域名称",
  "保存中": "保存中",
  "保存失败，请重试": "保存失败，请重试",
  "研发接口人": "研发接口人",
  "飞书需求群聊ID": "飞书需求群聊ID",
  "新增系统": "新增系统",
  "请输入系统名称或系统key": "请输入系统名称或系统key",
  "关联数据库": "关联数据库",
  "机器人url": "机器人url",
  "创建该系统的线上问题时，研发接口人将会被拉到线上问题群": "创建该系统的线上问题时，研发接口人将会被拉到线上问题群",
  "行业线编码(唯一且不能修改)": "行业线编码(唯一且不能修改)",
  "行业线编码只能包含字母、数字、横划线和下划线": "行业线编码只能包含字母、数字、横划线和下划线",
  "行业线名称": "行业线名称",
  "父级行业线": "父级行业线",
  "激活": "激活",
  "行业线编码": "行业线编码",
  "请输入行业线名称或编码": "请输入行业线名称或编码",
  "新增行业线": "新增行业线",
  "打标明细": "打标明细",
  "确认要删除标签吗？": "确认要删除标签吗？",
  "请输入标签名称": "请输入标签名称",
  "新增标签": "新增标签",
  "属性信息配置（待实现）": "属性信息配置（待实现）",
  "缺少组ID，无法保存": "缺少组ID，无法保存",
  "基础信息保存成功": "基础信息保存成功",
  "基础信息编辑": "基础信息编辑",
  "组名称": "组名称",
  "请输入组名称": "请输入组名称",
  "组名称不能超过50个字符": "组名称不能超过50个字符",
  "负责人可以管理该卡片组，并进行卡片分发与编辑(不包含删除权限,只有创建人才能删除卡片组) ps:卡片赠送消息会抄送负责人": "负责人可以管理该卡片组，并进行卡片分发与编辑(不包含删除权限,只有创建人才能删除卡片组) ps:卡片赠送消息会抄送负责人",
  "关联TOP部门": "关联TOP部门",
  "卡片将在这些top部门内部流转": "卡片将在这些top部门内部流转",
  "请选择关联TOP部门": "请选择关联TOP部门",
  "请选择TOP部门": "请选择TOP部门",
  "组描述": "组描述",
  "请输入组描述（选填）": "请输入组描述（选填）",
  "组描述不能超过200个字符": "组描述不能超过200个字符",
  "活动名称": "活动名称",
  "同人同卡最大赠送数": "同人同卡最大赠送数",
  "提醒周期": "提醒周期",
  "第几小时提醒": "第几小时提醒",
  "确认手动触发未使用卡片提醒吗？": "确认手动触发未使用卡片提醒吗？",
  "提醒": "提醒",
  "确认删除该活动吗？": "确认删除该活动吗？",
  "请选择卡片组": "请选择卡片组",
  "请选择活动时间": "请选择活动时间",
  "活动更新成功": "活动更新成功",
  "活动创建成功": "活动创建成功",
  "活动列表": "活动列表",
  "新建活动": "新建活动",
  "暂无活动": "暂无活动",
  "编辑活动": "编辑活动",
  "请输入活动名称": "请输入活动名称",
  "活动时间": "活动时间",
  "同人同卡最大赠送数量": "同人同卡最大赠送数量",
  "可选，默认不限": "可选，默认不限",
  "设置后会给未使用卡片人员发送提醒通知": "设置后会给未使用卡片人员发送提醒通知",
  "可选，选择后需配置提醒小时": "可选，选择后需配置提醒小时",
  "可选，范围 0~23": "可选，范围 0~23",
  "分发原因": "分发原因",
  "单人发放数量": "单人发放数量",
  "发放人数": "发放人数",
  "总发放数": "总发放数",
  "确认撤回该分发批次吗？": "确认撤回该分发批次吗？",
  "撤回成功": "撤回成功",
  "撤回": "撤回",
  "分发批次记录": "分发批次记录",
  "请选择卡片组后查看分发批次记录": "请选择卡片组后查看分发批次记录",
  "卡片名称": "卡片名称",
  "持有人": "持有人",
  "生效时间": "生效时间",
  "失效时间": "失效时间",
  "发放人": "发放人",
  "发放时间": "发放时间",
  "持有人:": "持有人:",
  "请选择持有人": "请选择持有人",
  "卡片:": "卡片:",
  "请选择卡片": "请选择卡片",
  "发放时间:": "发放时间:",
  "分发记录": "分发记录",
  "请选择卡片组后查看分发记录": "请选择卡片组后查看分发记录",
  "赠送人": "赠送人",
  "接收人所属部门": "接收人所属部门",
  "赠送装饰": "赠送装饰",
  "赠送时间": "赠送时间",
  "导出失败:": "导出失败:",
  "赠送人:": "赠送人:",
  "请选择赠送人": "请选择赠送人",
  "接收人:": "接收人:",
  "赠送时间:": "赠送时间:",
  "赠送记录": "赠送记录",
  "请选择卡片组后查看赠送记录": "请选择卡片组后查看赠送记录",
  "请选择卡片组后再分发": "请选择卡片组后再分发",
  "模板信息异常，无法分发": "模板信息异常，无法分发",
  "请至少选择一个部门": "请至少选择一个部门",
  "所选部门暂无人员": "所选部门暂无人员",
  "请至少选择一位人员": "请至少选择一位人员",
  "分发成功": "分发成功",
  "有效期": "有效期",
  "请选择有效期": "请选择有效期",
  "分发数量": "分发数量",
  "请输入分发数量": "请输入分发数量",
  "分发数量需大于0": "分发数量需大于0",
  "请输入数量": "请输入数量",
  "请填写分发原因": "请填写分发原因",
  "选人模式": "选人模式",
  "按部门": "按部门",
  "按人员": "按人员",
  "指定部门": "指定部门",
  "指定人员": "指定人员",
  "请选择分发人员": "请选择分发人员",
  "卡片赠送情况占比": "卡片赠送情况占比",
  "请选择卡片类型": "请选择卡片类型",
  "卡片净收到数量排行": "卡片净收到数量排行",
  "暂无卡片净收到数量排行数据": "暂无卡片净收到数量排行数据",
  "赠送": "赠送",
  "分发卡片": "分发卡片",
  "确定要删除这个卡片吗？": "确定要删除这个卡片吗？",
  "请输入卡片名称": "请输入卡片名称",
  "请选择卡片适用范围": "请选择卡片适用范围",
  "卡片模板更新成功": "卡片模板更新成功",
  "卡片模板创建成功": "卡片模板创建成功",
  "暂无素材": "暂无素材",
  "无背景": "无背景",
  "卡片适用范围": "卡片适用范围",
  "卡片使用规则": "卡片使用规则",
  "请输入卡片使用规则": "请输入卡片使用规则",
  "背景素材库": "背景素材库",
  "新增卡片": "新增卡片",
  "模板信息异常，无法删除": "模板信息异常，无法删除",
  "分发批次": "分发批次",
  "活动配置": "活动配置",
  "请先新建一个活动哦": "请先新建一个活动哦",
  "创建活动后即可配置卡片。": "创建活动后即可配置卡片。",
  "快速创建活动": "快速创建活动",
  "卡片类型配置保存成功": "卡片类型配置保存成功",
  "卡片类型配置": "卡片类型配置",
  "卡片类型名称": "卡片类型名称",
  "请输入卡片类型名称": "请输入卡片类型名称",
  "卡片类型编码": "卡片类型编码",
  "只能包含大写字母和下划线": "只能包含大写字母和下划线",
  "请输入卡片类型编码": "请输入卡片类型编码",
  "卡片类型编码只能包含大写字母和下划线": "卡片类型编码只能包含大写字母和下划线",
  "请输入卡片类型编码（大写字母和下划线）": "请输入卡片类型编码（大写字母和下划线）",
  "适用范围": "适用范围",
  "请选择适用范围": "请选择适用范围",
  "确定要删除这条记录吗？": "确定要删除这条记录吗？",
  "添加卡片类型": "添加卡片类型",
  "表单未初始化": "表单未初始化",
  "请完善卡片类型信息": "请完善卡片类型信息",
  "请完善表单信息": "请完善表单信息",
  "创建失败": "创建失败",
  "创建卡片组": "创建卡片组",
  "完成创建": "完成创建",
  "卡片素材": "卡片素材",
  "组素材保存成功": "组素材保存成功",
  "组素材配置": "组素材配置",
  "仅支持上传 PNG/JPG/SVG 图片": "仅支持上传 PNG/JPG/SVG 图片",
  "背景素材": "背景素材",
  "点击批量上传": "点击批量上传",
  "装饰素材": "装饰素材",
  "素材配置": "素材配置",
  "删除组": "删除组",
  "确定要删除这个组吗？": "确定要删除这个组吗？",
  "月份": "月份",
  "指标类型": "指标类型",
  "指标单位": "指标单位",
  "考核角色": "考核角色",
  "基线值": "基线值",
  "确定删除该基线吗？": "确定删除该基线吗？",
  "新增基线": "新增基线",
  "编辑基线": "编辑基线",
  "请选择关联类型": "请选择关联类型",
  "年-月": "年-月",
  "请选择年月": "请选择年月",
  "（单位：": "（单位：",
  "批量新增基线": "批量新增基线",
  "请至少选择一个年月": "请至少选择一个年月",
  "选择图标": "选择图标",
  "请选择指标图标": "请选择指标图标",
  "提交失败，请检查表单": "提交失败，请检查表单",
  "新增指标": "新增指标",
  "编辑指标": "编辑指标",
  "更换图标": "更换图标",
  "请输入指标名称": "请输入指标名称",
  "指标编码": "指标编码",
  "请输入指标编码": "请输入指标编码",
  "请选择指标类型": "请选择指标类型",
  "能否算分": "能否算分",
  "请选择能否算分": "请选择能否算分",
  "请选择考核角色": "请选择考核角色",
  "指标极性": "指标极性",
  "请选择指标极性": "请选择指标极性",
  "请选择指标单位": "请选择指标单位",
  "指标级别": "指标级别",
  "指标归属": "指标归属",
  "指标描述": "指标描述",
  "请输入指标描述": "请输入指标描述",
  "状态切换成功": "状态切换成功",
  "查看基线详情": "查看基线详情",
  "确定删除该指标吗？": "确定删除该指标吗？",
  "请输入指标名称/编码/描述": "请输入指标名称/编码/描述",
  "单个新增": "单个新增",
  "批量新增": "批量新增",
  "配置指标": "配置指标",
  "交付": "交付",
  "效率": "效率",
  "代码": "代码",
  "协作": "协作",
  "工时": "工时",
  "质量": "质量",
  "增长": "增长",
  "下降": "下降",
  "进展": "进展",
  "分析": "分析",
  "报表": "报表",
  "总览": "总览",
  "数据": "数据",
  "安全": "安全",
  "监控": "监控",
  "性能": "性能",
  "热点": "热点",
  "雷达": "雷达",
  "漏斗": "漏斗",
  "节点类型": "节点类型",
  "节点": "节点",
  "节点描述不能为空": "节点描述不能为空",
  "节点驳回描述（中文）": "节点驳回描述（中文）",
  "节点驳回描述（英文）": "节点驳回描述（英文）",
  "回退节点；可不设置，不设置默认按操作记录回退为上一操作节点": "回退节点；可不设置，不设置默认按操作记录回退为上一操作节点",
  "节点描述": "节点描述",
  "回退节点": "回退节点",
  "确认要删除驳回节点吗？": "确认要删除驳回节点吗？",
  "新增驳回节点": "新增驳回节点",
  "请输入查询条件": "请输入查询条件",
  "无操作权限": "无操作权限",
  "服务组": "服务组",
  "git组": "git组",
  "git名称": "git名称",
  "请输入git名称": "请输入git名称",
  "请输入有效的git名称，例如：https://git.imile.com/tech/athena.git": "请输入有效的git名称，例如：https://git.imile.com/tech/athena.git",
  "服务描述": "服务描述",
  "已部署环境": "已部署环境",
  "环境数量": "环境数量",
  "开发": "开发",
  "添加环境": "添加环境",
  "克隆后，请及时修改服务名": "克隆后，请及时修改服务名",
  "克隆服务基础信息": "克隆服务基础信息",
  "删除后，【服务环境记录】与【服务jenkins配置】也会一并删除，确认要删除吗？": "删除后，【服务环境记录】与【服务jenkins配置】也会一并删除，确认要删除吗？",
  "服务基础信息列表": "服务基础信息列表",
  "新增服务": "新增服务",
  "请输入服务名或服务描述": "请输入服务名或服务描述",
  "日志url": "日志url",
  "副本数": "副本数",
  "镜像列表": "镜像列表",
  "是否灰度发布": "是否灰度发布",
  "域名配置": "域名配置",
  "发布窗口开始时间": "发布窗口开始时间",
  "发布窗口截止时间": "发布窗口截止时间",
  "克隆环境": "克隆环境",
  "服务关联环境列表": "服务关联环境列表",
  "新增环境": "新增环境",
  "克隆环境配置": "克隆环境配置",
  "请选择目标环境": "请选择目标环境",
  "目标环境": "目标环境",
  "新增环境配置": "新增环境配置",
  "编辑环境配置": "编辑环境配置",
  "发布窗口时间": "发布窗口时间",
  "Apollo环境": "Apollo环境",
  "数据库名": "数据库名",
  "域名对象": "域名对象",
  "应用说明": "应用说明",
  "订阅后会在配置和数据库变更后推送企微消息，前端不支持订阅": "订阅后会在配置和数据库变更后推送企微消息，前端不支持订阅",
  "配置服务": "配置服务",
  "订阅人更新成功": "订阅人更新成功",
  "更新失败": "更新失败",
  "编辑订阅人失败:": "编辑订阅人失败:",
  "选择订阅人：": "选择订阅人：",
  "请选择订阅人": "请选择订阅人",
  "新的状态组": "新的状态组",
  "状态中文名": "状态中文名",
  "状态英文名": "状态英文名",
  "类型编码": "类型编码",
  "类型名称": "类型名称",
  "正常": "正常",
  "新增类型": "新增类型",
  "请输入编码或名称或描述": "请输入编码或名称或描述",
  "请输入编码或中英文名称": "请输入编码或中英文名称",
  "保存草稿失败:": "保存草稿失败:",
  "表单提交失败:": "表单提交失败:",
  "新增版本": "新增版本",
  "如：v2.1.0": "如：v2.1.0",
  "请输入版本号": "请输入版本号",
  "版本号格式不正确，请输入如：v2.1.0 ，v1.0.0-beta格式（必须以v开头）": "版本号格式不正确，请输入如：v2.1.0 ，v1.0.0-beta格式（必须以v开头）",
  "请选择发布时间": "请选择发布时间",
  "选择发布时间": "选择发布时间",
  "一句话描述本次发布内容（可选）": "一句话描述本次发布内容（可选）",
  "版本摘要": "版本摘要",
  "请输入版本摘要（可选）": "请输入版本摘要（可选）",
  "更新明细": "更新明细",
  "更新类型": "更新类型",
  "选择类型": "选择类型",
  "请选择更新类型": "请选择更新类型",
  "更新内容": "更新内容",
  "请输入更新内容": "请输入更新内容",
  "最新版本": "最新版本",
  "📝 版本摘要": "📝 版本摘要",
  "📋 更新内容": "📋 更新内容",
  "项更新": "项更新",
  "目录": "目录",
  "查看所有功能更新和版本历史，了解最新系统改进": "查看所有功能更新和版本历史，了解最新系统改进",
  "暂无草稿版本": "暂无草稿版本",
  "暂无发布版本": "暂无发布版本",
  "创建第一个版本": "创建第一个版本",
  "请填写完整的中文模板内容": "请填写完整的中文模板内容",
  "中文模板": "中文模板",
  "请输入中文模板内容": "请输入中文模板内容",
  "英文模板": "英文模板",
  "是否启用": "是否启用",
  "模版所有者": "模版所有者",
  "确认要删除模版吗？": "确认要删除模版吗？",
  "新增模版": "新增模版",
  "搜索类型（名称）": "搜索类型（名称）",
  "暂无订阅类型": "暂无订阅类型",
  "确认删除该订阅类型？": "确认删除该订阅类型？",
  "删除类型后将无法在页面选择该类型。": "删除类型后将无法在页面选择该类型。",
  "新增订阅类型": "新增订阅类型",
  "编辑订阅类型": "编辑订阅类型",
  "请输入类型名称": "请输入类型名称",
  "例如：需求池订阅": "例如：需求池订阅",
  "类型 CODE": "类型 CODE",
  "请输入类型 CODE": "请输入类型 CODE",
  "仅支持字母/数字/_/-": "仅支持字母/数字/_/-",
  "例如：POOL_SUBSCRIBE": "例如：POOL_SUBSCRIBE",
  "关联值类型": "关联值类型",
  "请选择关联值类型": "请选择关联值类型",
  "订阅值": "订阅值",
  "请选择一个订阅类型": "请选择一个订阅类型",
  "搜索订阅值（名称）": "搜索订阅值（名称）",
  "产品需求状态": "产品需求状态",
  "订阅类型编码缺失，无法保存": "订阅类型编码缺失，无法保存",
  "请至少选择一个订阅值": "请至少选择一个订阅值",
  "订阅已保存": "订阅已保存",
  "保存订阅失败，请重试": "保存订阅失败，请重试",
  "无权限：仅 CTO 可新增订阅类型": "无权限：仅 CTO 可新增订阅类型",
  "无权限：仅创建人可编辑该类型": "无权限：仅创建人可编辑该类型",
  "已新增订阅类型": "已新增订阅类型",
  "已更新订阅类型": "已更新订阅类型",
  "无权限：仅创建人可删除该类型": "无权限：仅创建人可删除该类型",
  "已删除订阅类型": "已删除订阅类型",
  "订阅类型": "订阅类型",
  "已订阅": "已订阅",
  "未保存": "未保存",
  "保存订阅": "保存订阅",
  "确认全部订阅？": "确认全部订阅？",
  "全部订阅": "全部订阅",
  "确认全部取消订阅？": "确认全部取消订阅？",
  "全部取消": "全部取消",
  "已刷新": "已刷新",
  "正在删除": "正在删除",
  "请输入模板id": "请输入模板id",
  "请输入模板关键字": "请输入模板关键字",
  "已选择:": "已选择:",
  "确认绑定": "确认绑定",
  "请从下方表格中选择要绑定的SQL模板": "请从下方表格中选择要绑定的SQL模板",
  "债务总数": "债务总数",
  "新增债务": "新增债务",
  "高优先级": "高优先级",
  "降序 ↓": "降序 ↓",
  "升序 ↑": "升序 ↑",
  "事故详情": "事故详情",
  "业务需求详情": "业务需求详情",
  "仅指派人可以操作": "仅指派人可以操作",
  "新建成功": "新建成功",
  "编辑成功": "编辑成功",
  "表单校验或提交失败:": "表单校验或提交失败:",
  "新建技术债务": "新建技术债务",
  "编辑技术债务": "编辑技术债务",
  "请选择关联系统": "请选择关联系统",
  "请选择债务类型": "请选择债务类型",
  "绑定债务": "绑定债务",
  "未绑定任何债务": "未绑定任何债务",
  "重新选择": "重新选择",
  "选择绑定": "选择绑定",
  "请选择指派人": "请选择指派人",
  "债务描述": "债务描述",
  "重开次数": "重开次数",
  "关联债务": "关联债务",
  "暂无关联债务": "暂无关联债务",
  "(双击开始编辑)": "(双击开始编辑)",
  "债务名称和链接已剪贴板": "债务名称和链接已剪贴板",
  "切换到系统 All 下才能筛选业务领域": "切换到系统 All 下才能筛选业务领域",
  "优先级分布": "优先级分布",
  "严重程度分布": "严重程度分布",
  "月度债务趋势": "月度债务趋势",
  "债务重开": "债务重开",
  "暂无文档内容": "暂无文档内容",
  "点击\"编辑文档\"开始创建": "点击\"编辑文档\"开始创建",
  "请联系管理员创建文档": "请联系管理员创建文档",
  "编辑文档": "编辑文档",
  "获取应用配额记录失败:": "获取应用配额记录失败:",
  "获取应用配额记录失败": "获取应用配额记录失败",
  "可调用模型": "可调用模型",
  "无": "无",
  "应用配额使用情况": "应用配额使用情况",
  "用户配额使用情况": "用户配额使用情况",
  "创建密钥明细": "创建密钥明细",
  "加载应用中...": "加载应用中...",
  "应用视图": "应用视图",
  "选择您要使用的AI应用，点击卡片进入对应的应用页面": "选择您要使用的AI应用，点击卡片进入对应的应用页面",
  "暂无可用应用": "暂无可用应用",
  "审批申请已提交，请等待审批结果": "审批申请已提交，请等待审批结果",
  "审批申请提交失败": "审批申请提交失败",
  "申请密钥": "申请密钥",
  "重置密钥": "重置密钥",
  "请填写申请原因": "请填写申请原因",
  "请详细说明申请密钥的原因和用途": "请详细说明申请密钥的原因和用途",
  "• 申请后需要经过审批流程": "• 申请后需要经过审批流程",
  "• 审批通过后将自动生成API密钥": "• 审批通过后将自动生成API密钥",
  "• 您可以在审批进度中查看申请状态": "• 您可以在审批进度中查看申请状态",
  "获取聊天记录失败": "获取聊天记录失败",
  "已复制完整内容到剪贴板": "已复制完整内容到剪贴板",
  "复制完整内容": "复制完整内容",
  "请求模型": "请求模型",
  "请求内容": "请求内容",
  "响应内容": "响应内容",
  "请求参数": "请求参数",
  "响应参数": "响应参数",
  "输入Token": "输入Token",
  "输出Token": "输出Token",
  "总Token": "总Token",
  "请求IP": "请求IP",
  "请求人": "请求人",
  "请求时间": "请求时间",
  "请求记录详情": "请求记录详情",
  "API Key已复制到剪贴板": "API Key已复制到剪贴板",
  "您还没有": "您还没有",
  "应用密钥": "应用密钥",
  "申请一个": "申请一个",
  "应用密钥开始使用": "应用密钥开始使用",
  "查看审批进度": "查看审批进度",
  "隐藏密钥": "隐藏密钥",
  "显示密钥": "显示密钥",
  "复制完整密钥": "复制完整密钥",
  "Base Url已复制到剪贴板": "Base Url已复制到剪贴板",
  "应用日配额": "应用日配额",
  "个人日配额": "个人日配额",
  "可用模型": "可用模型",
  "配额使用趋势": "配额使用趋势",
  "在指定时间范围内的配额使用量趋势，点击图表可查看详情": "在指定时间范围内的配额使用量趋势，点击图表可查看详情",
  "所选条件范围内暂无配额使用趋势数据": "所选条件范围内暂无配额使用趋势数据",
  "查看接入文档": "查看接入文档",
  "接入文档": "接入文档",
  "刷新页面": "刷新页面",
  "应用配额": "应用配额",
  "使用趋势": "使用趋势",
  "请求记录": "请求记录",
  "配额日使用情况（已用/总量）": "配额日使用情况（已用/总量）",
  "暂无应用密钥统计数据": "暂无应用密钥统计数据",
  "应用类型": "应用类型",
  "请选择应用类型": "请选择应用类型",
  "加载应用类型中...": "加载应用类型中...",
  "请先确保有应用密钥统计数据": "请先确保有应用密钥统计数据",
  "加载趋势数据中...": "加载趋势数据中...",
  "密钥申请趋势": "密钥申请趋势",
  "所选时间范围内暂无应用密钥创建趋势数据": "所选时间范围内暂无应用密钥创建趋势数据",
  "用户": "用户",
  "请选择用户": "请选择用户",
  "加载数据中...": "加载数据中...",
  "应用密钥统计": "应用密钥统计",
  "应用明细": "应用明细",
  "OpenApi业务日志": "OpenApi业务日志",
  "Java服务日志(here-info)": "Java服务日志(here-info)",
  "Java服务日志(error-logs)": "Java服务日志(error-logs)",
  "请输入节点ID": "请输入节点ID",
  "请输入客户端地址": "请输入客户端地址",
  "数据库订阅": "数据库订阅",
  "执行成功": "执行成功",
  "请先选择需要审批的工单": "请先选择需要审批的工单",
  "只有待人工审核状态的工单可以审批": "只有待人工审核状态的工单可以审批",
  "未找到有效的工单ID，无法审批": "未找到有效的工单ID，无法审批",
  "请填写审批备注": "请填写审批备注",
  "名称:": "名称:",
  "请输入工单名称": "请输入工单名称",
  "状态:": "状态:",
  "批量审批": "批量审批",
  "SQL详情": "SQL详情",
  "审批备注": "审批备注",
  "终止流程": "终止流程",
  "审核通过": "审核通过",
  "请输入审批备注": "请输入审批备注",
  "了解更多": "了解更多",
  "欢迎使用 Ant Design Pro": "欢迎使用 Ant Design Pro",
  "Ant Design Pro 是一个整合了 umi，Ant Design 和 ProComponents 的脚手架方案。致力于在设计规范和基础组件的基础上，继续向上构建，提炼出典型模板/业务组件/配套设计资源，进一步提升企业级中后台产品设计研发过程中的『用户』和『设计者』的体验。": "Ant Design Pro 是一个整合了 umi，Ant Design 和 ProComponents 的脚手架方案。致力于在设计规范和基础组件的基础上，继续向上构建，提炼出典型模板/业务组件/配套设计资源，进一步提升企业级中后台产品设计研发过程中的『用户』和『设计者』的体验。",
  "了解 umi": "了解 umi",
  "了解 ant design": "了解 ant design",
  "了解 Pro Components": "了解 Pro Components",
  "创建业务需求": "创建业务需求",
  "创建任务": "创建任务",
  "创建评审": "创建评审",
  "创建回归缺陷": "创建回归缺陷",
  "创建线上问题": "创建线上问题",
  "按类型新建": "按类型新建",
  "转换操作失败:": "转换操作失败:",
  "研发任务明细": "研发任务明细",
  "差": "差",
  "较差": "较差",
  "一般": "一般",
  "良好": "良好",
  "优秀": "优秀",
  "较上周：": "较上周：",
  "视频无法播放，已在新窗口打开": "视频无法播放，已在新窗口打开",
  "视频": "视频",
  "在新窗口播放": "在新窗口播放",
  "点击下载": "点击下载",
  "附件列表": "附件列表",
  "有问题请请点击此处,开权限等": "有问题请请点击此处,开权限等",
  "全局搜索": "全局搜索",
  "点击设置计划联调日期": "点击设置计划联调日期",
  "点击设置计划上线日期": "点击设置计划上线日期",
  "点击设置暂停日期": "点击设置暂停日期",
  "联调日期反馈": "联调日期反馈",
  "填写后将会自动通知至需求业务方及产品经理！": "填写后将会自动通知至需求业务方及产品经理！",
  "计划上线日期反馈": "计划上线日期反馈",
  "预估人天（研发、测试总人天）": "预估人天（研发、测试总人天）",
  "变更原因": "变更原因",
  "暂停反馈": "暂停反馈",
  "计划暂停至": "计划暂停至",
  "提测申请记录已暂存！": "提测申请记录已暂存！",
  "标签设置成功": "标签设置成功",
  "请输入标签中文名称": "请输入标签中文名称",
  "请输入标签英文名称": "请输入标签英文名称",
  "标签创建成功": "标签创建成功",
  "暂无标签": "暂无标签",
  "选择标签": "选择标签",
  "没有想要的？": "没有想要的？",
  "手动添加": "手动添加",
  "暂无操作记录": "暂无操作记录",
  "操作记录": "操作记录",
  "产品验收通知": "产品验收通知",
  "您有": "您有",
  "个需求待验收": "个需求待验收",
  "关闭此通知后，您可以在通知中心查看": "关闭此通知后，您可以在通知中心查看",
  "研发效能平台版本更新": "研发效能平台版本更新",
  "发布版本号：": "发布版本号：",
  "去查看": "去查看",
  "每一起严重事故的背后，必然有": "每一起严重事故的背后，必然有",
  "29次轻微事故": "29次轻微事故",
  "300起未遂先兆": "300起未遂先兆",
  "以及": "以及",
  "1000起事故隐患": "1000起事故隐患",
  "📞 联系值班人员": "📞 联系值班人员",
  "很不满意": "很不满意",
  "不满意": "不满意",
  "满意": "满意",
  "很满意": "很满意",
  "添加备注失败:": "添加备注失败:",
  "添加备注失败，请重试": "添加备注失败，请重试",
  "查看当前工作项备注记录": "查看当前工作项备注记录",
  "隐藏当前工作项备注记录": "隐藏当前工作项备注记录",
  "备注类型": "备注类型",
  "备注内容": "备注内容",
  "点击隐藏当前工作项备注记录": "点击隐藏当前工作项备注记录",
  "点击查看当前工作项备注记录": "点击查看当前工作项备注记录",
  "将按当前筛选条件导出，最多支持 5000 条。": "将按当前筛选条件导出，最多支持 5000 条。",
  "导出已勾选数据（": "导出已勾选数据（",
  "条）": "条）",
  "导出当前筛选结果（": "导出当前筛选结果（",
  "数据超过 5000 条，请缩小筛选范围后再导出。": "数据超过 5000 条，请缩小筛选范围后再导出。",
  "获取责任人详情失败:": "获取责任人详情失败:",
  "获取责任人详情失败，将使用默认值": "获取责任人详情失败，将使用默认值",
  "请至少选择一个责任人": "请至少选择一个责任人",
  "更新责任人成功": "更新责任人成功",
  "更新责任人失败": "更新责任人失败",
  "编辑责任人失败:": "编辑责任人失败:",
  "编辑责任人失败": "编辑责任人失败",
  "责任人员": "责任人员",
  "责任原因": "责任原因",
  "请输入责任原因": "请输入责任原因",
  "调用 logout 接口失败:": "调用 logout 接口失败:",
  "请选择或搜索系统": "请选择或搜索系统",
  "至少选择一个相关人": "至少选择一个相关人",
  "图表初始化失败:": "图表初始化失败:",
  "手动添加事件监听器失败:": "手动添加事件监听器失败:",
  "已同意": "已同意",
  "未开放": "未开放",
  "审批撤销": "审批撤销",
  "待审批": "待审批",
  "后付费": "后付费",
  "预付费": "预付费",
  "通用型": "通用型",
  "独享型": "独享型",
  "「技术类」": "「技术类」",
  "不能为空": "不能为空",
  "实际工时不能超过120h": "实际工时不能超过120h",
  "将按全部启用的业务领域重建模板，业务岗位和值班组长都会清除固定人员并恢复自动轮转；需要固定的人员请在重置后重新选择。已生成的值班数据不会立即改变。": "将按全部启用的业务领域重建模板，业务岗位和值班组长都会清除固定人员并恢复自动轮转；需要固定的人员请在重置后重新选择。已生成的值班数据不会立即改变。",
  "确认重排": "确认重排",
  "我创建的仪表盘": "我创建的仪表盘",
  "共享我的仪表盘": "共享我的仪表盘",
  "-需求交付时长": "-需求交付时长",
  "当前装饰": "当前装饰",
  "自定义装饰": "自定义装饰",
  "装饰": "装饰",
  "研发bug数": "研发bug数",
  "生产bug数": "生产bug数",
  "发布总次数": "发布总次数",
  "次": "次",
  "发布回滚次数": "发布回滚次数",
  "研发需求设计缺陷数": "研发需求设计缺陷数",
  "产品评审驳回数": "产品评审驳回数",
  "代码规范提交数": "代码规范提交数",
  "研发bug重开数": "研发bug重开数",
  "生产bug重开数": "生产bug重开数",
  "紧急发布数": "紧急发布数",
  "需求测试覆盖数": "需求测试覆盖数",
  "缺陷数": "缺陷数",
  "万次": "万次",
  "技术债务个数": "技术债务个数",
  "模版数量": "模版数量",
  "致命事故": "致命事故",
  "生产事故出现次数和严重程度：无P1级及以上生产事故，P2级及以下生产事故<=2": "生产事故出现次数和严重程度：无P1级及以上生产事故，P2级及以下生产事故<=2",
  "严重事故": "严重事故",
  "一般事故": "一般事故",
  "轻微事故": "轻微事故",
  "需求前置平均等待时间": "需求前置平均等待时间",
  "提出需求到产品介入需求等待时长平均值": "提出需求到产品介入需求等待时长平均值",
  "所有已介入需求到需求评审完成的累计时长平均值": "所有已介入需求到需求评审完成的累计时长平均值",
  "开始开发到转提测的累计时长平均值": "开始开发到转提测的累计时长平均值",
  "需求转提测至产品验收通过的累计时长平均值": "需求转提测至产品验收通过的累计时长平均值",
  "需求开始验收到已发布的累计时长平均值": "需求开始验收到已发布的累计时长平均值",
  "卡片名称(中文)": "卡片名称(中文)",
  "卡片名称(英文)": "卡片名称(英文)",
  "只能上传jpg/png文件,且不大于10MB": "只能上传jpg/png文件,且不大于10MB",
  "填写评审纪要": "填写评审纪要",
  "警告": "警告",
  "错误": "错误",
  "扫描中": "扫描中",
  "确定要删除任务「{name}」吗？": "确定要删除任务「{name}」吗？",
  "驳回项": "驳回项",
  "提交不规范项": "提交不规范项",
  "紧急发布项": "紧急发布项",
  "发布失败项": "发布失败项",
  "回滚项": "回滚项",
  "我创建的需求池": "我创建的需求池",
  "共享我的需求池": "共享我的需求池",
  "后端任务": "后端任务",
  "前端任务": "前端任务",
  "测试任务": "测试任务",
  "UI任务": "UI任务",
  "产品任务": "产品任务",
  "运维任务": "运维任务",
  "其他类任务": "其他类任务",
  "其他任务": "其他任务",
  "已完成或未逾期": "已完成或未逾期",
  "进行中且已逾期": "进行中且已逾期",
  "未开始且已逾期": "未开始且已逾期",
  "配置【": "配置【",
  "】模板": "】模板",
  "拆分【": "拆分【",
  "】部门周报": "】部门周报",
  "本周新增": "本周新增",
  "本周完成": "本周完成",
  "模板": "模板",
  "分钟": "分钟",
  "已撤销": "已撤销",
  "重新申请": "重新申请",
  "支持大小写字母、数字、'.'和'-'、长度不超过64个字符": "支持大小写字母、数字、'.'和'-'、长度不超过64个字符",
  "请输入有效的用户ID": "请输入有效的用户ID",
  "添加一行服务分支": "添加一行服务分支",
  "拉取": "拉取",
  "不拉取": "不拉取",
  "拉取载体分支": "拉取载体分支",
  "发布成功后发布单将变为【待回归】状态，需要测试回归需求": "发布成功后发布单将变为【待回归】状态，需要测试回归需求",
  "确定【": "确定【",
  "】吗？": "】吗？",
  "全局平均值": "全局平均值",
  "平均工时": "平均工时",
  "{value} 小时": "{value} 小时",
  "基础柱状图-图形标签位置": "基础柱状图-图形标签位置",
  "基础柱状图的图形标签位置可以指定为top-柱形上部，middle-柱形中心，bottom-柱形底部。": "基础柱状图的图形标签位置可以指定为top-柱形上部，middle-柱形中心，bottom-柱形底部。",
  "时长": "时长",
  "{value} 天": "{value} 天",
  "{value} 个": "{value} 个",
  "平均响应耗时": "平均响应耗时",
  "平均解决耗时": "平均解决耗时",
  "平均关闭耗时": "平均关闭耗时",
  "平均修复总耗时": "平均修复总耗时",
  "全局平均修复耗时": "全局平均修复耗时",
  "未关闭缺陷数量": "未关闭缺陷数量",
  "已关闭缺陷数量": "已关闭缺陷数量",
  "每天新增Bug数": "每天新增Bug数",
  "每天解决Bug数": "每天解决Bug数",
  "每天关闭Bug数": "每天关闭Bug数",
  "预计一个月内完成，进度良好": "预计一个月内完成，进度良好",
  "预计3个月内完成，需要关注进度": "预计3个月内完成，需要关注进度",
  "预计超过3个月完成，风险较高": "预计超过3个月完成，风险较高",
  "展示各项健康度指标的分布情况": "展示各项健康度指标的分布情况",
  "工时（人天）": "工时（人天）",
  "占比": "占比",
  "成本": "成本",
  "您确定要关闭吗？": "您确定要关闭吗？",
  "添加邮箱": "添加邮箱",
  "数量（个）": "数量（个）",
  "事故总数": "事故总数",
  "bug总数": "bug总数",
  "关闭时效": "关闭时效",
  "bug数": "bug数",
  "效能度量总分": "效能度量总分",
  "各指标分数": "各指标分数",
  "{value} 分": "{value} 分",
  "总分": "总分",
  "产品": "产品",
  "{value} 次": "{value} 次",
  "每月平均发布次数": "每月平均发布次数",
  "每月平均发布成功率": "每月平均发布成功率",
  "成功率": "成功率",
  "耗时1周内": "耗时1周内",
  "耗时1-2周": "耗时1-2周",
  "耗时2-4周": "耗时2-4周",
  "耗时4周以上": "耗时4周以上",
  "延期交付数量": "延期交付数量",
  "平均延期交付时间": "平均延期交付时间",
  "天数": "天数",
  "累积次数（个）": "累积次数（个）",
  "累积耗时（天）": "累积耗时（天）",
  "全部反馈": "全部反馈",
  "我的反馈": "我的反馈",
  "手打标签": "手打标签",
  "请输入搜索反馈名称": "请输入搜索反馈名称",
  "确定要将此反馈转为业务需求吗？": "确定要将此反馈转为业务需求吗？",
  "执行完成": "执行完成",
  "待人工审核": "待人工审核",
  "定时任务": "定时任务",
  "执行中": "执行中",
  "自动审核失败": "自动审核失败",
  "执行异常": "执行异常",
  "数据库变更详情": "数据库变更详情",
  "系统发布详情": "系统发布详情",
  "待审核": "待审核",
  "数据库变更": "数据库变更",
  "配置变更": "配置变更",
  "系统发布": "系统发布",
  "故障/事件": "故障/事件",
  "权限变更": "权限变更",
  "流量变更": "流量变更",
  "系统优化": "系统优化",
  "德国生产环境": "德国生产环境",
  "新加坡生产环境": "新加坡生产环境",
  "新加坡预发环境": "新加坡预发环境",
  "德国预发环境": "德国预发环境",
  "本地测试环境": "本地测试环境",
  "杭州测试环境": "杭州测试环境",
  "德国灰度环境": "德国灰度环境",
  "香港测试环境": "香港测试环境",
  "开发环境": "开发环境",
  "消息列表": "消息列表",
  "验收报告": "验收报告",
  "问卷": "问卷",
  "元": "元",
  "删除后无法恢复，请谨慎操作。": "删除后无法恢复，请谨慎操作。",
  "移出后该工作项将不再属于当前项目，可从项目外重新关联。": "移出后该工作项将不再属于当前项目，可从项目外重新关联。",
  "当前为演示效果，后续会接入真实的需求 / 迭代 / 任务新增能力。": "当前为演示效果，后续会接入真实的需求 / 迭代 / 任务新增能力。",
  "项目里程碑明细": "项目里程碑明细",
  "是否需要关联遗漏需求与迭代？": "是否需要关联遗漏需求与迭代？",
  "确定要删除该条风险吗？": "确定要删除该条风险吗？",
  "确认将该风险标记为已处理？": "确认将该风险标记为已处理？",
  "删除后项目数据将无法恢复": "删除后项目数据将无法恢复",
  "张三": "张三",
  "李四": "李四",
  "王五": "王五",
  "赵六": "赵六",
  "孙七": "孙七",
  "周八": "周八",
  "吴九": "吴九",
  "郑十": "郑十",
  "王潇武": "王潇武",
  "常峻": "常峻",
  "古静杨": "古静杨",
  "陈晓": "陈晓",
  "林薇": "林薇",
  "黄杨": "黄杨",
  "刘言": "刘言",
  "徐鑫": "徐鑫",
  "毛俊": "毛俊",
  "高玲": "高玲",
  "路通": "路通",
  "产品需求原型或需求文档是否准确，是否符合业务预期": "产品需求原型或需求文档是否准确，是否符合业务预期",
  "产品经理响应是否及时，是否及时解决问题": "产品经理响应是否及时，是否及时解决问题",
  "产品经理是否准确理解业务诉求，并能转化为合适的产品方案": "产品经理是否准确理解业务诉求，并能转化为合适的产品方案",
  "与产品经理沟通过程是否顺畅，是否及时解决问题": "与产品经理沟通过程是否顺畅，是否及时解决问题",
  "研发开发和交付效率是否满足业务预期": "研发开发和交付效率是否满足业务预期",
  "产品功能交付质量是否满足业务预期": "产品功能交付质量是否满足业务预期",
  "需求背景描述是否清晰": "需求背景描述是否清晰",
  "问题描述是否清晰": "问题描述是否清晰",
  "产品方案是否合理": "产品方案是否合理",
  "原型或者需求设计是否清晰": "原型或者需求设计是否清晰",
  "事故数量": "事故数量",
  "请选择有效日期": "请选择有效日期",
  "事故明细": "事故明细",
  "责任人排名": "责任人排名",
  "COE 详情": "COE 详情",
  "平均恢复时长(天)": "平均恢复时长(天)",
  "恢复时长(天)": "恢复时长(天)",
  "Todo 数量": "Todo 数量",
  "COE评论": "COE评论",
  "查看原文已修改评论": "查看原文已修改评论",
  "删除回复": "删除回复",
  "综合根因内容": "综合根因内容",
  "由表及里，导致故障现象的直接原因是什么？": "由表及里，导致故障现象的直接原因是什么？",
  "如：MQ推送了旧脏数据": "如：MQ推送了旧脏数据",
  "为什么会推送旧数据？": "为什么会推送旧数据？",
  "如：未复用内存数据，查询了从库": "如：未复用内存数据，查询了从库",
  "为什么从库有旧数据？": "为什么从库有旧数据？",
  "如：主从同步延迟": "如：主从同步延迟",
  "为什么会读从库？": "为什么会读从库？",
  "如：上传与推送拆分两个方法": "如：上传与推送拆分两个方法",
  "为什么拆分方法未合并？": "为什么拆分方法未合并？",
  "如：过渡期双链路遗留": "如：过渡期双链路遗留",
  "为什么没有自动告警？": "为什么没有自动告警？",
  "如：仅监控通道可用性": "如：仅监控通道可用性",
  "为什么缺数据一致性监控？": "为什么缺数据一致性监控？",
  "如：未列入监控需求": "如：未列入监控需求",
  "为什么没有自动熔断？": "为什么没有自动熔断？",
  "如：消息均发送成功，无异常触发": "如：消息均发送成功，无异常触发",
  "为什么定位困难？": "为什么定位困难？",
  "如：日志无异常、无数据对比": "如：日志无异常、无数据对比",
  "是否恢复上次未成功保存的内容？选择放弃将清除这份本机缓存。": "是否恢复上次未成功保存的内容？选择放弃将清除这份本机缓存。",
  "COE新建表单章节": "COE新建表单章节",
  "COE复盘章节": "COE复盘章节",
  "只看延期": "只看延期",
  "系统出现崩溃情况，现象：影响范围：": "系统出现崩溃情况，现象：影响范围：",
  "数据导出失败，错误信息：影响业务：": "数据导出失败，错误信息：影响业务：",
  "发现数据异常，问题描述：错误数据示例：": "发现数据异常，问题描述：错误数据示例：",
  "运营流程受阻，受阻环节：影响程度：": "运营流程受阻，受阻环节：影响程度：",
  "当前输入框已有内容，确定要用模板覆盖吗？": "当前输入框已有内容，确定要用模板覆盖吗？",
  "当前输入框已有内容，确定要清空吗？": "当前输入框已有内容，确定要清空吗？",
  "响应时间": "响应时间",
  "处理时间": "处理时间",
  "bug类型": "bug类型",
  "bug页面URL数": "bug页面URL数",
  "请勿重复点击": "请勿重复点击",
  "飞书": "飞书",
  "反馈者": "反馈者",
  "抄送": "抄送",
  "时间不能小于今天": "时间不能小于今天",
  "再建一行": "再建一行",
  "期待日期": "期待日期",
  "请选择期待完成时间": "请选择期待完成时间",
  "用例等级": "用例等级",
  "主负责人": "主负责人",
  "过程": "过程",
  "判断": "判断",
  "观点一": "观点一",
  "观点二": "观点二",
  "观点三": "观点三",
  "观点四": "观点四",
  "需求ID": "需求ID",
  "需求是否符合业务预期，是否符合产品规划": "需求是否符合业务预期，是否符合产品规划",
  "功能是否完备，是否满足业务预期": "功能是否完备，是否满足业务预期",
  "功能是否流畅，是否满足业务预期": "功能是否流畅，是否满足业务预期",
  "设计是否符合业务预期，是否符合产品规划": "设计是否符合业务预期，是否符合产品规划",
  "时间不能小于当前时间": "时间不能小于当前时间",
  "分享链接": "分享链接",
  "一键创建": "一键创建",
  "添加一行": "添加一行",
  "不能超过3天": "不能超过3天",
  "内容不能超过15000个字符": "内容不能超过15000个字符",
  "需要培训师": "需要培训师",
  "评审参与人": "评审参与人",
  "请确认要申请发布吗？": "请确认要申请发布吗？",
  "数据加载失败": "数据加载失败",
  "请选择预计上线日期": "请选择预计上线日期",
  "评审名称": "评审名称",
  "评审类型": "评审类型",
  "评审需求": "评审需求",
  "评审Sprint": "评审Sprint",
  "评审测试用例": "评审测试用例",
  "不预约": "不预约",
  "评审描述": "评审描述",
  "12人以下": "12人以下",
  "13~20人": "13~20人",
  "20人以上": "20人以上",
  "电视": "电视",
  "投影": "投影",
  "白板": "白板",
  "（点击催读）": "（点击催读）",
  "研发工时": "研发工时",
  "期望": "期望",
  "迭代例会": "迭代例会",
  "{b} : {c} 人天 ({d}%)": "{b} : {c} 人天 ({d}%)",
  "{b}: {c} 人天": "{b}: {c} 人天",
  "工作项总数": "工作项总数",
  "工作项完成数": "工作项完成数",
  "工作项未完成数": "工作项未完成数",
  "关联产品数": "关联产品数",
  "上传失败！": "上传失败！",
  "预估时间范围": "预估时间范围",
  "删除Sprint": "删除Sprint",
  "（选择服务分支必须选择需求）": "（选择服务分支必须选择需求）",
  "时间不能为空": "时间不能为空",
  "预估人天不能小于0": "预估人天不能小于0",
  "预估人天不能超过3天，请拆解": "预估人天不能超过3天，请拆解",
  "数字越小越靠前；排序号相同时，最新创建的工作流靠前": "数字越小越靠前；排序号相同时，最新创建的工作流靠前",
  "不可编辑（": "不可编辑（",
  "移除流转": "移除流转",
  "添加流转": "添加流转",
  "新增流转规则（": "新增流转规则（",
  "编辑流转规则（": "编辑流转规则（",
  "移除流转规则（": "移除流转规则（",
  "系统会自动获取": "系统会自动获取",
  "，并与下方固定人员合并": "，并与下方固定人员合并",
  "一人同意": "一人同意",
  "关闭后，该业务领域下的所有系统也会全部关闭，是否继续？": "关闭后，该业务领域下的所有系统也会全部关闭，是否继续？",
  "业务领域名称(中)": "业务领域名称(中)",
  "业务领域名称(英)": "业务领域名称(英)",
  "创建系统": "创建系统",
  "编辑系统": "编辑系统",
  "系统唯一Key（全大写字母，中划线拼接）": "系统唯一Key（全大写字母，中划线拼接）",
  "删除标签": "删除标签",
  "正在导出数据...": "正在导出数据...",
  "导出失败，请稍后重试": "导出失败，请稍后重试",
  "只能上传jpg/png文件,且单个文件不超过10MB": "只能上传jpg/png文件,且单个文件不超过10MB",
  "是否克隆服务基础信息": "是否克隆服务基础信息",
  "是否删除服务基础信息": "是否删除服务基础信息",
  "停用": "停用",
  "添加更新明细": "添加更新明细",
  "规则名称": "规则名称",
  "规则描述": "规则描述",
  "请输入至少五个字符": "请输入至少五个字符",
  "配置规则属性": "配置规则属性",
  "监控对象": "监控对象",
  "规则模板": "规则模板",
  "规则类型": "规则类型",
  "设定调度周期": "设定调度周期",
  "周": "周",
  "万": "万",
  "债务数量": "债务数量",
  "您有未保存的更改，确定要关闭吗？": "您有未保存的更改，确定要关闭吗？",
  "技术债务明细": "技术债务明细",
  "显示选定应用类型在指定时间范围内的密钥创建数量趋势": "显示选定应用类型在指定时间范围内的密钥创建数量趋势",
  "umi 是一个可扩展的企业级前端应用框架,umi 以路由为基础的，同时支持配置式路由和约定式路由，保证路由的功能完备，并以此进行功能扩展。": "umi 是一个可扩展的企业级前端应用框架,umi 以路由为基础的，同时支持配置式路由和约定式路由，保证路由的功能完备，并以此进行功能扩展。",
  "antd 是基于 Ant Design 设计体系的 React UI 组件库，主要用于研发企业级中后台产品。": "antd 是基于 Ant Design 设计体系的 React UI 组件库，主要用于研发企业级中后台产品。",
  "ProComponents 是一个基于 Ant Design 做了更高抽象的模板组件，以 一个组件就是一个页面为开发理念，为中后台开发带来更好的体验。": "ProComponents 是一个基于 Ant Design 做了更高抽象的模板组件，以 一个组件就是一个页面为开发理念，为中后台开发带来更好的体验。",
  "加载失败": "加载失败",
  "点击预览": "点击预览",
  "{value0}核/{value1}GB": "{value0}核/{value1}GB",
  "{value0} 小时": "{value0} 小时",
  "{value0} 分钟": "{value0} 分钟",
  "{value0} 秒": "{value0} 秒",
  "第{value0}-{value1} 条共 {value2} 条": "第{value0}-{value1} 条共 {value2} 条",
  "{value0}任务甘特图": "{value0}任务甘特图",
  "确定要删除 {value0} 目录吗？": "确定要删除 {value0} 目录吗？",
  "确定要删除 {value0} 吗？": "确定要删除 {value0} 吗？",
  "第{value0}-{value1}条/总共 {value2} 条": "第{value0}-{value1}条/总共 {value2} 条",
  "共 {value0} 条": "共 {value0} 条",
  "重新排班成功，共更新 {value0} 条排班记录": "重新排班成功，共更新 {value0} 条排班记录",
  "补齐今日到截止日期（{value0} ~ {value1}）缺失的排班，已有排班不会覆盖": "补齐今日到截止日期（{value0} ~ {value1}）缺失的排班，已有排班不会覆盖",
  "已自动填充 {value0} 个空缺岗位": "已自动填充 {value0} 个空缺岗位",
  "{value0} 值班表": "{value0} 值班表",
  "4周内交付率：{value0}": "4周内交付率：{value0}",
  "年度交付周数（{value0}）": "年度交付周数（{value0}）",
  "4周内：{value0}": "4周内：{value0}",
  "赠送卡片{value0}": "赠送卡片{value0}",
  "{value0} 送你了 {value1}": "{value0} 送你了 {value1}",
  "{value0} 天": "{value0} 天",
  "<div style=\"padding: 8px; background: #fff; border-radius: 4px; \">\n              <div style=\"font-weight: bold; margin-bottom: 4px;\">{value0}</div>\n              <div>{value1}: {value2} 天</div>\n            </div>": "<div style=\"padding: 8px; background: #fff; border-radius: 4px; \">\n              <div style=\"font-weight: bold; margin-bottom: 4px;\">{value0}</div>\n              <div>{value1}: {value2} 天</div>\n            </div>",
  "{value0}年-{value1}": "{value0}年-{value1}",
  "\n            <div style=\"margin-bottom:8px;font-weight:bold\">\n              {value0} ({value1}年)\n            </div>\n            <div style=\"display:flex;align-items:center\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value2};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value3}: {value4} {value5}\n              <span style=\"color:#666;margin-left:8px\">\n                ({value6}%)\n              </span>\n            </div>\n          ": "\n            <div style=\"margin-bottom:8px;font-weight:bold\">\n              {value0} ({value1}年)\n            </div>\n            <div style=\"display:flex;align-items:center\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value2};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value3}: {value4} {value5}\n              <span style=\"color:#666;margin-left:8px\">\n                ({value6}%)\n              </span>\n            </div>\n          ",
  "\n                <div style=\"font-weight:bold\">{value0} - {value1}</div>\n                <div style=\"display:flex;align-items:center;margin:3px 0\">\n                  <span style=\"display:inline-block;width:10px;height:10px;background:{value2};margin-right:5px;\"></span>\n                  <strong>{value3}</strong>: {value4} {value5} ({value6}%)\n                </div>\n                <div style=\"margin-top:5px;font-weight:bold\">\n                  总计: {value7} {value8}\n                </div>\n              ": "\n                <div style=\"font-weight:bold\">{value0} - {value1}</div>\n                <div style=\"display:flex;align-items:center;margin:3px 0\">\n                  <span style=\"display:inline-block;width:10px;height:10px;background:{value2};margin-right:5px;\"></span>\n                  <strong>{value3}</strong>: {value4} {value5} ({value6}%)\n                </div>\n                <div style=\"margin-top:5px;font-weight:bold\">\n                  总计: {value7} {value8}\n                </div>\n              ",
  "模板{value0}": "模板{value0}",
  "最新{value0}: {value1}{value2}": "最新{value0}: {value1}{value2}",
  "累计{value0}: {value1}{value2}": "累计{value0}: {value1}{value2}",
  "{value0} 万次": "{value0} 万次",
  "{value0} 次": "{value0} 次",
  "{value0}年": "{value0}年",
  "{value0}指标": "{value0}指标",
  "{value0} 月": "{value0} 月",
  "{value0} 文件上传失败": "{value0} 文件上传失败",
  "仅查看{value0}": "仅查看{value0}",
  "请选择{value0}": "请选择{value0}",
  " • 搜索到 {value0} 个结果": " • 搜索到 {value0} 个结果",
  "点击查看{value0}任务详情": "点击查看{value0}任务详情",
  "正在渲染... ({value0}/{value1})": "正在渲染... ({value0}/{value1})",
  "配置项目周报模板{value0}": "配置项目周报模板{value0}",
  "共{value0}条 ": "共{value0}条 ",
  "{value0}预约详情": "{value0}预约详情",
  "已提交回滚到版本 {value0}": "已提交回滚到版本 {value0}",
  "确认回滚到版本 {value0}？": "确认回滚到版本 {value0}？",
  "申请回滚到版本 {value0}": "申请回滚到版本 {value0}",
  "申请调试 (Pod: {value0} 容器: {value1})": "申请调试 (Pod: {value0} 容器: {value1})",
  "容器信息 ({value0})": "容器信息 ({value0})",
  "{value0}重启请求已提交": "{value0}重启请求已提交",
  "是否重启该{value0}": "是否重启该{value0}",
  "确认要重启该{value0}吗？": "确认要重启该{value0}吗？",
  "{value0}重启申请已提交": "{value0}重启申请已提交",
  "重启{value0}": "重启{value0}",
  "申请重启{value0}": "申请重启{value0}",
  "副本数已修改为 {value0}": "副本数已修改为 {value0}",
  "执行{value0}": "执行{value0}",
  "申请{value0}": "申请{value0}",
  "确定要删除泳道组 \"{value0}\" 吗？此操作不可恢复。": "确定要删除泳道组 \"{value0}\" 吗？此操作不可恢复。",
  "流量比例不能超过 {value0}%": "流量比例不能超过 {value0}%",
  "流量比例必须在0-{value0}%之间": "流量比例必须在0-{value0}%之间",
  "确定要删除泳道 \"{value0}\" 吗？此操作不可恢复。": "确定要删除泳道 \"{value0}\" 吗？此操作不可恢复。",
  "[{value0}] 前缀匹配 [{value1}]": "[{value0}] 前缀匹配 [{value1}]",
  "[{value0}] 正则匹配 [{value1}]": "[{value0}] 正则匹配 [{value1}]",
  "[{value0}] 百分比 [{value1}]": "[{value0}] 百分比 [{value1}]",
  "第 {value0}-{value1} 条/总共 {value2} 条": "第 {value0}-{value1} 条/总共 {value2} 条",
  "{value0} 灰度配置": "{value0} 灰度配置",
  "最多还能添加 {value0} 个用户ID，当前待添加{value1}个": "最多还能添加 {value0} 个用户ID，当前待添加{value1}个",
  "成功添加 {value0} 个用户ID": "成功添加 {value0} 个用户ID",
  "{value0}秒": "{value0}秒",
  "共 {value0} 条记录": "共 {value0} 条记录",
  "服务发布流水线（{value0}）": "服务发布流水线（{value0}）",
  "复制{value0}": "复制{value0}",
  "查看问题 \n              {value0}": "查看问题 \n              {value0}",
  "{value0}万": "{value0}万",
  "{value0}年{value1}月{value2}日": "{value0}年{value1}月{value2}日",
  "{value0} - {value1}详情": "{value0} - {value1}详情",
  "未来第{value0}周": "未来第{value0}周",
  "查看更多 (+{value0})": "查看更多 (+{value0})",
  "{value0} 人天": "{value0} 人天",
  "{value0}人天": "{value0}人天",
  "{value0}<br/>\n                  实际工时: {value1} 人天<br/>\n                  占比（实际工时/总工时）: {value2}%": "{value0}<br/>\n                  实际工时: {value1} 人天<br/>\n                  占比（实际工时/总工时）: {value2}%",
  "部分指标已存在，已跳过：{value0}": "部分指标已存在，已跳过：{value0}",
  "成功添加 {value0} 个指标": "成功添加 {value0} 个指标",
  "{value0}全年平均分": "{value0}全年平均分",
  "{value0}下半年平均分": "{value0}下半年平均分",
  "{value0}上半年平均分": "{value0}上半年平均分",
  "{value0}年12月平均分": "{value0}年12月平均分",
  "{value0}年{value1}月平均分": "{value0}年{value1}月平均分",
  "{value0}月": "{value0}月",
  "{value0}月指标对比（加权得分）": "{value0}月指标对比（加权得分）",
  "\n            <div>超期未完成</div>\n            <div>{value0}: {value1}个</div>\n          ": "\n            <div>超期未完成</div>\n            <div>{value0}: {value1}个</div>\n          ",
  "\n            <div style=\"font-weight:bold\">{value0}</div>\n            <div style=\"display:flex;align-items:center;margin:5px 0\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value1};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value2}: {value3} 个\n              <span style=\"color:#666;margin-left:8px\">\n                ({value4}%)\n              </span>\n            </div>\n          ": "\n            <div style=\"font-weight:bold\">{value0}</div>\n            <div style=\"display:flex;align-items:center;margin:5px 0\">\n              <span style=\"\n                display:inline-block;\n                width:10px;\n                height:10px;\n                background:{value1};\n                margin-right:5px;\n                border-radius:2px\n              \"></span>\n              {value2}: {value3} 个\n              <span style=\"color:#666;margin-left:8px\">\n                ({value4}%)\n              </span>\n            </div>\n          ",
  "{value0}(天)": "{value0}(天)",
  "操作失败: {value0}": "操作失败: {value0}",
  "总分: {value0}": "总分: {value0}",
  "统计区间：{value0}    数据量：{value1} 条": "统计区间：{value0}    数据量：{value1} 条",
  "{value0} - {value1}指标明细": "{value0} - {value1}指标明细",
  "统计区间：{value0}    成员数：{value1} 人": "统计区间：{value0}    成员数：{value1} 人",
  "{value0}-{value1}指标明细-{value2}.xls": "{value0}-{value1}指标明细-{value2}.xls",
  "{value0}-全角色指标明细-{value1}.xls": "{value0}-全角色指标明细-{value1}.xls",
  "暂未配置{value0}成员": "暂未配置{value0}成员",
  "当前筛选未命中{value0}指标": "当前筛选未命中{value0}指标",
  "展开剩余 {value0} 人": "展开剩余 {value0} 人",
  "展示团队指标当前值，并提供往年同比（%）对照（{value0} ~ {value1}）": "展示团队指标当前值，并提供往年同比（%）对照（{value0} ~ {value1}）",
  "按角色展示成员指标明细表格，不同角色展示各自独立指标（{value0} ~ {value1}）": "按角色展示成员指标明细表格，不同角色展示各自独立指标（{value0} ~ {value1}）",
  "选择{value0}成员": "选择{value0}成员",
  "已选择 {value0} 人，可在下方微调": "已选择 {value0} 人，可在下方微调",
  "工专路 {value0} 号店": "工专路 {value0} 号店",
  "正向反馈: {value0}个 ({value1}%)": "正向反馈: {value0}个 ({value1}%)",
  "中性反馈: {value0}个 ({value1}%)": "中性反馈: {value0}个 ({value1}%)",
  "负面反馈: {value0}个 ({value1}%)": "负面反馈: {value0}个 ({value1}%)",
  "平均时效: {value0}": "平均时效: {value0}",
  "待处理 {value0} 个反馈": "待处理 {value0} 个反馈",
  "第 {value0}-{value1} 条/共 {value2} 条": "第 {value0}-{value1} 条/共 {value2} 条",
  "{value0} - 反馈详情": "{value0} - 反馈详情",
  "{value0} - {value1}反馈详情": "{value0} - {value1}反馈详情",
  "点赞排行 - {value0}": "点赞排行 - {value0}",
  "{value0}情绪反馈详情": "{value0}情绪反馈详情",
  "编辑{value0}": "编辑{value0}",
  "新增{value0}": "新增{value0}",
  "成功添加 {value0} 个属性": "成功添加 {value0} 个属性",
  "确定要删除 \"{value0}\" 吗？": "确定要删除 \"{value0}\" 吗？",
  "确定要删除 \"{value0}\" 及其所有子节点吗？": "确定要删除 \"{value0}\" 及其所有子节点吗？",
  "编辑配置 - {value0} × {value1}": "编辑配置 - {value0} × {value1}",
  "正在复制 {value0} × {value1} 的配置...": "正在复制 {value0} × {value1} 的配置...",
  "拖拽复制: {value0} × {value1}": "拖拽复制: {value0} × {value1}",
  "成功添加 {value0} 个敏感词": "成功添加 {value0} 个敏感词",
  "确定要变更为\"{value0}\"状态吗？": "确定要变更为\"{value0}\"状态吗？",
  "变更{value0}": "变更{value0}",
  "当前{value0}": "当前{value0}",
  "选择{value0}": "选择{value0}",
  "{value0}变更成功": "{value0}变更成功",
  "{value0}变更失败": "{value0}变更失败",
  "反馈原文：{value0}\n反馈翻译：{value1}\n详情链接：{value2}": "反馈原文：{value0}\n反馈翻译：{value1}\n详情链接：{value2}",
  "{value0} 至 {value1}": "{value0} 至 {value1}",
  "草稿 · {value0}": "草稿 · {value0}",
  "所属空间: {value0}": "所属空间: {value0}",
  "业务领域: {value0}": "业务领域: {value0}",
  "类型: {value0}": "类型: {value0}",
  "规模: {value0}": "规模: {value0}",
  "风险: {value0}": "风险: {value0}",
  "替换 - {value0}": "替换 - {value0}",
  "添加 - {value0}": "添加 - {value0}",
  "请选择要关联的{value0}": "请选择要关联的{value0}",
  "确定要删除里程碑「{value0}」吗？": "确定要删除里程碑「{value0}」吗？",
  "第{value0}条：{value1}未填": "第{value0}条：{value1}未填",
  "{value0} 万": "{value0} 万",
  "预期ROI：{value0}%": "预期ROI：{value0}%",
  "已选择 {value0} 星": "已选择 {value0} 星",
  "项目数: {value0}": "项目数: {value0}",
  "成员数: {value0}": "成员数: {value0}",
  "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div>{value1}: {value2} 天</div>\n            ": "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div>{value1}: {value2} 天</div>\n            ",
  "\n              <div style=\"margin-bottom:8px;font-weight:bold\">\n                {value0} ({value1}年)\n              </div>\n              <div style=\"display:flex;align-items:center\">\n                <span style=\"\n                  display:inline-block;\n                  width:10px;\n                  height:10px;\n                  background:{value2};\n                  margin-right:5px;\n                  border-radius:2px\n                \"></span>\n                {value3}: {value4} \n                <span style=\"color:#666;margin-left:8px\">\n                  ({value5}%)\n                </span>\n              </div>\n            ": "\n              <div style=\"margin-bottom:8px;font-weight:bold\">\n                {value0} ({value1}年)\n              </div>\n              <div style=\"display:flex;align-items:center\">\n                <span style=\"\n                  display:inline-block;\n                  width:10px;\n                  height:10px;\n                  background:{value2};\n                  margin-right:5px;\n                  border-radius:2px\n                \"></span>\n                {value3}: {value4} \n                <span style=\"color:#666;margin-left:8px\">\n                  ({value5}%)\n                </span>\n              </div>\n            ",
  "{value0}-事故报告": "{value0}-事故报告",
  "{value0}({value1}项)": "{value0}({value1}项)",
  "添加备注失败: {value0}": "添加备注失败: {value0}",
  "删除备注失败: {value0}": "删除备注失败: {value0}",
  "请对{value0}进行评分": "请对{value0}进行评分",
  "{value0} 小时 {value1} 分钟": "{value0} 小时 {value1} 分钟",
  "{value0} COE 看板": "{value0} COE 看板",
  " · {value0} 行": " · {value0} 行",
  "移除图片 {value0}": "移除图片 {value0}",
  "展开 {value0} 条评论": "展开 {value0} 条评论",
  "查看 {value0} 条原文已修改评论": "查看 {value0} 条原文已修改评论",
  "原文已修改评论 ({value0})": "原文已修改评论 ({value0})",
  "时间线第 {value0} 行": "时间线第 {value0} 行",
  "节点 {value0}": "节点 {value0}",
  "Todo 第 {value0} 行{value1}": "Todo 第 {value0} 行{value1}",
  "当前为 {value0} 分钟，按发生时间和恢复时间计算为 {value1} 分钟。": "当前为 {value0} 分钟，按发生时间和恢复时间计算为 {value1} 分钟。",
  "删除 {value0}？": "删除 {value0}？",
  "有 {value0} 条改进措施关联了该 Why，确认后将同时清空这些关联。": "有 {value0} 条改进措施关联了该 Why，确认后将同时清空这些关联。",
  "已自动暂存 {value0}": "已自动暂存 {value0}",
  "提交数据缺少：{value0}，已定位到第一处": "提交数据缺少：{value0}，已定位到第一处",
  "{value0}成功，保存期间还有新的修改，已保留在当前页面和本机备份中": "{value0}成功，保存期间还有新的修改，已保留在当前页面和本机备份中",
  "请完善必填项：{value0}，已为你定位": "请完善必填项：{value0}，已为你定位",
  "还有 {value0} 处必填或格式校验未通过，已定位到第一处：{value1}": "还有 {value0} 处必填或格式校验未通过，已定位到第一处：{value1}",
  "已延期 {value0} 天": "已延期 {value0} 天",
  "{value0}分钟": "{value0}分钟",
  "{value0}小时": "{value0}小时",
  "{value0}小时{value1}分钟": "{value0}小时{value1}分钟",
  "COE复盘名称：{value0}\n详情链接：{value1}": "COE复盘名称：{value0}\n详情链接：{value1}",
  "{value0}_告警记录": "{value0}_告警记录",
  "{value0}，拉群成功": "{value0}，拉群成功",
  "{value0}，拉群人数不足": "{value0}，拉群人数不足",
  "{value0}等": "{value0}等",
  "{value0} 不是一个视频文件": "{value0} 不是一个视频文件",
  "业务需求{value0}": "业务需求{value0}",
  "{value0}_验收报告": "{value0}_验收报告",
  "「{value0} 」已绑定Sprint，请解绑后后绑定新的Sprint": "「{value0} 」已绑定Sprint，请解绑后后绑定新的Sprint",
  "{value0} - {value1} (负责人: {value2})": "{value0} - {value1} (负责人: {value2})",
  "请输入{value0}相关内容": "请输入{value0}相关内容",
  "你有未保存的更改，确定要{value0}吗？": "你有未保存的更改，确定要{value0}吗？",
  "{value0}关联Bug记录": "{value0}关联Bug记录",
  "已加载 {value0} 条数据": "已加载 {value0} 条数据",
  "已加载 {value0}/{value1} 条数据": "已加载 {value0}/{value1} 条数据",
  "已加载全部 {value0} 条数据": "已加载全部 {value0} 条数据",
  "（{value0}结束）": "（{value0}结束）",
  "已选择{value0}个会议室：{value1}": "已选择{value0}个会议室：{value1}",
  "  \n            日期: {value0}<br/>  \n            存量: {value1}<br/>  \n            操作: {value2}<br/>  \n            期望: {value3}  \n          ": "  \n            日期: {value0}<br/>  \n            存量: {value1}<br/>  \n            操作: {value2}<br/>  \n            期望: {value3}  \n          ",
  "  \n            日期: {value0}<br/>  \n            期望: {value1}  \n          ": "  \n            日期: {value0}<br/>  \n            期望: {value1}  \n          ",
  " 共{value0}人": " 共{value0}人",
  "选择需求（{value0}）的目标状态": "选择需求（{value0}）的目标状态",
  "已经超期{value0}天": "已经超期{value0}天",
  "还有{value0}天到期": "还有{value0}天到期",
  "规划工时 {value0} 天": "规划工时 {value0} 天",
  "审批节点{value0}": "审批节点{value0}",
  "{value0} 时": "{value0} 时",
  "赠送记录_{value0}.csv": "赠送记录_{value0}.csv",
  "分发卡片-{value0}": "分发卡片-{value0}",
  "前{value0}": "前{value0}",
  "卡片配置-{value0}": "卡片配置-{value0}",
  "{value0} 年": "{value0} 年",
  "编辑版本 - {value0}{value1}": "编辑版本 - {value0}{value1}",
  "更新明细 {value0}": "更新明细 {value0}",
  "编辑{value0}的模版": "编辑{value0}的模版",
  "查看{value0}的模版": "查看{value0}的模版",
  "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div style=\"display:flex;align-items:center;margin:3px 0\">\n                <span style=\"display:inline-block;width:10px;height:10px;background:{value1};margin-right:5px;\"></span>\n                <strong>{value2}</strong>: {value3} 个 ({value4}%)\n              </div>\n              {value5}\n            ": "\n              <div style=\"font-weight:bold\">{value0}</div>\n              <div style=\"display:flex;align-items:center;margin:3px 0\">\n                <span style=\"display:inline-block;width:10px;height:10px;background:{value1};margin-right:5px;\"></span>\n                <strong>{value2}</strong>: {value3} 个 ({value4}%)\n              </div>\n              {value5}\n            ",
  "\n              <div style=\"margin-top:5px;font-weight:bold\">\n                总计: {value0} 个\n              </div>\n              ": "\n              <div style=\"margin-top:5px;font-weight:bold\">\n                总计: {value0} 个\n              </div>\n              ",
  "\n            <div style=\"font-weight:bold\">{value0} - {value1}</div>\n            <div>数量: {value2} 个</div>\n          ": "\n            <div style=\"font-weight:bold\">{value0} - {value1}</div>\n            <div>数量: {value2} 个</div>\n          ",
  "{value0}天": "{value0}天",
  "模型名称 {value0} 已复制到剪贴板": "模型名称 {value0} 已复制到剪贴板",
  "显示选定应用类型{value0}在指定时间范围内的配额使用量趋势，点击图表可查看详情": "显示选定应用类型{value0}在指定时间范围内的配额使用量趋势，点击图表可查看详情",
  "操作人：{value0}": "操作人：{value0}",
  "已催办当前审批节点未审批人：": "已催办当前审批节点未审批人：",
  "催办失败": "催办失败",
  "同意中...": "同意中...",
  "待我审批": "待我审批",
  "我发起且审批中": "我发起且审批中",
  "我发起且今日通过": "我发起且今日通过",
  "我发起且今日驳回": "我发起且今日驳回",
  "我发起且今日撤销": "我发起且今日撤销",
  "未知岗位": "未知岗位",
  "自动轮转（业务领域负责人）": "自动轮转（业务领域负责人）",
  "自动轮转": "自动轮转",
  "获取可赠送人员失败": "获取可赠送人员失败",
  "图片上传失败，请稍后重试": "图片上传失败，请稍后重试",
  "赠送失败，请稍后重试": "赠送失败，请稍后重试",
  "请点击选择会议室": "请点击选择会议室",
  "我是研发": "我是研发",
  "获取标签人员失败": "获取标签人员失败",
  "未命名需求": "未命名需求",
  "周报标题预览效果：": "周报标题预览效果：",
  "DevOps可直接执行，每次回滚都会记录操作日志。": "DevOps可直接执行，每次回滚都会记录操作日志。",
  "该审批在通过后24小时内可重复用于此版本，每次执行都会记录操作日志。": "该审批在通过后24小时内可重复用于此版本，每次执行都会记录操作日志。",
  "回滚申请已提交，审批通过后请再次点击该版本执行回滚": "回滚申请已提交，审批通过后请再次点击该版本执行回滚",
  "调试申请已提交": "调试申请已提交",
  "调试": "调试",
  "副本数变更申请已提交": "副本数变更申请已提交",
  "开始调试": "开始调试",
  "禁用成功": "禁用成功",
  "启用成功": "启用成功",
  "暂无匹配的泳道": "暂无匹配的泳道",
  "暂无泳道数据": "暂无泳道数据",
  "是否申请新加坡生产环境发布?": "是否申请新加坡生产环境发布?",
  "是否创建非生产环境发布?": "是否创建非生产环境发布?",
  "确定后会创建新加坡生产环境发布申请，发布需走审批流程，并会自动创建一个发布单（请先确保新加披uat已验证通过）": "确定后会创建新加坡生产环境发布申请，发布需走审批流程，并会自动创建一个发布单（请先确保新加披uat已验证通过）",
  "确定后会按服务顺序直接发布，并会根据发布载体类型创建或关联一个发布单": "确定后会按服务顺序直接发布，并会根据发布载体类型创建或关联一个发布单",
  "昨日": "昨日",
  "近7~14天": "近7~14天",
  "总反馈详情": "总反馈详情",
  "编辑反馈类型失败": "编辑反馈类型失败",
  "新增反馈类型失败": "新增反馈类型失败",
  "根节点": "根节点",
  "编辑失败": "编辑失败",
  "新增失败": "新增失败",
  "编辑配置失败": "编辑配置失败",
  "新增配置失败": "新增配置失败",
  "编辑FAQ失败": "编辑FAQ失败",
  "新增FAQ失败": "新增FAQ失败",
  "编辑敏感词失败": "编辑敏感词失败",
  "新增敏感词失败": "新增敏感词失败",
  "上架成功": "上架成功",
  "下架成功": "下架成功",
  "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 反馈详情链接：</span></strong></p><p></p>": "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 反馈详情链接：</span></strong></p><p></p>",
  "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 反馈内容：</span></strong></p><p></p>": "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 反馈内容：</span></strong></p><p></p>",
  "创建工单失败": "创建工单失败",
  "该工单不支持指派": "该工单不支持指派",
  "预算更新失败": "预算更新失败",
  "获取项目实际人天失败": "获取项目实际人天失败",
  "里程碑已更新": "里程碑已更新",
  "里程碑已新增": "里程碑已新增",
  "更新里程碑失败": "更新里程碑失败",
  "新增里程碑失败": "新增里程碑失败",
  "风险已更新": "风险已更新",
  "风险已新增": "风险已新增",
  "更新风险失败": "更新风险失败",
  "新增风险失败": "新增风险失败",
  "管理需求": "管理需求",
  "移出项目": "移出项目",
  "编辑时间": "编辑时间",
  "未命名里程碑": "未命名里程碑",
  "加载项目里程碑失败": "加载项目里程碑失败",
  "解决风险失败": "解决风险失败",
  "请完善项目基本信息、项目背景和项目团队信息": "请完善项目基本信息、项目背景和项目团队信息",
  "草稿保存失败": "草稿保存失败",
  "请完善必填信息": "请完善必填信息",
  "基础": "基础",
  "研发/周报": "研发/周报",
  "流程/其他": "流程/其他",
  "加载看板数据失败": "加载看板数据失败",
  "评分失败": "评分失败",
  "删除项目失败": "删除项目失败",
  "开始项目失败": "开始项目失败",
  "发起立项审批失败": "发起立项审批失败",
  "完成项目失败": "完成项目失败",
  "已收藏": "已收藏",
  "已取消收藏": "已取消收藏",
  "收藏操作失败": "收藏操作失败",
  "请选择是否与您沟通确认期待完成时间": "请选择是否与您沟通确认期待完成时间",
  "暂存成功": "暂存成功",
  "暂存失败": "暂存失败",
  "COE 复盘": "COE 复盘",
  "更新 COE 评论失败": "更新 COE 评论失败",
  "保存 COE 回复失败": "保存 COE 回复失败",
  "持续时长计算失败": "持续时长计算失败",
  "未填写故障名称，内容仅保存在本机": "未填写故障名称，内容仅保存在本机",
  "正在自动暂存…": "正在自动暂存…",
  "自动暂存失败，已保存在本机，联网后重试": "自动暂存失败，已保存在本机，联网后重试",
  "自动暂存失败，本机缓存空间不足，请手动暂存": "自动暂存失败，本机缓存空间不足，请手动暂存",
  "等待自动暂存…": "等待自动暂存…",
  "未保存修改已备份到本机": "未保存修改已备份到本机",
  "本机缓存空间不足，请尽快保存": "本机缓存空间不足，请尽快保存",
  "附件仍在上传，请等待上传完成后再关闭": "附件仍在上传，请等待上传完成后再关闭",
  "存在上传失败的附件，请删除或重新上传后再关闭": "存在上传失败的附件，请删除或重新上传后再关闭",
  "附件仍在上传，请等待上传完成后再保存": "附件仍在上传，请等待上传完成后再保存",
  "存在上传失败的附件，请删除或重新上传后再保存": "存在上传失败的附件，请删除或重新上传后再保存",
  "保存失败，内容仍保留在当前页面和本机缓存中": "保存失败，内容仍保留在当前页面和本机缓存中",
  "如：迭代上线": "如：迭代上线",
  "选择操作人员": "选择操作人员",
  "请输入备注，支持换行": "请输入备注，支持换行",
  "请输入根因总结，支持换行": "请输入根因总结，支持换行",
  "请输入说明，支持换行": "请输入说明，支持换行",
  "请填写任务内容": "请填写任务内容",
  "请输入任务内容，支持换行": "请输入任务内容，支持换行",
  "请选择交付时间": "请选择交付时间",
  "如：履约轨迹缺失": "如：履约轨迹缺失",
  "请选择故障责任组长": "请选择故障责任组长",
  "请选择故障责任人": "请选择故障责任人",
  "请选择复盘组织者": "请选择复盘组织者",
  "请选择复盘参与人": "请选择复盘参与人",
  "如：影响XX国家/XX业务线": "如：影响XX国家/XX业务线",
  "如：12单 / 3个客户": "如：12单 / 3个客户",
  "如：约2小时 / 10:00-12:00": "如：约2小时 / 10:00-12:00",
  "如：工单/群反馈/客服": "如：工单/群反馈/客服",
  "如：异常订单1200单，说明统计口径": "如：异常订单1200单，说明统计口径",
  "如：可追回，预计7月15日前完成": "如：可追回，预计7月15日前完成",
  "如：下游账务系统对账延迟": "如：下游账务系统对账延迟",
  "请选择用户/客户通知人": "请选择用户/客户通知人",
  "主值班": "主值班",
  "备值班": "备值班",
  "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 以下为线上问题引用内容：</span></strong></p><p></p>": "<p></p><p></p><p><strong><span style=\"color:#003ba5\">## 以下为线上问题引用内容：</span></strong></p><p></p>",
  "交接失败": "交接失败",
  "非需求对接人与已完成状态无法操作变更": "非需求对接人与已完成状态无法操作变更",
  "业务需求.xlsx": "业务需求.xlsx",
  "产品需求.xlsx": "产品需求.xlsx",
  "后端任务-": "后端任务-",
  "前端任务-": "前端任务-",
  "测试任务-": "测试任务-",
  "设计任务-": "设计任务-",
  "（提测申请）": "（提测申请）",
  "你有未保存的更改，确定要离开吗？": "你有未保存的更改，确定要离开吗？",
  "非需求产品经理无法操作变更": "非需求产品经理无法操作变更",
  "存在相同的服务，请自行Merge到一个分支后保存，服务分别是": "存在相同的服务，请自行Merge到一个分支后保存，服务分别是",
  "申请创建紧急发布单": "申请创建紧急发布单",
  "申请创建发布单": "申请创建发布单",
  "产品阶段": "产品阶段",
  "请选择评审类型": "请选择评审类型",
  "需求按缺陷数量排名（单位：个)": "需求按缺陷数量排名（单位：个)",
  "迭代需求燃尽图": "迭代需求燃尽图",
  "tips：需求状态流转维度": "tips：需求状态流转维度",
  "代码缺陷率（增量）排名（单位：％)": "代码缺陷率（增量）排名（单位：％)",
  "千行代码缺陷率（全量）排名（单位：‰)": "千行代码缺陷率（全量）排名（单位：‰)",
  "工时容量": "工时容量",
  "预估工时": "预估工时",
  "预估工时排名（单位：人天)": "预估工时排名（单位：人天)",
  "实际工时排名（单位：人天）": "实际工时排名（单位：人天）",
  "停用成功": "停用成功",
  "操作失败，请稍后重试": "操作失败，请稍后重试",
  "活动列表加载失败": "活动列表加载失败",
  "元数据加载失败，请稍后重试": "元数据加载失败，请稍后重试",
  "更新并发布成功": "更新并发布成功",
  "创建并发布成功": "创建并发布成功",
  "草稿保存成功": "草稿保存成功",
  "创建草稿成功": "创建草稿成功",
  "API Key总数": "API Key总数",
  "日新增": "日新增",
  "日请求数量": "日请求数量",
  "标签设置失败": "标签设置失败",
  "标签创建失败": "标签创建失败",
  "阶段": "阶段",
  "实时日志已连接...": "实时日志已连接...",
  "欢迎使用 Pod 调试功能，通过模拟终端的方式，方便快速进入容器进行调试。(注意：默认连接的 Shell 为 Bash)": "欢迎使用 Pod 调试功能，通过模拟终端的方式，方便快速进入容器进行调试。(注意：默认连接的 Shell 为 Bash)",
  "控制台": "控制台",
  "平均工时(小时)": "平均工时(小时)",
  "销售量": "销售量",
  "不满": "不满",
  "开始日期不能早于项目开始日期": "开始日期不能早于项目开始日期",
  "截止日期不能晚于项目截止日期": "截止日期不能晚于项目截止日期",
  "结束日期": "结束日期",
  "请选择开始日期": "请选择开始日期",
  "请选择预计完成时间": "请选择预计完成时间",
  "如：合并双链路代码": "如：合并双链路代码",
  "如：强制架构评审": "如：强制架构评审",
  "如：完善测试场景": "如：完善测试场景",
  "如：新增数据一致性校验告警": "如：新增数据一致性校验告警",
  "如：新增计税金额波动监控": "如：新增计税金额波动监控",
  "如：建立客户侧数据日报": "如：建立客户侧数据日报",
  "如：消息推送异常自动熔断": "如：消息推送异常自动熔断",
  "如：批量订正工具": "如：批量订正工具",
  "如：一键回滚机制": "如：一键回滚机制",
  "如：请求链路全量日志": "如：请求链路全量日志",
  "如：数据对比工具": "如：数据对比工具",
  "请等待附件上传完成": "请等待附件上传完成",
  "请删除上传失败的附件后重试": "请删除上传失败的附件后重试",
  "发现时间不能早于发生时间": "发现时间不能早于发生时间",
  "恢复时间不能早于发现时间": "恢复时间不能早于发现时间",
  "内部原因必须选择归属部门": "内部原因必须选择归属部门",
  "交付开始时间": "交付开始时间",
  "交付结束时间": "交付结束时间",
  "极差": "极差",
  "失望": "失望",
  "惊喜": "惊喜",
  "无标题": "无标题",
  "不限": "不限",
  "请选择提醒周期": "请选择提醒周期",
  "请选择提醒小时": "请选择提醒小时",
  "催办失败，请稍后重试": "催办失败，请稍后重试",
  "任务信息": "任务信息",
  "名称：": "名称：",
  "链接：": "链接：",
  "人员已失效（自动轮转）": "人员已失效（自动轮转）",
  "值班表名称：": "值班表名称：",
  "值班表链接：": "值班表链接：",
  "上传失败，未返回文件URL": "上传失败，未返回文件URL",
  "主播粉丝": "主播粉丝",
  "超跑礼物": "超跑礼物",
  "模板存量": "模板存量",
  "模板已解决": "模板已解决",
  "无数据": "无数据",
  "01月": "01月",
  "02月": "02月",
  "03月": "03月",
  "04月": "04月",
  "05月": "05月",
  "06月": "06月",
  "07月": "07月",
  "08月": "08月",
  "09月": "09月",
  "10月": "10月",
  "11月": "11月",
  "12月": "12月",
  "缺陷名称：": "缺陷名称：",
  "问题反馈人：": "问题反馈人：",
  "详情链接：": "详情链接：",
  "需求名称：": "需求名称：",
  "需求链接：": "需求链接：",
  "暂无会议": "暂无会议",
  "邀请你参加评审": "邀请你参加评审",
  "评审主题：": "评审主题：",
  "评审详情链接：": "评审详情链接：",
  "评审类型：": "评审类型：",
  "评审时间：": "评审时间：",
  "评审地点：": "评审地点：",
  "会议链接：": "会议链接：",
  "评审资料：": "评审资料：",
  "点击升序排列": "点击升序排列",
  "点击降序排列": "点击降序排列",
  "点击取消排序": "点击取消排序",
  "未分组": "未分组",
  "当前：按开始时间排序": "当前：按开始时间排序",
  "当前：按结束时间排序": "当前：按结束时间排序",
  "始": "始",
  "终": "终",
  "需求创建时间：": "需求创建时间：",
  "_%Y%W周报": "_%Y%W周报",
  "%N_%Y%W周报": "%N_%Y%W周报",
  "已配置项目周报模板": "已配置项目周报模板",
  "%N_%Y%W_%B%P周报": "%N_%Y%W_%B%P周报",
  "周报标题：": "周报标题：",
  "未知职位": "未知职位",
  "刚刚": "刚刚",
  "申请人同时为本节点审批人，系统已跳过": "申请人同时为本节点审批人，系统已跳过",
  "当前操作无需审批，可以立即执行": "当前操作无需审批，可以立即执行",
  "你同时是审批人，命中的审批节点已自动跳过，可以立即执行操作": "你同时是审批人，命中的审批节点已自动跳过，可以立即执行操作",
  "你同时是审批人，命中的审批节点已自动跳过，其余节点继续审批": "你同时是审批人，命中的审批节点已自动跳过，其余节点继续审批",
  "审批已通过，可以立即执行操作": "审批已通过，可以立即执行操作",
  "重复提交": "重复提交",
  "发布单名称：": "发布单名称：",
  "发布单类型：": "发布单类型：",
  "漏洞数": "漏洞数",
  "Bug数": "Bug数",
  "在职": "在职",
  "离职": "离职",
  "当前值": "当前值",
  "Canvas转换失败": "Canvas转换失败",
  "获取图片URL失败": "获取图片URL失败",
  "<Cell ss:StyleID=\"descLabel\"> <Data ss:Type=\"String\">指标释义</Data> </Cell>": "<Cell ss:StyleID=\"descLabel\"> <Data ss:Type=\"String\">指标释义</Data> </Cell>",
  "<Cell ss:StyleID=\"avgLabel\"> <Data ss:Type=\"String\">团队均值</Data> </Cell>": "<Cell ss:StyleID=\"avgLabel\"> <Data ss:Type=\"String\">团队均值</Data> </Cell>",
  "样本个数": "样本个数",
  "里程碑个数": "里程碑个数",
  "需求个数": "需求个数",
  "缺陷个数": "缺陷个数",
  "事故个数": "事故个数",
  "债务个数": "债务个数",
  "指标值": "指标值",
  "指标达成率": "指标达成率",
  "总计需求数": "总计需求数",
  "可以配置各国、各反馈来源中的App Tab页，如：首页、产品页、用户页、设置页等": "可以配置各国、各反馈来源中的App Tab页，如：首页、产品页、用户页、设置页等",
  "可以配置各国、各反馈来源中的常见问题解答，支持多语言配置": "可以配置各国、各反馈来源中的常见问题解答，支持多语言配置",
  "可可以配置各国、各反馈来源中的功能，如：是否支持上传视频等": "可可以配置各国、各反馈来源中的功能，如：是否支持上传视频等",
  "可以配置各国、各反馈来源中的反馈主次类型，如：产品问题、功能问题、性能问题、体验问题、其他问题等": "可以配置各国、各反馈来源中的反馈主次类型，如：产品问题、功能问题、性能问题、体验问题、其他问题等",
  "App Tab页管理": "App Tab页管理",
  "功能管理": "功能管理",
  "反馈类型管理": "反馈类型管理",
  "App Tab页": "App Tab页",
  "新增Tab页": "新增Tab页",
  "批量添加FAQ": "批量添加FAQ",
  "批量添加反馈类型": "批量添加反馈类型",
  "批量添加App Tab页": "批量添加App Tab页",
  "批量添加属性": "批量添加属性",
  "（已完成）": "（已完成）",
  "关键结果不能为空": "关键结果不能为空",
  "权重不能为空": "权重不能为空",
  "验收时间不能为空": "验收时间不能为空",
  "验收人不能为空": "验收人不能为空",
  "验收标准不能为空": "验收标准不能为空",
  "关联需求/迭代": "关联需求/迭代",
  "继续完成项目": "继续完成项目",
  "完成验收": "完成验收",
  "如果里程碑已经开始，需要变更里程碑信息，可联系 Zola 周华": "如果里程碑已经开始，需要变更里程碑信息，可联系 Zola 周华",
  "请至少添加一条项目关键里程碑": "请至少添加一条项目关键里程碑",
  "业务起草": "业务起草",
  "创建项目 - 业务起草": "创建项目 - 业务起草",
  "技术起草": "技术起草",
  "编辑项目": "编辑项目",
  "平均解决时长(天)": "平均解决时长(天)",
  "处理时长(天)": "处理时长(天)",
  "事故名称：": "事故名称：",
  "新增事故报告": "新增事故报告",
  "编辑事故报告": "编辑事故报告",
  "哪怕把CPU干冒烟、把内存条烧成灰、把我自己加载成地中海，也保证给您推送完！🚬🔥": "哪怕把CPU干冒烟、把内存条烧成灰、把我自己加载成地中海，也保证给您推送完！🚬🔥",
  "别急，页面正在和网速搏斗中🤼": "别急，页面正在和网速搏斗中🤼",
  "哪怕把服务器薅秃、把网线搓出火花、把我自己加载到发际线后移三厘米，也一定把您的邮箱页面完整送到！💻🦲": "哪怕把服务器薅秃、把网线搓出火花、把我自己加载到发际线后移三厘米，也一定把您的邮箱页面完整送到！💻🦲",
  "您放心，今天哪怕加班到头发掉光、咖啡喝到洗胃、服务器被我哄到崩溃重启，我也一定把您的邮件页面怼出来！☕🦲": "您放心，今天哪怕加班到头发掉光、咖啡喝到洗胃、服务器被我哄到崩溃重启，我也一定把您的邮件页面怼出来！☕🦲",
  "未定级": "未定级",
  "请选择统计时间范围": "请选择统计时间范围",
  "当前用户": "当前用户",
  "未命名附件": "未命名附件",
  "表单字段": "表单字段",
  "自动暂存失败": "自动暂存失败",
  "编辑执行人": "编辑执行人",
  "编辑关联需求": "编辑关联需求",
  "未延期": "未延期",
  "恢复时间不能早于发生时间": "恢复时间不能早于发生时间",
  "反馈人：": "反馈人：",
  "指派给：": "指派给：",
  "需求提出人：": "需求提出人：",
  "必填项未填写": "必填项未填写",
  "切换": "切换",
  "邀请你参加例会/评审": "邀请你参加例会/评审",
  "例会/评审主题：": "例会/评审主题：",
  "例会/评审详情链接：": "例会/评审详情链接：",
  "例会/评审类型：": "例会/评审类型：",
  "例会/评审时间：": "例会/评审时间：",
  "例会/评审地点：": "例会/评审地点：",
  "例会/会议链接：": "例会/会议链接：",
  "例会/评审资料：": "例会/评审资料：",
  "迭代名称：": "迭代名称：",
  "迭代负责人：": "迭代负责人：",
  "Sprint名称：": "Sprint名称：",
  "迭代数据不存在": "迭代数据不存在",
  "只有状态为\"未开始\"或\"进行中\"的迭代才能操作": "只有状态为\"未开始\"或\"进行中\"的迭代才能操作",
  "无法获取当前用户信息": "无法获取当前用户信息",
  "非迭代负责人无法操作": "非迭代负责人无法操作",
  "任务名称：": "任务名称：",
  "无作用域": "无作用域",
  "接收人ID": "接收人ID",
  "部门ID": "部门ID",
  "时间未知": "时间未知",
  "新建卡片": "新建卡片",
  "表一": "表一",
  "表二": "表二",
  "规则模板一": "规则模板一",
  "规则模板二": "规则模板二",
  "人员排名": "人员排名",
  "债务名称：": "债务名称：",
  "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif": "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif",
  "苹果苹方=PingFang SC,Microsoft YaHei,sans-serif": "苹果苹方=PingFang SC,Microsoft YaHei,sans-serif",
  "宋体=simsun,serif": "宋体=simsun,serif",
  "仿宋体=FangSong,serif": "仿宋体=FangSong,serif",
  "黑体=SimHei,sans-serif": "黑体=SimHei,sans-serif",
  "指标释义": "指标释义",
  "团队均值": "团队均值",
  "重开项": "重开项",
  "需求设计缺陷项": "需求设计缺陷项",
  "按系统审批流配置": "按系统审批流配置",
  "需求统计.xlsx": "需求统计.xlsx",
  "未设置时间": "未设置时间",
  "项目创建": "项目创建",
  "添加成员：李四": "添加成员：李四",
  "开始第一个Sprint": "开始第一个Sprint",
  "系统研发接口人": "系统研发接口人",
  "发布协同组": "发布协同组",
  "确认人": "确认人",
  "关闭人": "关闭人",
  "慢SQL模板记录.xlsx": "慢SQL模板记录.xlsx",
  "正在连接中": "正在连接中",
  "已经连接并且可以通讯": "已经连接并且可以通讯",
  "连接正在关闭": "连接正在关闭",
  "连接已关闭或者没有连接成功": "连接已关闭或者没有连接成功",
  "role.badge.product": "产",
  "role.badge.developer": "开",
  "role.badge.tester": "测",
  " ": " ",
  "pages.common.deleteConfirm": "确认删除",
  "pages.common.deleteConfirmDesc": "确定要删除任务「{name}」吗？",
  "pages.common.ok": "确定",
  "pages.common.cancel": "取消",
  "pages.common.deleteSuccess": "删除成功",
  "please.select.release.order": "请选择发布单",
  "pages.bug.responsiblePerson": "责任人",
  "pages.bug.joining": "请勿重复点击",
  "任务数": "任务数",
  "前端预计完成时间": "前端预计完成时间",
  "后端预计完成时间": "后端预计完成时间",
  "测试预计完成时间": "测试预计完成时间",
  "pages.system.form.selectUiDesign": "请选择 UI 设计",
  "pages.system.form.systemName": "请输入名称！",
  "pages.searchTable.updateForm.ruleConfig": "规则配置",
  "pages.searchTable.updateForm.basicConfig": "基本配置",
  "pages.searchTable.updateForm.ruleName.nameLabel": "规则名称",
  "pages.searchTable.updateForm.ruleName.nameRules": "请输入规则名称！",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "规则描述",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder": "请输入至少五个字符",
  "pages.searchTable.updateForm.ruleDesc.descRules": "请输入至少五个字符的规则描述！",
  "pages.searchTable.updateForm.ruleProps.title": "配置规则属性",
  "pages.searchTable.updateForm.object": "监控对象",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "规则模板",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "规则类型",
  "pages.searchTable.updateForm.schedulingPeriod.title": "设置调度周期",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "开始时间",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules": "请选择开始时间！",
  "pages.searchTable.titleDesc": "描述",
  "pages.searchTable.titleCallNo": "服务调用次数",
  "pages.searchTable.tenThousand": "万",
  "pages.searchTable.titleStatus": "状态",
  "pages.searchTable.nameStatus.default": "关闭",
  "pages.searchTable.nameStatus.running": "运行中",
  "pages.searchTable.nameStatus.online": "已上线",
  "pages.searchTable.nameStatus.abnormal": "异常",
  "pages.searchTable.titleUpdatedAt": "上次调度时间",
  "pages.searchTable.exception": "请输入异常原因！",
  "pages.searchTable.titleOption": "操作",
  "pages.searchTable.config": "配置",
  "pages.searchTable.subscribeAlert": "订阅告警",
  "pages.searchTable.title": "查询表格",
  "pages.searchTable.new": "新建",
  "pages.searchTable.chosen": "已选择",
  "pages.searchTable.item": "项",
  "pages.searchTable.totalServiceCalls": "服务调用总数",
  "pages.searchTable.batchDeletion": "批量删除",
  "pages.searchTable.batchApproval": "批量审批",
  "pages.searchTable.createForm.newRule": "新建规则",
  "pages.searchTable.ruleName": "规则名称为必填项",
  "pages.bug.feedbackUserCode": "反馈人",
  "pages.layouts.userLayout.title": "Ant Design 是西湖区最具影响力的 Web 设计规范",
  "pages.welcome.link": "欢迎使用",
  "pages.welcome.alertMessage": "更快更强的重型组件，已经发布。",
  "pages.admin.subPage.title": " 这个页面只有 admin 权限才能查看",
  "pages.admin.subPage.alertMessage": "umi ui 现已发布，欢迎使用 npm run ui 启动体验。",
  "pages.common.createDate": "创建时间",
  "pages.common.id": "序号",
  "pages.common.createUserName": "创建人",
  "pages.common.lastUpdDate": "更新时间",
  "pages.common.lastUpdUserName": "更新人",
  "pages.common.option": "操作",
  "pages.common.create": "新建",
  "pages.common.apply": "申请",
  "pages.common.edit": "编辑",
  "pages.common.delete": "删除",
  "pages.common.restore": "恢复",
  "pages.common.copy": "克隆",
  "pages.common.status": "状态",
  "pages.common.share": "分享",
  "pages.common.tag": "标签",
  "pages.common.productManagerName": "产品经理",
  "pages.common.uiDesignName": "UI设计",
  "pages.common.developName": "后端开发",
  "pages.common.frontWebName": "前端开发",
  "pages.common.testEngineerName": "测试开发",
  "pages.common.testName": "测试",
  "pages.common.itSupportName": "技术支持",
  "pages.common.businessCounterpartName": "业务方",
  "pages.common.form.selectProduct": "请选择产品经理",
  "pages.common.form.selectBusinessCounterpartName": "请选择业务方",
  "pages.common.form.selectUdDesign": "请选择UI设计",
  "pages.common.form.selectDev": "请选择后端开发",
  "pages.common.form.selectFont": "请选择前端开发",
  "pages.common.form.selectTest": "请选择测试开发",
  "pages.common.form.selectSupport": "请选择技术支持",
  "pages.common.startTime": "开始时间",
  "pages.common.endTime": "结束时间",
  "pages.common.colSetting": "列设置",
  "pages.common.closed": "归档",
  "pages.common.filter": "筛选",
  "pages.common.clear": "清除",
  "pages.common.notarize": "确认",
  "pages.common.addRemark": "添加备注",
  "pages.common.assign": "指派处理人",
  "pages.common.cardUnit": "张",
  "pages.business.businessNameCn": "业务领域(中)",
  "pages.business.businessNameEn": "业务领域(英)",
  "pages.business.systemId": "关联系统",
  "pages.business.title": "业务领域",
  "pages.system.updateForm.schedulingPeriod.timeLabel": "开始时间",
  "pages.system.updateForm.schedulingPeriod.timeRules": "请选择开始时间！",
  "pages.system.status": "启用状态",
  "pages.system.title": "系统",
  "pages.system.name": "系统名称",
  "pages.system.systemId": "系统ID（关联Jira的SystemId）",
  "pages.system.systemKey": "系统Key",
  "pages.system.ruleName": "系统名称为必填项",
  "pages.system.businessName": "业务领域",
  "pages.system.businessNameEn": "业务领域-英",
  "pages.system.leaderUserName": "系统负责人",
  "pages.system.businessLeaderUserName": "业务领域负责人",
  "pages.system.businessUserCount": "业务参与人数",
  "pages.system.systemDesc": "系统描述",
  "pages.system.exception": "请输入异常原因！",
  "pages.system.form.businessName": "所属业务领域",
  "pages.system.form.systemKey": "系统Key（唯一）",
  "pages.system.form.selectBusiness": "请选择业务领域",
  "pages.system.form.selectSystemLeader": "请选择系统负责人",
  "pages.system.form.inputSystemName": "请输入系统名称",
  "pages.system.form.inputSystemId": "请输入关联Jira系统ID",
  "pages.system.form.inputSystemKey": "请输入系统Key",
  "pages.system.form.robotId": "机器人ID",
  "pages.businessIssue.productManagerName": "产品对接人",
  "pages.businessIssue.productManagerName2": "对接人",
  "pages.businessIssue.businessSideInfo": "提出人",
  "pages.businessIssue.businessRelatedInfo": "相关人",
  "pages.businessIssue.pengingTime": "等待时长(天)",
  "pages.businessIssue.pengingTime2": "等待时长",
  "pages.businessIssue.expectDate": "期待完成时间",
  "pages.businessIssue.relatedIssues": "关联产品需求",
  "pages.businessIssue.relatedIssuesCount": "关联产品需求数量",
  "pages.businessIssue.createProductIssue": "创建产品需求",
  "pages.issuePool.issueId": "序列号",
  "pages.issuePool.issueName": "需求名称",
  "pages.issuePool.system": "所属系统",
  "pages.issuePool.relatedUser": "相关人(抄送人)",
  "pages.issuePool.complexRate": "复杂度",
  "pages.issuePool.sourceDesc": "需求来源",
  "pages.issuePool.country": "国家",
  "pages.issuePool.label": "标签",
  "pages.issuePool.priorityLevel": "优先级",
  "pages.issuePool.sprint": "所属Sprint",
  "pages.issuePool.expectDate": "期待完成时间",
  "pages.issuePool.completeDate": "实际完成时间",
  "pages.issuePool.expectDate2": "期待完成",
  "pages.issuePool.completeDate2": "实际完成",
  "pages.issuePool.reviewDate": "评审（会议）时间",
  "pages.issuePool.allReviewDate": "时间",
  "pages.issuePool.relatedIssues": "关联需求",
  "pages.issuePool.follower": "关注",
  "pages.issuePool.cancelFollower": "取消关注",
  "pages.issuePool.transfer": "转移系统",
  "pages.issuePool.planName": "规划名称",
  "pages.issuePool.allIssues": "全部需求",
  "pages.issuePool.currentSprint": "查看当前Sprint",
  "pages.issuePool.taskCnt": "任务数量",
  "pages.issuePool.release": "创建发布单",
  "pages.issuePool.isTechnical": "技术类需求",
  "pages.issuePool.isRequireTrainer": "需要系统培训",
  "pages.issuePool.addPlan": "需求绑定Sprint(默认展示需求所属系统的Sprint)",
  "pages.issuePool.follewUsers": "关注者",
  "pages.issuePool.taskTotalTime": "任务总耗时",
  "pages.issuePool.taskTime": "任务耗时",
  "pages.issuePool.form.selectIssueName": "请输入标题",
  "pages.issuePool.form.selectExpectDate": "请选择期待日期",
  "pages.issuePool.form.selectComplexRate": "请选择复杂度",
  "pages.issuePool.form.selectPriorityLevel": "请选择优先级",
  "pages.issuePool.form.estimatedPersonDay": "预估人天",
  "pages.issuePool.form.businessReviewName": "业务评审名称",
  "pages.issuePool.form.collaborativeIssue": "协同需求",
  "pages.issuePool.form.relatedSprint": "关联Sprint",
  "pages.issuePool.form.country": "需求影响国家",
  "pages.issuePool.form.isRequireTrainer": "是否需要系统培训",
  "pages.release.collaboratorList": "协同人",
  "pages.release.Date": "发布日期",
  "pages.issueReview.name": "评审（会议）名称",
  "pages.issueReview.allName": "名称",
  "pages.issueReview.createUserName": "发起人",
  "pages.issueReview.reviewUsers": "评审（会议）参与人",
  "pages.issueReview.status": "评审（会议）状态",
  "pages.issueReview.reviewType": "评审（会议）类型",
  "pages.issueReview.reviewReadCount": "确认情况",
  "pages.issueReview.reviewTime": "预估评审时间",
  "pages.issueReview.relatedIssueCount": "关联需求数",
  "pages.issueReview.meetingCount": "会议数",
  "pages.issueReview.meetingCode": "点击复制会议号",
  "pages.issueReview.createMeeting": "发起会议",
  "pages.issueReview.editMeeting": "编辑会议",
  "pages.issueReview.cancelMeeting": "取消会议",
  "pages.issueReview.cancelReview": "删除评审",
  "pages.issueReview.ReviewAgain": "重新评审",
  "pages.issueReview.reviewDesc": "评审（会议）描述",
  "pages.issueReview.form.meetingName": "评审会议名称",
  "pages.issueReview.form.allMeetingName": "会议名称",
  "pages.issueReview.form.meetingTime": "会议时长",
  "pages.issueReview.form.reviewMeetingDesc": "评审会议描述",
  "pages.issueReview.form.allReviewMeetingDesc": "会议描述",
  "pages.issueReview.form.plan": "规划",
  "pages.issueReview.form.issues": "需求",
  "pages.issueReview.form.reviewMeetingContent": "评审会议纪要",
  "pages.issueReview.issuePool.unReadCount": "未读人数",
  "pages.issueReview.issuePool.unReadUser": "未读人",
  "pages.issueReview.issuePool.readCount": "已读人数",
  "pages.issueReview.issuePool.readUser": "已读人",
  "pages.issueReview.meetingRemindBefores": "开始前提醒",
  "pages.sprint.name": "Sprint名称",
  "pages.sprint.owner": "负责人",
  "pages.sprint.goal": "Sprint(迭代)目标",
  "pages.sprint.issueCnt": "需求数量",
  "pages.sprint.cycle": "周期(GMT+8)",
  "pages.sprint.budget": "人天预算(Day)",
  "pages.sprint.isSynergy": "协同规划",
  "pages.sprint.plan": "Sprint规划",
  "pages.sprint.version": "版本号",
  "pages.sprint.createVersion": "创建迭代",
  "pages.sprint.form.time": "开始-结束",
  "pages.sprint.form.issues": "需求",
  "pages.sprint.add.issue": "添加需求",
  "pages.sprint.systemNames": "所属系统",
  "pages.task.id": "任务ID",
  "pages.task.name": "任务名称",
  "pages.task.type": "类型",
  "pages.task.complexRate": "复杂度",
  "pages.task.priorityLevel": "优先级",
  "pages.task.status": "状态",
  "pages.task.owner": "负责人",
  "pages.task.taskParticipants": "参与人",
  "pages.task.task": "任务详情列表",
  "pages.task.estimatedPersonDay": "预估人天",
  "pages.task.issues": "需求",
  "pages.task.serviceType": "服务类型",
  "pages.task.service": "服务",
  "pages.task.branch": "分支",
  "pages.task.overtime": "已逾期",
  "pages.task.form.time": "开始-结束",
  "pages.task.sprint": "迭代",
  "pages.test.caseName": "用例名称",
  "pages.test.systemName": "所属系统",
  "pages.test.issueName": "所属需求",
  "pages.test.moduleName": "所属模块",
  "pages.test.caseLevel": "用例级别",
  "pages.test.reviewStatusDesc": "评审状态",
  "pages.test.fileName": "文件名称",
  "pages.bug.title": "标题",
  "pages.bug.system": "所属系统",
  "pages.bug.issue": "所属需求",
  "pages.bug.severityLevel": "严重级别",
  "pages.bug.priorityLevel": "优先级",
  "pages.bug.implementationPlan": "执行方案",
  "pages.bug.bugType": "Bug类型",
  "pages.bug.proposer": "反馈人",
  "pages.bug.assignedUser": "指派给",
  "pages.bug.assignedDate": "指派时间",
  "pages.bug.relatedIssueInfos": "关联需求",
  "pages.bug.deadline": "截止时间",
  "pages.bug.relatedIssuesCount": "关联产品需求数量",
  "pages.bug.bugPageUrlsCnt": "Bug页面URL数\t",
  "pages.bug.responseTime": "响应耗时",
  "pages.bug.processingTime": "处理耗时",
  "pages.bug.waitingCloseTime": "等待关闭",
  "pages.bug.waitingTime": "总耗时",
  "pages.bug.carbonCopyUser": "抄送人",
  "pages.bug.operatingSystem": "操作系统",
  "pages.bug.resolvedUser": "解决者",
  "pages.bug.confirmedDate": "确认时间",
  "pages.bug.resolvedDate": "解决时间",
  "pages.bug.closedUser": "关闭者",
  "pages.bug.closedDate": "关闭时间",
  "pages.bug.confirm": "确认",
  "pages.bug.resolve": "解决",
  "pages.bug.reopen": "重开",
  "pages.bug.closed": "关闭",
  "pages.bug.reminder": "催办",
  "pages.bug.clone": "克隆",
  "pages.bug.join": "进群",
  "pages.codeQuality.title": "项目/服务",
  "pages.codeQuality.type": "类别",
  "pages.codeQuality.lines": "代码总行数",
  "pages.codeQuality.changeLines": "代码行数变化",
  "pages.codeQuality.addLines": "增量代码行数",
  "pages.codeQuality.allLines": "代码总行数",
  "pages.codeQuality.bugs": "缺陷数量",
  "pages.codeQuality.bugDensity": "千行代码缺陷率（‰）",
  "pages.codeQuality.addBugDensity": "增量代码缺陷率（％）",
  "pages.codeQuality.allBugDensity": "全量千行代码缺陷率（‰）",
  "pages.efficiencyDashboard.title": "需求交付概览",
  "pages.efficiencyDashboard.issueStatistics": "需求存量统计",
  "pages.efficiencyDashboard.stockCount": "总存量",
  "pages.efficiencyDashboard.pendingInterventionsCount": "待介入",
  "pages.efficiencyDashboard.suspendedCount": "已暂停",
  "pages.efficiencyDashboard.underSolutionCount": "方案中",
  "pages.efficiencyDashboard.toBeDevelopedCount": "待开发",
  "pages.efficiencyDashboard.underDevelopmentCount": "开发中",
  "pages.efficiencyDashboard.recentSevenDayDasboard": "近7天需求概览",
  "pages.efficiencyDashboard.newCount": "新增",
  "pages.efficiencyDashboard.closeCount": "关闭",
  "pages.efficiencyDashboard.totalReleaseCount": "总发布",
  "pages.efficiencyDashboard.normalReleaseCount": "正常发布",
  "pages.efficiencyDashboard.emergencyReleaseCount": "紧急发布",
  "pages.efficiencyDashboard.delayedUnpublishedCount": "延迟未发布",
  "pages.efficiencyDashboard.recentSevenDayQuality": "近7天需求质效",
  "pages.efficiencyDashboard.handledWaitTime": "需求等待时长（已处理） 单位: 小时",
  "pages.efficiencyDashboard.designTime": "需求设计时长（已处理） 单位: 小时",
  "pages.efficiencyDashboard.recentSevenDayOption": "近7天操作",
  "pages.efficiencyDashboard.changeCount": "状态变更次数",
  "pages.polarDB.log.id": "ID",
  "pages.polarDB.log.environment": "环境",
  "pages.polarDB.log.dbClusterId": "集群ID",
  "pages.polarDB.log.dbName": "数据库",
  "pages.polarDB.log.dbNodeId": "节点ID",
  "pages.polarDB.log.executionStartTime": "SQL执行时间（UTC）",
  "pages.polarDB.log.hostAddress": "客户端地址",
  "pages.polarDB.log.lockTimes": "SQL锁定时长（秒）",
  "pages.polarDB.log.queryTimes": "SQL执行时长（秒）",
  "pages.polarDB.log.parseRowCounts": "解析行数",
  "pages.polarDB.log.returnRowCounts": "返回行数",
  "pages.polarDB.log.sqlText": "查询语句",
  "pages.polarDB.log.dataTimestamp": "SQL执行时间戳",
  "pages.polarDB.log.sqlTemplateId": "SQL模板id",
  "pages.polarDB.tempalte.id": "模板id",
  "pages.polarDB.tempalte.environment": "环境",
  "pages.polarDB.tempalte.dbClusterId": "集群ID",
  "pages.polarDB.tempalte.dbName": "数据库",
  "pages.polarDB.tempalte.dbNodeId": "节点ID",
  "pages.polarDB.tempalte.hostAddress": "客户端地址",
  "pages.polarDB.tempalte.sqlText": "SQL模板",
  "pages.polarDB.tempalte.createDate": "拉取时间",
  "pages.polarDB.tempalte.lastUpdDate": "更新时间",
  "pages.polarDB.tempalte.lastUpdUserName": "更新人",
  "pages.polarDB.tempalte.overdueDays": "逾期天数",
  "pages.polarDB.tempalte.handlerInfo": "处理人",
  "pages.polarDB.tempalte.status": "是否处理",
  "pages.polarDB.tempalte.remark": "备注",
  "pages.db.subscribe.dbId": "数据库id",
  "pages.db.subscribe.dbName": "数据库",
  "pages.db.subscribe.dbLeader": "负责人",
  "is.subscribe": "是否订阅",
  "subscribers": "订阅人",
  "pages.db.subscribe.explain": "须知：订阅数据库后，第二天开始会通过应用推送订阅数据库昨日的慢sql模板数据！（无慢SQL,则不推送）",
  "edit.subscribers": "编辑订阅人",
  "pages.label.status": "启用状态",
  "pages.label.type": "标签类型",
  "pages.label.nameCn": "标签名称(中文)",
  "pages.label.nameEn": "标签名称(英文)",
  "pages.label.markingCnt": "打标数量",
  "pages.label.lastUpdDate": "更新时间",
  "pages.label.lastUpdUserName": "更新人",
  "pages.label.relationTypeName": "打标类型",
  "pages.label.relationName": "打标名称",
  "pages.label.createDate": "打标时间",
  "pages.label.createUserName": "打标人",
  "pages.delivery.id": "ID",
  "pages.delivery.releaseCarrierId": "发布单ID",
  "pages.delivery.releaseCarrierName": "发布单名称",
  "pages.delivery.releaseCarrierType": "发布单类型",
  "pages.delivery.collaboratorInfos": "协同人",
  "pages.delivery.otherInfo": "其它信息",
  "pages.delivery.isEmergency": "紧急发布",
  "pages.delivery.progress": "状态",
  "pages.delivery.progressDesc": "状态",
  "pages.delivery.appointmentDate": "预计发布时间",
  "pages.delivery.releaseDate": "实际发布时间",
  "pages.delivery.checkTermList": "检查项",
  "pages.delivery.issueSn": "需求序列号",
  "pages.delivery.taskCnt": "任务数量",
  "pages.delivery.issueUrl": "需求详情",
  "pages.delivery.serviceName": "服务名",
  "pages.delivery.serviceType": "服务类型",
  "pages.delivery.serviceStatus": "流水线状态",
  "pages.delivery.devOwnerNames": "开发Owner",
  "pages.delivery.developerNames": "开发者",
  "pages.delivery.businessName": "业务领域",
  "pages.delivery.serviceLevel": "服务级别",
  "pages.delivery.serviceNature": "服务属性",
  "pages.delivery.replicas": "容器副本",
  "pages.delivery.branch": "开发分支",
  "pages.delivery.releaseNum": "发布次数",
  "pages.delivery.emergencyReleaseNum": "紧急次数",
  "pages.delivery.updateBy": "最新操作人",
  "pages.delivery.updateTime": "最新操作时间",
  "start.up.today": "今日生产投产",
  "delivery.today": "今日交付",
  "publish.window": "发布窗口期",
  "service.publishing": "服务发布",
  "release.reason": "发布原因",
  "code.branch": "代码分支",
  "oneClick.publishing": "一键发布",
  "secondary.release": "二次发布",
  "noLpt.publishing": "非生产环境发布",
  "regression.completion": "回归完成",
  "acceptance.pass": "验收通过",
  "release.note": "发布说明",
  "requirement.acceptance.link": "需求验收链接",
  "release.history": "发布历史",
  "release.log": "发布日志",
  "service.log": "服务日志",
  "vulnerability.scanning": "漏洞扫描",
  "publish": "发布",
  "rollback": "回滚",
  "run.id": "运行ID",
  "branch": "分支",
  "commit.id": "提交ID",
  "run.time": "运行时间",
  "opt.time": "操作时间",
  "end.time": "结束时间",
  "op.user": "操作人",
  "finish.desc": "部署描述",
  "please.select.a.branch": "请选择分支",
  "commit.publish": "提交发布",
  "commit.scanner": "提交扫描",
  "error.log": "错误日志",
  "release.env": "发布环境",
  "product.requirements": "产品需求",
  "pull.carrier.branch": "拉取发布单分支",
  "refresh.branch": "刷新分支",
  "related.items": "关联项",
  "whether.to.schedule.a.meeting": "是否预约会议",
  "review.issue": "评审（会议）需求",
  "review.sprint": "评审（会议）Sprint",
  "review.test.case": "评审（会议）测试用例",
  "meeting.code": "会议号",
  "edit.review": "编辑评审",
  "edit.allReview": "编辑",
  "complete.review": "完成评审",
  "initiate.a.review.meeting": "预约评审会议",
  "initiate.a.allReview.meeting": "预约会议",
  "update.review.meeting": "变更评审会议",
  "update.review.allMeeting": "变更会议",
  "fill.in.the.review.minutes": "填写会议纪要",
  "cancel.review.meeting": "取消评审会议",
  "delete.review": "删除评审",
  "unconfirmed.person": "未确认人",
  "confirmed.person": "已确认人",
  "review.detail": "评审详情",
  "relation.name": "关联名称",
  "relation.type": "关联类型",
  "create.dashboard": "创建仪表盘",
  "pages.dashboard.kudoCard.description": "点亮星光，即刻赞美",
  "pages.dashboard.kudoCard.summary": "{nickname}，你收到了同事的星赞卡",
  "pages.dashboard.kudoCard.empty": "目前还没有同事赠送您星赞卡哦~",
  "pages.dashboard.kudoRank.rankingRule": "排名按累计星赞卡数量计算。",
  "pages.dashboard.kudoRank.title": "星赞卡排行榜 Top 20",
  "pages.dashboard.kudoRank.yourRank": "你的排名",
  "pages.dashboard.kudoRank.rankTime": "排行时间：",
  "pages.dashboard.kudoRank.noData": "暂无排行数据",
  "pages.dashboard.kudoRank.selectGroup": "请选择卡组",
  "pages.dashboard.receivedCards.title": "我收到的星赞卡",
  "pages.dashboard.receivedCards.description": "当期活动时间内你收到的卡片",
  "pages.dashboard.receivedCards.colleague": "同事",
  "pages.dashboard.receivedCards.cardName": "星赞卡",
  "pages.dashboard.receivedCards.filter": "筛选：",
  "pages.dashboard.receivedCards.noCards": "暂无星赞卡",
  "pages.dashboard.myCards.title": "我持有的星赞卡",
  "pages.dashboard.myCards.description": "当前活动时间内你拥有的卡片",
  "pages.dashboard.myCards.available": "可用",
  "pages.dashboard.myCards.status.pending": "待使用",
  "pages.dashboard.myCards.status.used": "已使用",
  "pages.dashboard.myCards.filter": "筛选：",
  "pages.dashboard.myCards.noCards": "暂无卡片",
  "instrument.name": "仪表盘名称",
  "card.logo": "卡片Logo",
  "card.name.cn": "卡片名称（中文）",
  "card.name.en": "卡片名称（英文）",
  "card.code": "卡片编码",
  "card.desc.cn": "卡片描述（中文）",
  "card.desc.en": "卡片描述（英文）",
  "card.type": "卡片类型",
  "edit.personal.instrument.card": "编辑个人仪表卡片",
  "card.list": "卡片列表",
  "to.do.name": "待办名称",
  "to.do.type": "待办类型",
  "to.do.status": "待办状态",
  "expected.end": "预计完成时间",
  "member.name": "成员名称",
  "edit.members": "编辑成员",
  "report.date": "汇报（年-周）",
  "weekly.report.title": "周报标题",
  "weekly.report.type": "周报类型",
  "weekly.report.title.template": "周报标题模板",
  "weekly.report.content.template": "周报内容模板",
  "report.to": "汇报对象",
  "report.by": "汇报人",
  "report.cc": "抄送人",
  "role": "角色",
  "push.time": "发送时间",
  "is.automatic.sending.enabled": "是否启用自动发送",
  "stage.name": "阶段名称",
  "quantity": "数量",
  "week.on.month.ratio": "与上周环比",
  "special.remark": "备注(回车保存)",
  "read.count": "阅读数",
  "add.comment": "发表评论",
  "comment.content": "评论内容",
  "chinese.name": "中文名称",
  "code": "编码",
  "status.type": "状态类型",
  "status.code": "状态编码",
  "english.name": "英文名称",
  "status.group": "状态组",
  "echo.color": "回显颜色",
  "transferable.status": "可流转状态",
  "sort": "排序",
  "clone.to.other.status.group": "克隆到其他状态组",
  "meeting.room.id": "会议室id",
  "meeting.room.name": "会议室名称",
  "meeting.room.capacity": "会议室容量",
  "city": "城市",
  "building": "建筑",
  "floor": "楼层",
  "meeting.room.equipment": "会议室设备",
  "sn": "序列号",
  "标题": "标题",
  "状态": "状态",
  "负责人": "负责人",
  "起始时间": "起始时间",
  "截止时间": "截止时间",
  "创建时间": "创建时间",
  "创建人": "创建人",
  "工作项类型": "工作项类型",
  "更新时间": "更新时间",
  "更新人名称": "更新人名称",
  "操作": "操作",
  "优先级": "优先级",
  "截止日期": "截止日期",
  "所属项目": "所属项目",
  "任务名称": "任务名称",
  "项目名称": "项目名称",
  "团队空间": "团队空间",
  "项目负责人": "项目负责人",
  "项目干系人": "项目干系人",
  "项目周期": "项目周期",
  "默认视图": "默认视图",
  "团队空间名称": "团队空间名称",
  "团队空间成员": "团队空间成员",
  "团队空间描述": "团队空间描述",
  "里程碑周期": "里程碑周期",
  "删除项目": "删除项目",
  "项目是否公开": "项目是否公开",
  "编辑": "编辑",
  "新建需求": "新建需求",
  "转产品需求": "转产品需求",
  "新建任务": "新建任务",
  "删除任务": "删除任务",
  "里程碑负责人": "里程碑负责人",
  "需求名称": "需求名称",
  "所属系统": "所属系统",
  "干系人": "干系人",
  "描述": "描述",
  "需求周期": "需求周期",
  "项目参与人": "项目参与人",
  "项目创建人": "项目创建人",
  "项目创建时间": "项目创建时间",
  "里程碑名称": "里程碑名称",
  "里程碑": "里程碑",
  "系统": "系统",
  "开始时间": "开始时间",
  "实际完成时间": "实际完成时间",
  "项目": "项目",
  "主产品经理": "主产品经理",
  "公开状态": "公开状态",
  "删除需求": "删除需求",
  "删除里程碑": "删除里程碑",
  "规划周期": "规划周期",
  "人天预算": "人天预算",
  "版本号": "版本号",
  "关联需求任务数": "关联需求任务数",
  "类型": "类型",
  "参与人": "参与人",
  "预估人天": "预估人天",
  "开始结束": "开始结束",
  "commit.cnt": "提交次数",
  "merge.cnt": "Merge次数",
  "push.cnt": "Push次数",
  "tag.cnt": "Tag次数",
  "merge.subscribe": "订阅Merge",
  "push.subscribe": "订阅Push",
  "merge.subscribers": "Merge订阅者",
  "push.subscribers": "Push订阅者",
  "warehouse.name": "仓库名",
  "related.sn": "关联序列号",
  "commit.email": "提交邮箱",
  "commit.url": "提交url",
  "commit.message": "提交描述",
  "commit.date": "提交时间",
  "commit.branch": "提交分支",
  "git.http.url": "Git仓库地址",
  "nick.name": "昵称",
  "attendance.date": "考勤日期",
  "attendance.type": "考勤类型",
  "attendance.start.address": "考勤开始地点",
  "attendance.end.address": "考勤结束地点",
  "attendance.start.source": "考勤开始来源",
  "attendance.end.source": "考勤结束来源",
  "attendance.start.result": "考勤开始结果",
  "attendance.end.result": "考勤结束结果",
  "department.name": "部门名称",
  "department.members": "部门成员",
  "location.city": "Base地",
  "personal.attendance.days": "个人出勤天数",
  "personal.total.working.hours": "个人总工时",
  "personal.average.working.hours": "个人平均工时",
  "department.attendance.person.day": "部门出勤人天",
  "department.total.working.hours": "部门总工时",
  "department.average.working.hours": "部门平均工时",
  "location.city.attendance.person.day": "Base地出勤人天",
  "location.city.total.working.hours": "Base地总工时",
  "location.city.average.working.hours": "Base地平均工时",
  "review.location": "评审（会议）地点",
  "review.allLocation": "地点",
  "review.count": "评审数量",
  "bug.count": "缺陷数量",
  "online.bug.count": "线上问题数量",
  "is.have.template": "周报模板",
  "dept.status": "部门状况",
  "total.commit.cnt": "提交总数",
  "requirment.commit.cnt": "需求提交数",
  "bug.commit.cnt": "缺陷提交数",
  "online.bug.commit.cnt": "线上问题提交数",
  "other.commit.cnt": "其他提交数",
  "standard.commit.rate": "规范提交率",
  "related.business": "关联业务领域",
  "related.system": "关联系统",
  "position": "岗位",
  "production.Defects.score": "生产缺陷分",
  "develop.defects.score": "研发缺陷分",
  "working.hours.score": "工时分",
  "average.score.of.production.and.research": "产研平均分",
  "individual.total.score": "个人总分",
  "technical.debt.score": "技术债务分",
  "delivery.efficiency.score": "交付效率分",
  "code.review.report": "CR报告",
  "status.stage.nameCn": "阶段名称（中文）",
  "status.stage.nameEn": "阶段名称（英文）",
  "status.stage.code": "阶段编码",
  "status.stage.echoColor": "回显颜色",
  "status.stage.sortNum": "排序编号",
  "description": "描述",
  "workflow": "工作流",
  "issue.type": "需求类型",
  "common.cancel": "取消",
  "common.ok": "确定",
  "common.confirm": "确认",
  "common.save": "保存",
  "common.submit": "提交",
  "common.back": "返回",
  "common.close": "关闭",
  "common.reset": "重置",
  "common.refresh": "刷新",
  "common.search": "搜索",
  "common.clear": "清空",
  "common.copy": "复制",
  "common.add": "添加",
  "common.viewDetails": "查看详情",
  "common.moreActions": "更多操作",
  "common.noData": "暂无数据",
  "common.loading": "加载中...",
  "common.pleaseSelect": "请选择",
  "common.pleaseEnter": "请输入",
  "common.yes": "是",
  "common.no": "否",
  "common.required": "必填",
  "common.success": "成功",
  "common.failed": "失败",
  "common.passed": "通过",
  "common.rejected": "不通过",
  "common.today": "今日",
  "common.thisWeek": "本周",
  "common.thisMonth": "本月",
  "common.thisYear": "本年",
  "common.all": "全部",
  "common.details": "详情",
  "common.reason": "原因",
  "common.remark": "备注",
  "common.label": "标签",
  "common.name": "名称",
  "common.type": "类型",
  "common.count": "数量",
  "common.time": "时间",
  "common.endTime": "结束时间",
  "common.owner": "责任人",
  "common.assignee": "处理人",
  "common.members": "成员",
  "common.people": "人员",
  "common.country": "国家",
  "common.countryTeam": "国家线",
  "common.industryTeam": "行业线",
  "common.serviceName": "服务名称",
  "common.serviceType": "服务类型",
  "common.branch": "分支",
  "common.task": "任务",
  "common.defect": "缺陷",
  "common.comments": "评论",
  "common.basicInfo": "基本信息",
  "common.fullScreen": "全屏",
  "common.exitFullScreen": "缩小",
  "common.expandAll": "全部展开",
  "common.collapseAll": "全部收起",
  "common.clickToCopy": "点击复制",
  "common.confirmDelete": "确认删除",
  "common.createdSuccessfully": "创建成功",
  "common.updatedSuccessfully": "更新成功",
  "common.modifiedSuccessfully": "修改成功",
  "common.savedSuccessfully": "保存成功",
  "common.addedSuccessfully": "添加成功",
  "common.deletedSuccessfully": "删除成功",
  "common.deleteFailed": "删除失败",
  "common.copyFailed": "复制失败",
  "common.uploadAttachment": "上传附件",
  "common.uploadFailed": "上传失败",
  "common.imageUploadFailed": "图片上传失败",
  "common.draft": "草稿",
  "common.completed": "已完成",
  "common.released": "已发布",
  "common.overdue": "已逾期",
  "common.hour": "小时",
  "common.day": "天",
  "common.item": "个",
  "common.total": "共",
  "0 天": "0 天",
  "请选择系统": "请选择系统",
  "指标名称": "指标名称",
  "指标说明": "指标说明",
  "需求主要归属": "需求主要归属",
  "关闭详情": "关闭详情",
  "支持小数": "支持小数",
  "缺陷类型": "缺陷类型",
  "图": "图",
  "表": "表",
  "请选择创建人": "请选择创建人",
  "是否删除": "是否删除",
  "请选择状态": "请选择状态",
  "实际工时（小时）": "实际工时（小时）",
  "图片上传错误，请重试！": "图片上传错误，请重试！",
  "请先设置开始结束时间和预估人天": "请先设置开始结束时间和预估人天",
  "请输入名称": "请输入名称",
  "计划上线日期": "计划上线日期",
  "时间范围": "时间范围",
  "请选择负责人": "请选择负责人",
  "链接内容": "链接内容",
  "回收站不可以进行该操作，请恢复后在操作！": "回收站不可以进行该操作，请恢复后在操作！",
  "实际工时": "实际工时",
  "确定要删除": "确定要删除",
  "吗？": "吗？",
  "测试人员": "测试人员",
  "上传文件不能超过5MB": "上传文件不能超过5MB",
  "需求名称和链接已剪贴板": "需求名称和链接已剪贴板",
  "填写实际工时": "填写实际工时",
  "请输入描述": "请输入描述",
  "发现时间": "发现时间",
  "上传文件不能超过10MB": "上传文件不能超过10MB",
  "上传文件不能超过20MB": "上传文件不能超过20MB",
  "已经是第一条了": "已经是第一条了",
  "已经是最后一条了": "已经是最后一条了",
  "条": "条",
  "查看明细": "查看明细",
  "请选择需求": "请选择需求",
  "请选择查询类型": "请选择查询类型",
  "查询": "查询",
  "表格视图": "表格视图",
  "需求设计缺陷率": "需求设计缺陷率",
  "产品评审驳回率": "产品评审驳回率",
  "代码提交规范率": "代码提交规范率",
  "紧急发布率": "紧急发布率",
  "未发布": "未发布",
  "确认要删除吗？": "确认要删除吗？",
  "部署环境": "部署环境",
  "操作成功": "操作成功",
  "写周报": "写周报",
  "点击添加评论": "点击添加评论",
  "取消点赞": "取消点赞",
  "添加点赞": "添加点赞",
  "点击分享周报": "点击分享周报",
  "年份": "年份",
  "至": "至",
  "回收站": "回收站",
  "审批单ID不能为空": "审批单ID不能为空",
  "基础信息": "基础信息",
  "服务分支信息": "服务分支信息",
  "同步数据": "同步数据",
  "关联需求名称": "关联需求名称",
  "总计": "总计",
  "缺陷逃逸率": "缺陷逃逸率",
  "缺陷漏检率": "缺陷漏检率",
  "发布成功率": "发布成功率",
  "执行人": "执行人",
  "复制失败:": "复制失败:",
  "事故序列": "事故序列",
  "严重程度": "严重程度",
  "指派人": "指派人",
  "存量": "存量",
  "说明": "说明",
  "数量变化（日）": "数量变化（日）",
  "这个指标的主要意义在于：": "这个指标的主要意义在于：",
  "质量控制：可以作为衡量软件质量变化的指标之一，帮助发现质量问题、进行质量改进。": "质量控制：可以作为衡量软件质量变化的指标之一，帮助发现质量问题、进行质量改进。",
  "上传附件：": "上传附件：",
  "复制成功": "复制成功",
  "提交失败:": "提交失败:",
  "配置": "配置",
  "编辑责任人": "编辑责任人",
  "请选择人员": "请选择人员",
  "设为默认": "设为默认",
  "发布时间": "发布时间",
  "状态变更": "状态变更",
  "只看我": "只看我",
  "已归档": "已归档",
  "全部记录": "全部记录",
  "双击开始编辑": "双击开始编辑",
  "请切换到ALL系统下进行筛选": "请切换到ALL系统下进行筛选",
  "请选择地域": "请选择地域",
  "最近更新时间": "最近更新时间",
  "同步结果": "同步结果",
  "请选择国家": "请选择国家",
  "解决耗时": "解决耗时",
  "关闭时长": "关闭时长",
  "重开率": "重开率",
  "降序": "降序",
  "升序": "升序",
  "分支名": "分支名",
  "点击复制序列号": "点击复制序列号",
  "已复制序列号": "已复制序列号",
  "事故等级": "事故等级",
  "债务类型": "债务类型",
  "关联服务": "关联服务",
  "指派": "指派",
  "存在未确认": "存在未确认",
  "全部已确认": "全部已确认",
  "评审吗？": "评审吗？",
  "请选择标签": "请选择标签",
  "计划联调日期": "计划联调日期",
  "回复": "回复",
  "完成目标": "完成目标",
  "风险类型": "风险类型",
  "风险原因": "风险原因",
  "预约发布": "预约发布",
  "请输入申请原因": "请输入申请原因",
  "创建时间:": "创建时间:",
  "请选择部门": "请选择部门",
  "分": "分",
  "人": "人",
  "风险": "风险",
  "附件": "附件",
  "请输入内容（拖动右下角可调整高度）": "请输入内容（拖动右下角可调整高度）",
  "无权限": "无权限",
  "故障名称": "故障名称",
  "评论不能为空": "评论不能为空",
  "评论成功": "评论成功",
  "请输入评论内容": "请输入评论内容",
  "活动日志": "活动日志",
  "只能在系统ALL下进行此条件筛选": "只能在系统ALL下进行此条件筛选",
  "设为默认后表格查询默认按该筛选条件查询": "设为默认后表格查询默认按该筛选条件查询",
  "只读权限": "只读权限",
  "一键创建任务": "一键创建任务",
  "请先勾选需求": "请先勾选需求",
  "目标值": "目标值",
  "pages.gray.userIdPlaceholder": "每行一个用户ID，或用逗号分隔\n例如:\nuser1\nuser2,user3\nuser4",
  "{count} 个团队": "{count} 个团队",
  "{count} 人": "{count} 人",
  "{count} 人 · {names}{ellipsis}": "{count} 人 · {names}{ellipsis}",
  "{count} 名成员": "{count} 名成员",
  "{count} 天": "{count} 天",
  "{metric} · 需求明细": "{metric} · 需求明细",
  "、": "、",
  "个": "个",
  "天": "天",
  "序列号": "序列号",
  "多团队研发效能对比": "多团队研发效能对比",
  "并列比较团队需求负载、当前流转状态、阶段耗时和大需求风险": "并列比较团队需求负载、当前流转状态、阶段耗时和大需求风险",
  "选择 1–5 个团队": "选择 1–5 个团队",
  "管理团队": "管理团队",
  "刷新": "刷新",
  "所选团队总览": "所选团队总览",
  "快速查看整体规模、流转效率与风险": "快速查看整体规模、流转效率与风险",
  "需求并集去重": "需求并集去重",
  "团队指标矩阵": "团队指标矩阵",
  "所有数值均可点击查看需求明细，点击列头可排序": "所有数值均可点击查看需求明细，点击列头可排序",
  "同一需求可能由多个团队共同参与，总览按需求去重，避免重复计数": "同一需求可能由多个团队共同参与，总览按需求去重，避免重复计数",
  "跨团队总览按需求去重": "跨团队总览按需求去重",
  "请选择团队查看数据": "请选择团队查看数据",
  "请先配置团队": "请先配置团队",
  "需求负载对比": "需求负载对比",
  "按团队查看总量与当前积压情况": "按团队查看总量与当前积压情况",
  "研发与测试耗时对比": "研发与测试耗时对比",
  "按对应阶段完成时间进入所选区间": "按对应阶段完成时间进入所选区间",
  "总数、构成、超10PD按需求创建时间；未完成/进行中为区间创建需求的当前状态；开发、测试、交付耗时分别按阶段完成时间进入区间。": "总数、构成、超10PD按需求创建时间；未完成/进行中为区间创建需求的当前状态；开发、测试、交付耗时分别按阶段完成时间进入区间。",
  "指标口径说明": "指标口径说明",
  "除“超 10PD 需求”外，团队范围均通过需求执行人关系判断；“超 10PD 需求”通过需求绑定任务和任务负责人判断。两种关联口径不能混用。": "除“超 10PD 需求”外，团队范围均通过需求执行人关系判断；“超 10PD 需求”通过需求绑定任务和任务负责人判断。两种关联口径不能混用。",
  "查看完整指标说明": "查看完整指标说明",
  "时间口径": "时间口径",
  "团队关联": "团队关联",
  "指标定义": "指标定义",
  "计算方式": "计算方式",
  "需求规模": "需求规模",
  "当前流转": "当前流转",
  "需求构成": "需求构成",
  "阶段效率": "阶段效率",
  "流转效率": "流转效率",
  "风险关注": "风险关注",
  "总需求数": "总需求数",
  "未完成需求": "未完成需求",
  "进行中需求": "进行中需求",
  "非技术需求": "非技术需求",
  "开发阶段平均耗时": "开发阶段平均耗时",
  "测试阶段平均耗时": "测试阶段平均耗时",
  "总交付平均耗时": "总交付平均耗时",
  "超 10PD 需求": "超 10PD 需求",
  "需求创建时间进入所选区间": "需求创建时间进入所选区间",
  "需求创建时间进入所选区间，状态取查询时的当前状态": "需求创建时间进入所选区间，状态取查询时的当前状态",
  "研发阶段完成时间进入所选区间": "研发阶段完成时间进入所选区间",
  "测试阶段完成时间进入所选区间": "测试阶段完成时间进入所选区间",
  "需求完成时间进入所选区间": "需求完成时间进入所选区间",
  "需求执行人关系中，执行人角色为研发、前端或测试，且执行人属于所选团队。": "需求执行人关系中，执行人角色为研发、前端或测试，且执行人属于所选团队。",
  "与总需求相同：通过需求执行人关系关联研发、前端或测试团队成员。": "与总需求相同：通过需求执行人关系关联研发、前端或测试团队成员。",
  "需求执行人关系中，研发、前端或测试执行人属于所选团队。": "需求执行人关系中，研发、前端或测试执行人属于所选团队。",
  "需求通过 ISSUE 类型任务绑定关系关联任务；只要任一有效绑定任务的负责人属于所选团队，该需求即进入团队范围。": "需求通过 ISSUE 类型任务绑定关系关联任务；只要任一有效绑定任务的负责人属于所选团队，该需求即进入团队范围。",
  "满足团队关联条件的产品需求总量。": "满足团队关联条件的产品需求总量。",
  "当前处于待介入、方案中、业务确认、已评审、需求排队或待开发的需求。": "当前处于待介入、方案中、业务确认、已评审、需求排队或待开发的需求。",
  "当前处于开发中、前端开发中、联调中、已提测或测试中的需求。": "当前处于开发中、前端开发中、联调中、已提测或测试中的需求。",
  "在产品需求中明确标记为技术需求的需求。": "在产品需求中明确标记为技术需求的需求。",
  "未标记为技术需求的其他产品需求。": "未标记为技术需求的其他产品需求。",
  "从产品阶段结束到研发阶段结束所经历的自然天数。": "从产品阶段结束到研发阶段结束所经历的自然天数。",
  "从研发阶段结束到测试阶段结束所经历的自然天数。": "从研发阶段结束到测试阶段结束所经历的自然天数。",
  "从产品阶段结束到需求完成所经历的自然天数。": "从产品阶段结束到需求完成所经历的自然天数。",
  "需求绑定的研发相关任务预估工时合计大于 10PD。": "需求绑定的研发相关任务预估工时合计大于 10PD。",
  "按需求 ID 去重计数；排除已删除、暂存和项目型需求。": "按需求 ID 去重计数；排除已删除、暂存和项目型需求。",
  "从总需求中按未完成状态集合筛选，并按需求 ID 去重计数。": "从总需求中按未完成状态集合筛选，并按需求 ID 去重计数。",
  "从总需求中按进行中状态集合筛选，并按需求 ID 去重计数。": "从总需求中按进行中状态集合筛选，并按需求 ID 去重计数。",
  "从总需求中筛选技术需求，并按需求 ID 去重计数。": "从总需求中筛选技术需求，并按需求 ID 去重计数。",
  "从总需求中筛选非技术需求，并按需求 ID 去重计数。": "从总需求中筛选非技术需求，并按需求 ID 去重计数。",
  "仅统计两个时间字段完整的需求，逐条计算天数后取算术平均值。": "仅统计两个时间字段完整的需求，逐条计算天数后取算术平均值。",
  "仅统计两个时间字段完整的已完成需求，逐条计算天数后取算术平均值。": "仅统计两个时间字段完整的已完成需求，逐条计算天数后取算术平均值。",
  "对进入团队范围的需求，汇总其全部有效后端、前端、无线开发及对应技术方案、需求调研任务的预估 PD；只累加大于0的工时，按需求分组后筛选合计值 > 10。": "对进入团队范围的需求，汇总其全部有效后端、前端、无线开发及对应技术方案、需求调研任务的预估 PD；只累加大于0的工时，按需求分组后筛选合计值 > 10。",
  "按需求 ID 去重 · 点击查看明细": "按需求 ID 去重 · 点击查看明细",
  "总需求": "总需求",
  "开发阶段": "开发阶段",
  "交付耗时": "交付耗时",
  "开发耗时": "开发耗时",
  "测试耗时": "测试耗时",
  "预估PD": "预估PD",
  "待介入": "待介入",
  "方案中": "方案中",
  "业务确认": "业务确认",
  "已评审": "已评审",
  "需求排队": "需求排队",
  "待开发": "待开发",
  "开发中": "开发中",
  "前端开发中": "前端开发中",
  "联调中": "联调中",
  "已提测": "已提测",
  "测试中": "测试中",
  "团队已保存": "团队已保存",
  "团队已删除": "团队已删除",
  "管理对比团队": "管理对比团队",
  "团队用于并列比较，同一成员可属于多个团队。": "团队用于并列比较，同一成员可属于多个团队。",
  "新增团队": "新增团队",
  "编辑团队": "编辑团队",
  "确认删除该团队？": "确认删除该团队？",
  "暂未配置团队": "暂未配置团队",
  "请输入团队名称": "请输入团队名称",
  "保存": "保存",
  "删除": "删除",
  "团队成员": "团队成员",
  "选择成员": "选择成员",
  "暂未选择成员，允许保存空团队": "暂未选择成员，允许保存空团队",
  "选择团队成员": "选择团队成员",
  "通过需求执行人关系关联团队；执行人角色限定为研发、前端或测试，执行人编码属于团队成员。": "通过需求执行人关系关联团队；执行人角色限定为研发、前端或测试，执行人编码属于团队成员。",
  "需求创建时间进入所选区间，并且产品、研发、测试阶段结束时间至少一项不为空": "需求创建时间进入所选区间，并且产品、研发、测试阶段结束时间至少一项不为空",
  "需求创建时间进入所选区间，并且需求完成时间、产品阶段结束时间均不为空": "需求创建时间进入所选区间，并且需求完成时间、产品阶段结束时间均不为空",
  "通过 ISSUE 类型任务绑定关系关联任务；至少一条预估工时大于0的有效绑定任务负责人属于团队成员。": "通过 ISSUE 类型任务绑定关系关联任务；至少一条预估工时大于0的有效绑定任务负责人属于团队成员。",
  "需求总量": "需求总量",
  "需求创建时间进入所选区间，并且业务编号不为空": "需求创建时间进入所选区间，并且业务编号不为空",
  "排除已删除、暂存和项目型需求后，按需求 ID 去重计数。": "排除已删除、暂存和项目型需求后，按需求 ID 去重计数。",
  "当前处于待介入、方案中、业务确认、已评审、需求排队或待开发状态的{type}需求。": "当前处于待介入、方案中、业务确认、已评审、需求排队或待开发状态的{type}需求。",
  "技术": "技术",
  "非技术": "非技术",
  "当前处于开发中、前端开发中、联调中、已提测或测试中状态的{type}需求。": "当前处于开发中、前端开发中、联调中、已提测或测试中状态的{type}需求。",
  "要求业务编号不为空，按状态集合和技术标记筛选后按需求 ID 去重计数。": "要求业务编号不为空，按状态集合和技术标记筛选后按需求 ID 去重计数。",
  "未完成技术需求数": "未完成技术需求数",
  "进行中技术需求数": "进行中技术需求数",
  "未完成非技术需求数": "未完成非技术需求数",
  "进行中非技术需求数": "进行中非技术需求数",
  "技术需求数": "技术需求数",
  "开发测试阶段": "开发测试阶段",
  "进入开发测试阶段样本的技术需求数量。": "进入开发测试阶段样本的技术需求数量。",
  "筛选 is_technical = 1 后按需求 ID 去重计数。": "筛选 is_technical = 1 后按需求 ID 去重计数。",
  "技术需求开发阶段平均耗时": "技术需求开发阶段平均耗时",
  "技术需求从产品阶段结束到研发阶段结束所经历的自然天数。": "技术需求从产品阶段结束到研发阶段结束所经历的自然天数。",
  "仅对两个时间字段完整的技术需求计算逐条耗时，再取算术平均值。": "仅对两个时间字段完整的技术需求计算逐条耗时，再取算术平均值。",
  "技术需求测试阶段平均耗时": "技术需求测试阶段平均耗时",
  "技术需求从研发阶段结束到测试阶段结束所经历的自然天数。": "技术需求从研发阶段结束到测试阶段结束所经历的自然天数。",
  "非技术需求数": "非技术需求数",
  "进入开发测试阶段样本的非技术需求数量。": "进入开发测试阶段样本的非技术需求数量。",
  "筛选 is_technical 不等于 1（含空值）后按需求 ID 去重计数。": "筛选 is_technical 不等于 1（含空值）后按需求 ID 去重计数。",
  "非技术需求开发阶段平均耗时": "非技术需求开发阶段平均耗时",
  "非技术需求从产品阶段结束到研发阶段结束所经历的自然天数。": "非技术需求从产品阶段结束到研发阶段结束所经历的自然天数。",
  "仅对两个时间字段完整的非技术需求计算逐条耗时，再取算术平均值。": "仅对两个时间字段完整的非技术需求计算逐条耗时，再取算术平均值。",
  "非技术需求测试阶段平均耗时": "非技术需求测试阶段平均耗时",
  "非技术需求从研发阶段结束到测试阶段结束所经历的自然天数。": "非技术需求从研发阶段结束到测试阶段结束所经历的自然天数。",
  "产品阶段结束到需求完成": "产品阶段结束到需求完成",
  "研发阶段结束到测试阶段结束": "研发阶段结束到测试阶段结束",
  "产品阶段结束到研发阶段结束": "产品阶段结束到研发阶段结束",
  "已交付需求": "已交付需求",
  "已交付技术需求数": "已交付技术需求数",
  "技术需求平均交付时长": "技术需求平均交付时长",
  "技术需求研发平均交付时长": "技术需求研发平均交付时长",
  "技术需求测试平均交付时长": "技术需求测试平均交付时长",
  "已交付非技术需求数": "已交付非技术需求数",
  "非技术需求平均交付时长": "非技术需求平均交付时长",
  "非技术需求研发平均交付时长": "非技术需求研发平均交付时长",
  "非技术需求测试平均交付时长": "非技术需求测试平均交付时长",
  "总研发需求平均交付时长": "总研发需求平均交付时长",
  "进入已交付样本的{type}需求数量。": "进入已交付样本的{type}需求数量。",
  "全部已交付需求从产品阶段结束到研发阶段结束所经历的自然天数。": "全部已交付需求从产品阶段结束到研发阶段结束所经历的自然天数。",
  "{type}需求从{interval}所经历的自然天数。": "{type}需求从{interval}所经历的自然天数。",
  "按技术标记筛选后按需求 ID 去重计数。": "按技术标记筛选后按需求 ID 去重计数。",
  "仅对计算区间两端时间完整的需求计算逐条耗时，再取算术平均值。": "仅对计算区间两端时间完整的需求计算逐条耗时，再取算术平均值。",
  "超 10PD 技术需求数": "超 10PD 技术需求数",
  "大需求风险": "大需求风险",
  "绑定的研发相关任务预估工时合计大于 10PD 的技术需求。": "绑定的研发相关任务预估工时合计大于 10PD 的技术需求。",
  "汇总全部有效后端、前端、无线开发及对应技术方案、需求调研任务中大于0的预估 PD，按需求分组筛选合计值 > 10。": "汇总全部有效后端、前端、无线开发及对应技术方案、需求调研任务中大于0的预估 PD，按需求分组筛选合计值 > 10。",
  "超 10PD 非技术需求数": "超 10PD 非技术需求数",
  "绑定的研发相关任务预估工时合计大于 10PD 的非技术需求。": "绑定的研发相关任务预估工时合计大于 10PD 的非技术需求。",
  "未完成技术": "未完成技术",
  "进行中技术": "进行中技术",
  "未完成非技术": "未完成非技术",
  "进行中非技术": "进行中非技术",
  "技术开发": "技术开发",
  "技术测试": "技术测试",
  "非技术开发": "非技术开发",
  "非技术测试": "非技术测试",
  "未开始与进行中需求对比": "未开始与进行中需求对比",
  "按技术、非技术需求拆分当前状态": "按技术、非技术需求拆分当前状态",
  "按需求创建时间进入区间，并按技术类型拆分": "按需求创建时间进入区间，并按技术类型拆分",
  "全部指标均按需求创建时间进入区间；状态指标另要求业务编号，阶段指标要求至少一个阶段时间，交付指标要求完成时间和产品阶段结束时间完整。": "全部指标均按需求创建时间进入区间；状态指标另要求业务编号，阶段指标要求至少一个阶段时间，交付指标要求完成时间和产品阶段结束时间完整。",
};
